{
  "admin.alertsScreen.waGroup.title": {
    "defaultMessage": "WhatsApp-Gruppe für Alarme"
  },
  "admin.dashboard.alertsBody": {
    "defaultMessage": "Überwachungsbenachrichtigungen konfigurieren"
  },
  "admin.dashboard.alertsBtnText": {
    "defaultMessage": "Alarme verwalten"
  },
  "admin.dashboard.alertsTitle": {
    "defaultMessage": "Alarme"
  },
  "admin.dashboard.btnLink": {
    "defaultMessage": "Einladungslink für Gruppe anfordern"
  },
  "admin.dashboard.contentAiBody": {
    "defaultMessage": "Content-AI-Konfiguration verwalten"
  },
  "admin.dashboard.contentAiBtnText": {
    "defaultMessage": "Konfigurieren"
  },
  "admin.dashboard.copyLink": {
    "defaultMessage": "Link-URL kopieren"
  },
  "admin.dashboard.coreAdministrationTitle": {
    "defaultMessage": "Kernverwaltung"
  },
  "admin.dashboard.featureConfigurationTitle": {
    "defaultMessage": "Funktionskonfiguration"
  },
  "admin.dashboard.fragments": {
    "defaultMessage": "Fragmente"
  },
  "admin.dashboard.fragmentsBody": {
    "defaultMessage": "Fragmentkonfiguration verwalten"
  },
  "admin.dashboard.fragmentsBtnText": {
    "defaultMessage": "Konfigurieren"
  },
  "admin.dashboard.groupsBtnText": {
    "defaultMessage": "Gruppen verwalten"
  },
  "admin.dashboard.socialIntegrationsTitle": {
    "defaultMessage": "Plattformintegration"
  },
  "admin.dashboard.stationsBody": {
    "defaultMessage": "Es gibt {count, plural, one {ist} other {sind} } {countBold} registrierte {count, plural, one {Sender} other {Sender} }"
  },
  "admin.dashboard.stationsBtnText": {
    "defaultMessage": "Sender verwalten"
  },
  "admin.dashboard.stationsTitle": {
    "defaultMessage": "Sender"
  },
  "admin.dashboard.title": {
    "defaultMessage": "Verwaltung"
  },
  "admin.dashboard.usersBody": {
    "defaultMessage": "Es gibt {count, plural, one {ist} other {sind} } {countBold} registrierte {count, plural, one {Benutzer} other {Benutzer} }"
  },
  "admin.dashboard.usersBtnText": {
    "defaultMessage": "Benutzer verwalten"
  },
  "admin.dashboard.usersTitle": {
    "defaultMessage": "Benutzer und Gruppen"
  },
  "admin.dashboard.videoAnalysisBody": {
    "defaultMessage": "Automatische Videoanalyse konfigurieren"
  },
  "admin.dashboard.videoAnalysisBtnText": {
    "defaultMessage": "Konfigurieren"
  },
  "admin.dashboard.videoAnalysisTitle": {
    "defaultMessage": "Videoanalyse"
  },
  "admin.dashboard.youtubeBtnText": {
    "defaultMessage": "Konfigurieren"
  },
  "admin.fragments.addNewFooter": {
    "defaultMessage": "Neue Fußzeile hinzufügen"
  },
  "admin.fragments.configUpdated": {
    "defaultMessage": "Fragmentkonfiguration für {stationName} aktualisiert"
  },
  "admin.fragments.footers": {
    "defaultMessage": "Fußzeilen in der Beschreibung"
  },
  "admin.fragments.fragmentsConfigUpdated": {
    "defaultMessage": "Fragmentkonfiguration für {stationName} aktualisiert"
  },
  "admin.fragments.newFooterName": {
    "defaultMessage": "Neue Fußzeile"
  },
  "admin.fragments.noFooters": {
    "defaultMessage": "Keine Fußzeilen registriert"
  },
  "admin.fragments.registeredFootersTitle": {
    "defaultMessage": "Registrierte Fußzeilen"
  },
  "admin.fragments.tagGroups": {
    "defaultMessage": "Tag-Gruppen"
  },
  "admin.fragments.title": {
    "defaultMessage": "Fragmente"
  },
  "admin.fragments.twoDefaultsNotAllowed": {
    "defaultMessage": "Es können nicht zwei Fußzeilen als Standard festgelegt werden"
  },
  "admin.fragments.useAsDefault": {
    "defaultMessage": "Als Standard verwenden"
  },
  "admin.fragments.watermark": {
    "defaultMessage": "Medien-Wasserzeichen"
  },
  "admin.fragments.watermark.active": {
    "defaultMessage": "Aktiv"
  },
  "admin.fragments.watermark.configTitle": {
    "defaultMessage": "Konfiguration"
  },
  "admin.fragments.watermark.imageTitle": {
    "defaultMessage": "Bild"
  },
  "admin.fragments.watermark.loadLabel": {
    "defaultMessage": "Wasserzeichen laden"
  },
  "admin.fragments.watermark.opacity": {
    "defaultMessage": "Deckkraft"
  },
  "admin.fragments.watermark.paddingX": {
    "defaultMessage": "Padding X"
  },
  "admin.fragments.watermark.paddingY": {
    "defaultMessage": "Padding Y"
  },
  "admin.fragments.watermark.positionBottom": {
    "defaultMessage": "Unten"
  },
  "admin.fragments.watermark.positionCenter": {
    "defaultMessage": "Mitte"
  },
  "admin.fragments.watermark.positionLeft": {
    "defaultMessage": "Links"
  },
  "admin.fragments.watermark.positionRight": {
    "defaultMessage": "Rechts"
  },
  "admin.fragments.watermark.positionTitle": {
    "defaultMessage": "Position"
  },
  "admin.fragments.watermark.positionTop": {
    "defaultMessage": "Oben"
  },
  "admin.fragments.watermark.positionX": {
    "defaultMessage": "Position X"
  },
  "admin.fragments.watermark.positionY": {
    "defaultMessage": "Position Y"
  },
  "admin.groups.addScreen.helpLinkText": {
    "defaultMessage": "Was ist eine Gruppe?"
  },
  "admin.groups.alertsScreen.title": {
    "defaultMessage": "Alarme"
  },
  "admin.groups.deleteScreen.btn": {
    "defaultMessage": "Gruppe löschen"
  },
  "admin.groups.deleteScreen.prompt": {
    "defaultMessage": "Möchten Sie die Gruppe <b>{name}</b> wirklich löschen? {br} Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "admin.groups.deleteScreen.title": {
    "defaultMessage": "Gruppe löschen"
  },
  "admin.groups.editScreen.title": {
    "defaultMessage": "Gruppe bearbeiten"
  },
  "admin.groups.filters.namePlaceholder": {
    "defaultMessage": "Nach Namen suchen"
  },
  "admin.groups.form.name.label": {
    "defaultMessage": "Name"
  },
  "admin.groups.form.name.placeholder": {
    "defaultMessage": "Zum Beispiel „Benutzer der Hauptsender“"
  },
  "admin.groups.form.users.help": {
    "defaultMessage": "<b>HINWEIS:</b> Benutzer können nur einer Gruppe angehören. Ausgewählte Benutzer, die bereits anderen Gruppen zugewiesen sind, werden überschrieben."
  },
  "admin.groups.form.users.label": {
    "defaultMessage": "Zugewiesene Benutzer"
  },
  "admin.groups.form.users.noMore": {
    "defaultMessage": "Keine weiteren verfügbaren Benutzer"
  },
  "admin.groups.help.assignGroup": {
    "defaultMessage": "Durch die Zuweisung einer Gruppe zu einem Benutzer erhält dieser Zugriff auf alle Sender, auf die die Gruppe Zugriff hat. Sie können die Berechtigungen jeder Gruppe unter <strong>Verwaltung > Sender > Gruppenberechtigungen</strong> verwalten."
  },
  "admin.groups.help.intro": {
    "defaultMessage": "<strong>Gruppen</strong> sind eine nützliche Methode, um Benutzer zu organisieren und den Zugriff und die Berechtigungen für Sender auf einfache Weise zu steuern."
  },
  "admin.groups.help.oneGroup": {
    "defaultMessage": "Ein Benutzer kann nur zu <strong>einer</strong> Gruppe gehören. Wenn Sie einem Benutzer über seine zugewiesene Gruppe hinaus Zugriff gewähren müssen, können Sie eine individuelle Berechtigung unter <strong>Verwaltung > Sender > Benutzerberechtigungen</strong> zuweisen."
  },
  "admin.groups.listScreen.links.createGroup": {
    "defaultMessage": "Gruppe erstellen"
  },
  "admin.groups.listScreen.noGroups": {
    "defaultMessage": "Keine Gruppen gefunden"
  },
  "admin.groups.listScreen.title": {
    "defaultMessage": "Gruppen verwalten"
  },
  "admin.groups.listScreen.usersCountHeader": {
    "defaultMessage": "# Benutzer"
  },
  "admin.groups.notifications.created": {
    "defaultMessage": "Gruppe erstellt"
  },
  "admin.groups.notifications.deleted": {
    "defaultMessage": "Gruppe gelöscht"
  },
  "admin.groups.notifications.updated": {
    "defaultMessage": "Gruppe aktualisiert"
  },
  "admin.groups.viewScreen.actionsPermissionsTab": {
    "defaultMessage": "Aktionsberechtigungen"
  },
  "admin.groups.viewScreen.assignedUsers.body": {
    "defaultMessage": "Diese Gruppe <b> {count, plural, =0 {hat keine} one {hat #} other {hat #} } </b> {count, plural, one {zugewiesenen Benutzer} other {zugewiesene Benutzer} }"
  },
  "admin.groups.viewScreen.assignedUsers.title": {
    "defaultMessage": "Zugewiesene Benutzer"
  },
  "admin.groups.viewScreen.basicInfoTab": {
    "defaultMessage": "Info"
  },
  "admin.groups.viewScreen.notDeletableHelp": {
    "defaultMessage": "Diese Gruppe kann nicht gelöscht werden, da sie zugewiesene Benutzer enthält"
  },
  "admin.groups.viewScreen.permissions.filterPlaceholder": {
    "defaultMessage": "Sender filtern"
  },
  "admin.groups.viewScreen.permissions.noFilterMatch": {
    "defaultMessage": "Keine passenden Sender gefunden"
  },
  "admin.groups.viewScreen.permissions.updateError": {
    "defaultMessage": "Berechtigung konnte nicht aktualisiert werden"
  },
  "admin.groups.viewScreen.stationsPermissionsTab": {
    "defaultMessage": "Senderberechtigungen"
  },
  "admin.integrations.accept": {
    "defaultMessage": "Akzeptieren"
  },
  "admin.integrations.cancel": {
    "defaultMessage": "Abbrechen"
  },
  "admin.integrations.warningContent": {
    "defaultMessage": "Sie sind im Begriff, diese Integration zu trennen. Sind Sie sicher?"
  },
  "admin.integrations.warningTitle": {
    "defaultMessage": "Achtung"
  },
  "admin.permissions.reset": {
    "defaultMessage": "Zurücksetzen"
  },
  "admin.permissions.resetPermissions": {
    "defaultMessage": "Berechtigungen zurücksetzen"
  },
  "admin.permissions.resetPermissionsPrompt": {
    "defaultMessage": "Sind Sie sicher, dass Sie alle Berechtigungen zurücksetzen möchten? Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "admin.permissionsLabel": {
    "defaultMessage": "Admin"
  },
  "admin.socialExport.body": {
    "defaultMessage": "Upload von Fragmenten zu {platformName} konfigurieren"
  },
  "admin.socialExport.title": {
    "defaultMessage": "Integration mit {name}"
  },
  "admin.stations.editScreen.title": {
    "defaultMessage": "Sender bearbeiten"
  },
  "admin.stations.filters.namePlaceholder": {
    "defaultMessage": "Nach Namen suchen"
  },
  "admin.stations.listScreen.title": {
    "defaultMessage": "Sender"
  },
  "admin.stations.viewScreen.basicInfo": {
    "defaultMessage": "Info"
  },
  "admin.stations.viewScreen.groups": {
    "defaultMessage": "Gruppen"
  },
  "admin.stations.viewScreen.groupsFilter": {
    "defaultMessage": "Gruppen filtern"
  },
  "admin.stations.viewScreen.groupsPermissions": {
    "defaultMessage": "Gruppenberechtigungen"
  },
  "admin.stations.viewScreen.logo": {
    "defaultMessage": "Logo"
  },
  "admin.stations.viewScreen.noGroups": {
    "defaultMessage": "Keine Gruppen gefunden"
  },
  "admin.stations.viewScreen.noGroupsFound": {
    "defaultMessage": "Keine passenden Gruppen gefunden"
  },
  "admin.stations.viewScreen.noUsersFound": {
    "defaultMessage": "Keine Benutzer gefunden"
  },
  "admin.stations.viewScreen.permissionInherited": {
    "defaultMessage": "Berechtigung geerbt von Gruppe {groupName}"
  },
  "admin.stations.viewScreen.permissionUpdateError": {
    "defaultMessage": "Berechtigung konnte nicht aktualisiert werden"
  },
  "admin.stations.viewScreen.userLinkText": {
    "defaultMessage": "Benutzerinfo anzeigen"
  },
  "admin.stations.viewScreen.usersFilter": {
    "defaultMessage": "Benutzer filtern"
  },
  "admin.stations.viewScreen.usersPermissions": {
    "defaultMessage": "Benutzerberechtigungen"
  },
  "admin.tagGroups.deleteGroupConfirm": {
    "defaultMessage": "Sind Sie sicher, dass Sie die Gruppe löschen möchten?"
  },
  "admin.tagGroups.deleteGroupTitle": {
    "defaultMessage": "Gruppe löschen"
  },
  "admin.tagGroups.newGroupName": {
    "defaultMessage": "Neue Gruppe"
  },
  "admin.sidebar.configuration": {
    "defaultMessage": "Features"
  },
  "admin.sidebar.groups": {
    "defaultMessage": "Gruppen"
  },
  "admin.sidebar.integrations": {
    "defaultMessage": "Plattformen"
  },
  "admin.sidebar.stationGroups": {
    "defaultMessage": "Sendergruppen"
  },
  "admin.stationGroups.breadcrumb": {
    "defaultMessage": "Sendergruppen"
  },
  "admin.stationGroups.filters.namePlaceholder": {
    "defaultMessage": "Nach Namen suchen"
  },
  "admin.stationGroups.listScreen.stationsCountHeader": {
    "defaultMessage": "# Sender"
  },
  "admin.stationGroups.listScreen.title": {
    "defaultMessage": "Sendergruppen"
  },
  "admin.stationGroups.viewScreen.accessType": {
    "defaultMessage": "Zugriff"
  },
  "admin.stationGroups.viewScreen.accessType.owned": {
    "defaultMessage": "Eigene"
  },
  "admin.stationGroups.viewScreen.accessType.shared": {
    "defaultMessage": "Geteilt"
  },
  "admin.stationGroups.viewScreen.noStations": {
    "defaultMessage": "Keine Sender in dieser Gruppe"
  },
  "admin.stationGroups.viewScreen.slug": {
    "defaultMessage": "Slug"
  },
  "admin.stationGroups.viewScreen.stations": {
    "defaultMessage": "Sender"
  },
  "admin.sidebar.organization": {
    "defaultMessage": "Organisation"
  },
  "admin.title": {
    "defaultMessage": "Admin"
  },
  "admin.users.addScreen.title": {
    "defaultMessage": "Benutzer erstellen"
  },
  "admin.users.deleteScreen.prompt": {
    "defaultMessage": "Möchten Sie den Benutzer <b>{email}</b> wirklich löschen? {br} Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "admin.users.deleteScreen.title": {
    "defaultMessage": "Benutzer löschen"
  },
  "admin.users.editScreen.title": {
    "defaultMessage": "Benutzer bearbeiten"
  },
  "admin.users.form.errors.errorUserExistsNotification": {
    "defaultMessage": "Benutzer existiert bereits"
  },
  "admin.users.form.group.label": {
    "defaultMessage": "Gruppe"
  },
  "admin.users.form.group.noGroup": {
    "defaultMessage": "Keine Gruppe"
  },
  "admin.users.form.name.label": {
    "defaultMessage": "Name"
  },
  "admin.users.filters.emailPlaceholder": {
    "defaultMessage": "Nach E-Mail suchen"
  },
  "admin.users.filters.namePlaceholder": {
    "defaultMessage": "Nach Namen suchen"
  },
  "admin.users.form.surname.label": {
    "defaultMessage": "Nachname"
  },
  "admin.users.lastLogin": {
    "defaultMessage": "Letzte Anmeldung"
  },
  "admin.users.listScreen.links.createUser": {
    "defaultMessage": "Benutzer erstellen"
  },
  "admin.users.listScreen.title": {
    "defaultMessage": "Benutzer verwalten"
  },
  "admin.users.loginMethod.SOCIAL_LOGIN.description": {
    "defaultMessage": "Der Benutzer verwendet sein bestehendes Google-Konto zur Anmeldung."
  },
  "admin.users.loginMethod.SOCIAL_LOGIN.label": {
    "defaultMessage": "Login mit Google"
  },
  "admin.users.loginMethod.USERNAME_PASSWORD.description": {
    "defaultMessage": "Der Benutzer erhält eine E-Mail mit Anweisungen zur Einrichtung seines Kontos"
  },
  "admin.users.loginMethod.USERNAME_PASSWORD.label": {
    "defaultMessage": "Benutzername und Passwort"
  },
  "admin.users.loginMethod.label": {
    "defaultMessage": "Anmeldemethode"
  },
  "admin.users.name": {
    "defaultMessage": "Name"
  },
  "admin.users.notifications.created": {
    "defaultMessage": "Benutzer erstellt"
  },
  "admin.users.notifications.deleted": {
    "defaultMessage": "Benutzer gelöscht"
  },
  "admin.users.notifications.updated": {
    "defaultMessage": "Benutzer aktualisiert"
  },
  "admin.users.role": {
    "defaultMessage": "Rolle"
  },
  "admin.users.roles.label": {
    "defaultMessage": "Benutzerrolle"
  },
  "admin.users.roles.values.CLIENT_ADMIN.description": {
    "defaultMessage": "Administrator des Kunden"
  },
  "admin.users.roles.values.CLIENT_ADMIN.label": {
    "defaultMessage": "Administrator"
  },
  "admin.users.roles.values.CLIENT_USER.description": {
    "defaultMessage": "Standardbenutzer des Kunden"
  },
  "admin.users.roles.values.CLIENT_USER.label": {
    "defaultMessage": "Standard"
  },
  "admin.users.roles.values.SUPERADMIN.description": {
    "defaultMessage": "Systemadministrator"
  },
  "admin.users.roles.values.SUPERADMIN.label": {
    "defaultMessage": "Superadministrator"
  },
  "admin.users.surname": {
    "defaultMessage": "Nachname"
  },
  "admin.users.title": {
    "defaultMessage": "Benutzer"
  },
  "admin.users.viewScreen.actionsPermissionsTab": {
    "defaultMessage": "Aktionsberechtigungen"
  },
  "admin.users.viewScreen.assignedGroup.noGroup": {
    "defaultMessage": "- Keine Gruppe -"
  },
  "admin.users.viewScreen.assignedGroup.title": {
    "defaultMessage": "Zugewiesene Gruppe"
  },
  "admin.users.viewScreen.basicInfoTab": {
    "defaultMessage": "Info"
  },
  "admin.users.viewScreen.fullName": {
    "defaultMessage": "Vollständiger Name"
  },
  "admin.users.viewScreen.permissions.clientAdminAllStationsAccess": {
    "defaultMessage": "Administratorbenutzer haben standardmäßig Zugriff auf alle Sender."
  },
  "admin.users.viewScreen.permissions.filterPlaceholder": {
    "defaultMessage": "Sender filtern"
  },
  "admin.users.viewScreen.permissions.noFilterMatch": {
    "defaultMessage": "Keine passenden Sender gefunden"
  },
  "admin.users.viewScreen.permissions.updateError": {
    "defaultMessage": "Berechtigung konnte nicht aktualisiert werden"
  },
  "admin.users.viewScreen.stationsPermissionsTab": {
    "defaultMessage": "Senderberechtigungen"
  },
  "admin.users.viewScreen.userRole": {
    "defaultMessage": "Benutzerrolle"
  },
  "admin.videoAnalysis.adOverlays.ignoredEntities": {
    "defaultMessage": "Ignorierte Entitäten"
  },
  "admin.videoAnalysis.adOverlays.notEnabledForStation": {
    "defaultMessage": "Ad Overlays für diesen Sender nicht aktiviert"
  },
  "admin.videoAnalysis.adOverlays.numericAllowlist": {
    "defaultMessage": "Numerische Whitelist"
  },
  "admin.videoAnalysis.adOverlays.title": {
    "defaultMessage": "Ad Overlays"
  },
  "admin.videoAnalysis.settingsUpdated": {
    "defaultMessage": "Einstellungen aktualisiert"
  },
  "assets.fileUploaded": {
    "defaultMessage": "Datei hochgeladen"
  },
  "assets.upload.error": {
    "defaultMessage": "Beim Hochladen der Datei ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
  },
  "assets.upload.errorFileSizeExceeded": {
    "defaultMessage": "Dateien dürfen {maxSizeMb}MB nicht überschreiten"
  },
  "assets.upload.label": {
    "defaultMessage": "Asset hochladen"
  },
  "assets.upload.maxSize": {
    "defaultMessage": "Max. {max}MB."
  },
  "assets.viewFile": {
    "defaultMessage": "Datei anzeigen"
  },
  "audit.adaptiveRun.noActions": {
    "defaultMessage": "Keine Aktionen"
  },
  "audit.adoverlayScreen.brand": {
    "defaultMessage": "Marke"
  },
  "audit.adoverlayScreen.duration": {
    "defaultMessage": "Dauer"
  },
  "audit.adoverlayScreen.image": {
    "defaultMessage": "Bild"
  },
  "audit.adoverlayScreen.loading": {
    "defaultMessage": "Ad-Overlays werden geladen"
  },
  "audit.adoverlayScreen.noResults": {
    "defaultMessage": "Keine Ad-Overlays gefunden"
  },
  "audit.aod.actions.acceptRun": {
    "defaultMessage": "Akzeptieren"
  },
  "audit.aod.actions.acceptRun.description": {
    "defaultMessage": "Berichtsergebnis akzeptieren und erneut ausführen, damit es exportiert wird"
  },
  "audit.aod.actions.acceptRun.reason": {
    "defaultMessage": "Grund (optional)"
  },
  "audit.aod.actions.acceptRun.reason.placeholder": {
    "defaultMessage": "Optionale Begründung für die Annahme dieser Ausführung eingeben"
  },
  "audit.aod.actions.downloadExport": {
    "defaultMessage": "Export herunterladen"
  },
  "audit.aod.actions.goToReport": {
    "defaultMessage": "Zum Bericht"
  },
  "audit.aod.actions.orderReprocess": {
    "defaultMessage": "Auftrag {orderId} neu verarbeiten"
  },
  "audit.aod.actions.orderReprocess.completed": {
    "defaultMessage": "Auftrag {orderId} neu verarbeitet"
  },
  "audit.aod.actions.orderReprocess.completed.multiple": {
    "defaultMessage": "Aufträge neu verarbeitet: {currentOrders}"
  },
  "audit.aod.actions.orderReprocess.confirm.button": {
    "defaultMessage": "Bestätigen"
  },
  "audit.aod.actions.orderReprocess.confirm.message": {
    "defaultMessage": "Sind Sie sicher, dass Sie die Neuverarbeitung des Auftrags {orderId} starten möchten?"
  },
  "audit.aod.actions.orderReprocess.confirm.message.withKey": {
    "defaultMessage": "Sind Sie sicher, dass Sie die Neuverarbeitung des Auftrags {orderId} starten möchten? (Key: {key})"
  },
  "audit.aod.actions.orderReprocess.confirm.title": {
    "defaultMessage": "Neuverarbeitung bestätigen"
  },
  "audit.aod.actions.orderReprocess.multiple": {
    "defaultMessage": "{count} Aufträge neu verarbeiten"
  },
  "audit.aod.actions.orderReprocess.processing": {
    "defaultMessage": "Auftrag {orderId} wird neu verarbeitet"
  },
  "audit.aod.actions.orderReprocess.processing.multiple": {
    "defaultMessage": "Aufträge {currentOrders} werden neu verarbeitet"
  },
  "audit.aod.actions.orderReprocess.reprocessedOn": {
    "defaultMessage": "Neu verarbeitet am {date, date, long} {date, time, short}"
  },
  "audit.aod.actions.orderReprocess.reprocessedOn.withKey": {
    "defaultMessage": "Neu verarbeitet am {date, date, long} {date, time, short} (Key: {key})"
  },
  "audit.aod.actions.refreshRun": {
    "defaultMessage": "Aktualisieren"
  },
  "audit.aod.actions.refreshRun.description": {
    "defaultMessage": "Ausführung mit bestehenden Ergebnissen erneut ausführen, ohne Exportbedingungen zu ändern"
  },
  "audit.aod.actions.refreshRun.description.missingMaterials": {
    "defaultMessage": "Nach dem Hochladen der fehlenden Materialien die Ausführung aktualisieren, um den Bericht neu zu bewerten."
  },
  "audit.aod.actions.restartRun": {
    "defaultMessage": "Ausführung neu starten"
  },
  "audit.aod.actions.restartRun.message": {
    "defaultMessage": "Sind Sie sicher, dass Sie diese Ausführung neu starten möchten? Der Bericht wird entfernt und die Verarbeitung erneut in die Warteschlange gestellt."
  },
  "audit.aod.actions.restartRun.title": {
    "defaultMessage": "Ausführung neu starten"
  },
  "audit.aod.actions.triggerReprocess": {
    "defaultMessage": "Neu verarbeiten"
  },
  "audit.aod.actions.triggerReprocess.completed": {
    "defaultMessage": "Neuverarbeitung abgeschlossen"
  },
  "audit.aod.actions.triggerReprocess.description": {
    "defaultMessage": "Auftragsneuverarbeitung starten und anschließend die Ausführung erneut ausführen"
  },
  "audit.aod.actions.triggerReprocess.error": {
    "defaultMessage": "Reprocessing konnte nicht gestartet werden"
  },
  "audit.aod.actions.triggerReprocess.error.missingMaterials": {
    "defaultMessage": "Reprocessing nicht möglich: Materialien fehlen. Audios hochladen und die Ausführung aktualisieren."
  },
  "audit.aod.actions.triggerReprocess.failed.message": {
    "defaultMessage": "Es gibt Probleme bei der Neuverarbeitung, die gelöst werden müssen:"
  },
  "audit.aod.actions.triggerReprocess.failed.missingSegments": {
    "defaultMessage": "Fehlende Segmente:"
  },
  "audit.aod.actions.triggerReprocess.failed.missingSpotMedia": {
    "defaultMessage": "Fehlende Spot-Medien:"
  },
  "audit.aod.actions.triggerReprocess.failed.title": {
    "defaultMessage": "Fehler bei Neuverarbeitung"
  },
  "audit.aod.actions.triggerReprocess.missingMaterials.description": {
    "defaultMessage": "Nicht gematchte Schedules haben keine verknüpften Spot-Medien. Materialien hochladen und die Ausführung aktualisieren; OLAF-Reprocessing hilft ohne Audio nicht."
  },
  "audit.aod.actions.triggerReprocess.missingMaterials.title": {
    "defaultMessage": "Reprocessing nicht verfügbar"
  },
  "audit.aod.actions.triggerReprocess.startedAt": {
    "defaultMessage": "Gestartet am"
  },
  "audit.aod.actions.triggerReprocess.waiting": {
    "defaultMessage": "Neuverarbeitung wartet auf Start"
  },
  "audit.aod.actions.viewResults": {
    "defaultMessage": "Ergebnisse anzeigen"
  },
  "audit.aod.basicInfo.invalidUserId": {
    "defaultMessage": "Ungültige Benutzer-ID"
  },
  "audit.aod.basicInfo.nameRequired": {
    "defaultMessage": "Name ist erforderlich"
  },
  "audit.aod.basicInfo.nameTooLong": {
    "defaultMessage": "Name ist zu lang"
  },
  "audit.aod.basicInfo.notificationPolicyRequired": {
    "defaultMessage": "Benachrichtigungsrichtlinie ist erforderlich"
  },
  "audit.aod.basicInfo.reportTypeRequired": {
    "defaultMessage": "Berichtstyp ist erforderlich"
  },
  "audit.aod.basicInfo.triggerRequired": {
    "defaultMessage": "Auslöser ist erforderlich"
  },
  "audit.aod.exportConditions.description": {
    "defaultMessage": "Beschreibung"
  },
  "audit.aod.exportConditions.description.placeholder": {
    "defaultMessage": "Optionale Beschreibung für diese manuelle Ausführung"
  },
  "audit.aod.exportConditions.enableEfficiency": {
    "defaultMessage": "Mindesteffizienz prüfen"
  },
  "audit.aod.exportConditions.minEfficiency": {
    "defaultMessage": "Mindesteffizienz"
  },
  "audit.aod.exportConditions.minEfficiency.help": {
    "defaultMessage": "Mindesteffizienz (0 bis 100 %)"
  },
  "audit.aod.exportConditions.minEfficiency.placeholder": {
    "defaultMessage": "0 - 100"
  },
  "audit.aod.gip.atLeastOneAdvertiser": {
    "defaultMessage": "Mindestens ein Werbetreibender muss ausgewählt werden"
  },
  "audit.aod.gip.export.packageStorageStrategy.PER_RULE": {
    "defaultMessage": "Pro Regel"
  },
  "audit.aod.gip.export.packageStorageStrategy.PER_RUN": {
    "defaultMessage": "Pro Ausführung"
  },
  "audit.aod.gip.export.packageStorageStrategyLabel": {
    "defaultMessage": "Paketspeicherung"
  },
  "audit.aod.gip.order": {
    "defaultMessage": "Auftrag"
  },
  "audit.aod.review.evidenceExportTitle": {
    "defaultMessage": "Beweisexport"
  },
  "audit.aod.review.exportConditionsTitle": {
    "defaultMessage": "Exportbedingungen"
  },
  "audit.aod.review.reportConfigTitle": {
    "defaultMessage": "Berichtskonfiguration"
  },
  "audit.aod.rules.active": {
    "defaultMessage": "Aktiv"
  },
  "audit.aod.rules.add": {
    "defaultMessage": "Regel erstellen"
  },
  "audit.aod.rules.add.reportType": {
    "defaultMessage": "Berichtstyp"
  },
  "audit.aod.rules.addScreen.title": {
    "defaultMessage": "AOD-Regel erstellen"
  },
  "audit.aod.rules.createdAt": {
    "defaultMessage": "Erstellt"
  },
  "audit.aod.rules.createdBy": {
    "defaultMessage": "by"
  },
  "audit.aod.rules.delete.message": {
    "defaultMessage": "Sind Sie sicher, dass Sie die Regel „{name}“ löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "audit.aod.rules.delete.title": {
    "defaultMessage": "AOD-Regel löschen"
  },
  "audit.aod.rules.edit.updateBtn": {
    "defaultMessage": "Regel aktualisieren"
  },
  "audit.aod.rules.editScreen.title": {
    "defaultMessage": "AOD-Regel bearbeiten"
  },
  "audit.aod.rules.field.active": {
    "defaultMessage": "Status"
  },
  "audit.aod.rules.field.createdAt": {
    "defaultMessage": "Erstellt"
  },
  "audit.aod.rules.field.name": {
    "defaultMessage": "Name"
  },
  "audit.aod.rules.field.reportType": {
    "defaultMessage": "Berichtstyp"
  },
  "audit.aod.rules.field.trigger": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.rules.managers": {
    "defaultMessage": "Verantwortliche"
  },
  "audit.aod.rules.managers.help": {
    "defaultMessage": "Wählen Sie die Benutzer, die für diese Regel verantwortlich sein werden"
  },
  "audit.aod.rules.managers.placeholder": {
    "defaultMessage": "Benutzer auswählen"
  },
  "audit.aod.rules.manualRun.exportConditions": {
    "defaultMessage": "Exportbedingungen"
  },
  "audit.aod.rules.manualRun.exportConditionsDescription": {
    "defaultMessage": "Ändern Sie die Exportbedingungen für diese manuelle Ausführung. Änderungen gelten nur für diese Ausführung."
  },
  "audit.aod.rules.manualRun.notifications.error": {
    "defaultMessage": "Fehler beim Starten der manuellen Ausführung"
  },
  "audit.aod.rules.manualRun.notifications.triggered": {
    "defaultMessage": "Manuelle Ausführung gestartet"
  },
  "audit.aod.rules.manualRun.submit": {
    "defaultMessage": "Manuelle Ausführung starten"
  },
  "audit.aod.rules.manualRunScreen.title": {
    "defaultMessage": "AOD-Regel manuell ausführen"
  },
  "audit.aod.rules.name": {
    "defaultMessage": "Name"
  },
  "audit.aod.rules.name.placeholder": {
    "defaultMessage": "Regelnamen eingeben"
  },
  "audit.aod.rules.notificationPolicy.ALWAYS": {
    "defaultMessage": "Immer (Wochenende und Bestellende)"
  },
  "audit.aod.rules.notificationPolicy.NONE": {
    "defaultMessage": "Keine Benachrichtigungen"
  },
  "audit.aod.rules.notificationPolicy.ORDER_END_ONLY": {
    "defaultMessage": "Nur Bestellende"
  },
  "audit.aod.rules.notificationPolicy.label": {
    "defaultMessage": "Benachrichtigungsrichtlinie"
  },
  "audit.aod.rules.notifications.createError": {
    "defaultMessage": "Fehler beim Erstellen der AOD-Regel."
  },
  "audit.aod.rules.notifications.created": {
    "defaultMessage": "AOD-Regel erstellt"
  },
  "audit.aod.rules.notifications.deleteError": {
    "defaultMessage": "Fehler beim Löschen der AOD-Regel"
  },
  "audit.aod.rules.notifications.deleted": {
    "defaultMessage": "AOD-Regel gelöscht"
  },
  "audit.aod.rules.notifications.updateError": {
    "defaultMessage": "Fehler beim Aktualisieren der AOD-Regel"
  },
  "audit.aod.rules.notifications.updated": {
    "defaultMessage": "AOD-Regel aktualisiert"
  },
  "audit.aod.rules.reportType": {
    "defaultMessage": "Berichtstyp"
  },
  "audit.aod.rules.review.basicInfo": {
    "defaultMessage": "Basisinformationen"
  },
  "audit.aod.rules.review.createBtn": {
    "defaultMessage": "Regel erstellen"
  },
  "audit.aod.rules.rule": {
    "defaultMessage": "Regel"
  },
  "audit.aod.rules.title": {
    "defaultMessage": "Regeln"
  },
  "audit.aod.rules.trigger": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.rules.trigger.EOW": {
    "defaultMessage": "Wochenabschluss"
  },
  "audit.aod.rules.trigger.EOW_AND_ORDER_END": {
    "defaultMessage": "Wochenabschluss + Auftragsende"
  },
  "audit.aod.rules.trigger.EOW_AND_ORDER_END_SHORT": {
    "defaultMessage": "Abschluss + Ende"
  },
  "audit.aod.rules.trigger.MANUAL": {
    "defaultMessage": "Manuell"
  },
  "audit.aod.rules.trigger.ORDER_END": {
    "defaultMessage": "Auftragsende"
  },
  "audit.aod.rules.view.runs.navigation.activeAndPast": {
    "defaultMessage": "Aktive/vergangene Ausführungen"
  },
  "audit.aod.rules.view.runs.navigation.future": {
    "defaultMessage": "Geplante Ausführungen"
  },
  "audit.aod.rules.view.runs.noFutureRuns": {
    "defaultMessage": "Keine geplanten Ausführungen für diese Regel."
  },
  "audit.aod.rules.view.runs.triggerManual": {
    "defaultMessage": "Manuell ausführen"
  },
  "audit.aod.rules.view.tabs.exportConditions": {
    "defaultMessage": "Exportbedingungen"
  },
  "audit.aod.rules.view.tabs.exportOptions": {
    "defaultMessage": "Exportoptionen"
  },
  "audit.aod.rules.view.tabs.info": {
    "defaultMessage": "Informationen"
  },
  "audit.aod.rules.view.tabs.reportConfig": {
    "defaultMessage": "Berichtskonfiguration"
  },
  "audit.aod.rules.view.tabs.runs": {
    "defaultMessage": "Ausführungen"
  },
  "audit.aod.rules.wizard.basicInfo": {
    "defaultMessage": "Basisinformationen"
  },
  "audit.aod.rules.wizard.exportConditions": {
    "defaultMessage": "Exportbedingungen"
  },
  "audit.aod.rules.wizard.exportOptions": {
    "defaultMessage": "Nachweis-Export"
  },
  "audit.aod.rules.wizard.reportConfig": {
    "defaultMessage": "Berichtskonfiguration"
  },
  "audit.aod.rules.wizard.review": {
    "defaultMessage": "Überprüfung"
  },
  "audit.aod.runs.actions.triggerRunCopy": {
    "defaultMessage": "Kopienausführung jetzt starten"
  },
  "audit.aod.runs.actions.triggerRunCopySuccess": {
    "defaultMessage": "Ausführung gestartet"
  },
  "audit.aod.runs.actions.viewRule": {
    "defaultMessage": "Zur Regel"
  },
  "audit.aod.runs.completionReason.LOW_EFFICIENCY": {
    "defaultMessage": "Niedrige Effizienz"
  },
  "audit.aod.runs.completionReason.MISSING_MATERIALS": {
    "defaultMessage": "Fehlende Materialien"
  },
  "audit.aod.runs.datetime": {
    "defaultMessage": "Ausgeführt"
  },
  "audit.aod.runs.field.actions": {
    "defaultMessage": "Aktionen"
  },
  "audit.aod.runs.field.completionComment": {
    "defaultMessage": "Kommentar"
  },
  "audit.aod.runs.field.completionReason": {
    "defaultMessage": "Grund"
  },
  "audit.aod.runs.field.deficiencyNotificationsSent": {
    "defaultMessage": "Mängelberichte gesendet"
  },
  "audit.aod.runs.field.deficiencyNotificationsUsers": {
    "defaultMessage": "Benachrichtigte Benutzer"
  },
  "audit.aod.runs.field.description": {
    "defaultMessage": "Beschreibung"
  },
  "audit.aod.runs.field.efficiency": {
    "defaultMessage": "Effizienz"
  },
  "audit.aod.runs.field.interval": {
    "defaultMessage": "Intervall"
  },
  "audit.aod.runs.field.minEfficiency": {
    "defaultMessage": "Erforderliche Mindesteffizienz"
  },
  "audit.aod.runs.field.order": {
    "defaultMessage": "Auftrag"
  },
  "audit.aod.runs.field.ruleName": {
    "defaultMessage": "Regel"
  },
  "audit.aod.runs.field.runAt": {
    "defaultMessage": "Ausgeführt am"
  },
  "audit.aod.runs.field.status": {
    "defaultMessage": "Status"
  },
  "audit.aod.runs.field.type": {
    "defaultMessage": "Typ"
  },
  "audit.aod.runs.interval": {
    "defaultMessage": "Intervall"
  },
  "audit.aod.runs.list.noScheduledRuns": {
    "defaultMessage": "Keine geplanten Ausführungen."
  },
  "audit.aod.runs.name": {
    "defaultMessage": "Name"
  },
  "audit.aod.runs.order": {
    "defaultMessage": "Auftrag"
  },
  "audit.aod.runs.reportType": {
    "defaultMessage": "Berichtstyp"
  },
  "audit.aod.runs.rule": {
    "defaultMessage": "Regel"
  },
  "audit.aod.runs.ruleName": {
    "defaultMessage": "Regel"
  },
  "audit.aod.runs.scheduledAt": {
    "defaultMessage": "Geplant"
  },
  "audit.aod.runs.status": {
    "defaultMessage": "Status"
  },
  "audit.aod.runs.status.completed_with_export": {
    "defaultMessage": "Ausgeführt mit Export"
  },
  "audit.aod.runs.status.completed_without_export": {
    "defaultMessage": "Ausgeführt ohne Export"
  },
  "audit.aod.runs.status.failed": {
    "defaultMessage": "Fehlgeschlagen"
  },
  "audit.aod.runs.status.in_progress": {
    "defaultMessage": "In Bearbeitung"
  },
  "audit.aod.runs.status.pending": {
    "defaultMessage": "Ausstehend"
  },
  "audit.aod.runs.status.waiting_for_reprocess": {
    "defaultMessage": "Wartet auf Neuverarbeitung"
  },
  "audit.aod.runs.title": {
    "defaultMessage": "Ausführungen"
  },
  "audit.aod.runs.type": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.runs.userAccepted.intro": {
    "defaultMessage": "Run manually accepted by user"
  },
  "audit.aod.runs.userAccepted.reason": {
    "defaultMessage": "Reason:"
  },
  "audit.aod.runs.userReprocess.intro": {
    "defaultMessage": "Manual reprocessing requested by user"
  },
  "audit.aod.runs.userReprocess.onDate": {
    "defaultMessage": "on"
  },
  "audit.aod.runs.userReprocess.unknownUser": {
    "defaultMessage": "unknown user"
  },
  "audit.aod.tabs.rules": {
    "defaultMessage": "AOD-Regeln"
  },
  "audit.aod.tabs.runsPast": {
    "defaultMessage": "Vergangene Ausführungen"
  },
  "audit.aod.tabs.runsScheduled": {
    "defaultMessage": "Geplante Ausführungen"
  },
  "audit.aod.title": {
    "defaultMessage": "AOD"
  },
  "audit.aod.titleLong": {
    "defaultMessage": "Automatische Auftragsauslieferung"
  },
  "audit.audiosScreen.customData.name": {
    "defaultMessage": "Name"
  },
  "audit.audiosScreen.customData.value": {
    "defaultMessage": "Wert"
  },
  "audit.audiosScreen.customDataTitle": {
    "defaultMessage": "Benutzerdefinierte Daten von {customId}"
  },
  "audit.audiosScreen.downloadBtn": {
    "defaultMessage": "Herunterladen"
  },
  "audit.audiosScreen.group": {
    "defaultMessage": "Gruppe"
  },
  "audit.audiosScreen.mediaTitle": {
    "defaultMessage": "Media"
  },
  "audit.audiosScreen.props.audioId": {
    "defaultMessage": "Audio-ID"
  },
  "audit.audiosScreen.props.date": {
    "defaultMessage": "Hochgeladen am"
  },
  "audit.audiosScreen.props.duration": {
    "defaultMessage": "Dauer"
  },
  "audit.audiosScreen.props.filename": {
    "defaultMessage": "Dateiname"
  },
  "audit.audiosScreen.showCustomData": {
    "defaultMessage": "Benutzerdefinierte Daten anzeigen"
  },
  "audit.audiosScreen.showTranscription": {
    "defaultMessage": "Transkription anzeigen"
  },
  "audit.audiosScreen.tabTitle": {
    "defaultMessage": "Media"
  },
  "audit.audiosScreen.title": {
    "defaultMessage": "Hochgeladene Audios"
  },
  "audit.audiosScreen.transcriptionTitle": {
    "defaultMessage": "Transkription für {customId}"
  },
  "audit.auditConfig.materials": {
    "defaultMessage": "Materialien"
  },
  "audit.bcr.label": {
    "defaultMessage": "BCR"
  },
  "audit.bcr.verifiedWithBcr": {
    "defaultMessage": "Mit BCR verifiziert"
  },
  "audit.bcrMatchesReport.emptyState.help": {
    "defaultMessage": "Vergleicht importierte BCR-Logs mit den System-Matches für den ausgewählten Tag. Hilft zu prüfen, welche Ausstrahlungen des externen Logs bestätigt wurden und welche nicht."
  },
  "audit.branding.headerBackgroundColor": {
    "defaultMessage": "Hintergrundfarbe der Kopfzeile"
  },
  "audit.broadcastEvidence.classification": {
    "defaultMessage": "Klassifikation"
  },
  "audit.broadcastEvidence.downloadPackage": {
    "defaultMessage": "Evidence herunterladen (ZIP)"
  },
  "audit.broadcastEvidence.downloadPending": {
    "defaultMessage": "Evidence-Paket nicht verfügbar"
  },
  "audit.broadcastEvidence.evidenceTitle": {
    "defaultMessage": "Evidenzen"
  },
  "audit.broadcastEvidence.jobStatus": {
    "defaultMessage": "Status"
  },
  "audit.broadcastEvidence.localDate": {
    "defaultMessage": "Datum"
  },
  "audit.broadcastEvidence.orderId": {
    "defaultMessage": "Auftrag"
  },
  "audit.broadcastEvidence.packageTitle": {
    "defaultMessage": "Evidence-Export"
  },
  "audit.broadcastEvidence.scheduledMaterial": {
    "defaultMessage": "Geplantes Material"
  },
  "audit.broadcastEvidence.station": {
    "defaultMessage": "Sender"
  },
  "audit.broadcastEvidence.summary.alternativeConfirmed": {
    "defaultMessage": "Bestätigt"
  },
  "audit.broadcastEvidence.summary.olafMatched": {
    "defaultMessage": "OLAF"
  },
  "audit.broadcastEvidence.summary.outsideTolerance": {
    "defaultMessage": "Außerhalb Toleranz"
  },
  "audit.broadcastEvidence.summary.scheduled": {
    "defaultMessage": "Geplant"
  },
  "audit.broadcastEvidence.summary.withinTolerance": {
    "defaultMessage": "In Toleranz"
  },
  "audit.broadcastEvidence.table.broadcastDatetime": {
    "defaultMessage": "Ausstrahlung"
  },
  "audit.broadcastEvidence.table.broadcastMaterialId": {
    "defaultMessage": "Gesendetes Material"
  },
  "audit.broadcastEvidence.table.methods": {
    "defaultMessage": "Methoden"
  },
  "audit.broadcastEvidence.table.observation": {
    "defaultMessage": "Beobachtung"
  },
  "audit.broadcastEvidence.table.scheduledMaterialId": {
    "defaultMessage": "Geplantes Material"
  },
  "audit.broadcastEvidence.table.status": {
    "defaultMessage": "Status"
  },
  "audit.broadcastEvidence.table.withinTolerance": {
    "defaultMessage": "Toleranz"
  },
  "audit.broadcastEvidence.withinTolerance.no": {
    "defaultMessage": "Nein"
  },
  "audit.broadcastEvidence.withinTolerance.yes": {
    "defaultMessage": "Ja"
  },
  "audit.column.moveToEnd": {
    "defaultMessage": "An das Ende verschieben"
  },
  "audit.column.moveToStart": {
    "defaultMessage": "An den Anfang verschieben"
  },
  "audit.configScreen.excludedCustomIds.hint": {
    "defaultMessage": "Liste benutzerdefinierter IDs (kommagetrennt), die von Prüfberichten ausgeschlossen werden"
  },
  "audit.configScreen.excludedCustomIds.label": {
    "defaultMessage": "Benutzerdefinierte IDs ausschließen"
  },
  "audit.configScreen.successMessage": {
    "defaultMessage": "Prüfkonfiguration aktualisiert"
  },
  "audit.configScreen.title": {
    "defaultMessage": "Prüfkonfiguration"
  },
  "audit.confirmedBySchedule.filterByOrder": {
    "defaultMessage": "Schedules der Order {order} anzeigen"
  },
  "audit.confirmedBySchedule.scheduleDatetime": {
    "defaultMessage": "Plan"
  },
  "audit.consecutiveSchedules.datetimeNext": {
    "defaultMessage": "Nächstes Datum und Uhrzeit"
  },
  "audit.consecutiveSchedules.title": {
    "defaultMessage": "Aufeinanderfolgende Zeitpläne"
  },
  "audit.controls.markers": {
    "defaultMessage": "Markierungen"
  },
  "audit.diarization.processing": {
    "defaultMessage": "Transkription wird verarbeitet"
  },
  "audit.diarization.speaker": {
    "defaultMessage": "Speaker"
  },
  "audit.diarization.speakerEditor": {
    "defaultMessage": "Sprecherbezeichnung"
  },
  "audit.equalMd5Report.customIds": {
    "defaultMessage": "Benutzerdefinierte IDs"
  },
  "audit.equalMd5Report.emptyState.help": {
    "defaultMessage": "Listet Mediendateien auf, die denselben MD5-Hash teilen (also identischen Dateiinhalt), aber unter verschiedenen Material-IDs registriert sind. Nützlich zum Erkennen und Bereinigen doppelter Medien."
  },
  "audit.equalMd5Report.md5": {
    "defaultMessage": "MD5"
  },
  "audit.filesUpload.audioIdLabel": {
    "defaultMessage": "Audio-ID:"
  },
  "audit.filesUpload.avgEntries": {
    "defaultMessage": "AVG entries ({count})"
  },
  "audit.filesUpload.bcrEntries": {
    "defaultMessage": "BCR entries ({count})"
  },
  "audit.filesUpload.bulkEntriesCount": {
    "defaultMessage": "Anzahl der Einträge: {count}"
  },
  "audit.filesUpload.bulkFileIds": {
    "defaultMessage": "Datei-IDs: {ids}"
  },
  "audit.filesUpload.entriesFoundToLoad": {
    "defaultMessage": "Es wurden {n} {type}-Einträge zum Laden gefunden. Bestätigen Sie die Ladung oder brechen Sie ab, um zurückzugehen."
  },
  "audit.filesUpload.fileLabel": {
    "defaultMessage": "File:"
  },
  "audit.filesUpload.filesLabel": {
    "defaultMessage": "Dateien:"
  },
  "audit.filesUpload.links.adAudios": {
    "defaultMessage": "Spot-Medien"
  },
  "audit.filesUpload.links.adSchedulesAsc": {
    "defaultMessage": "Spot-Pläne (ASC)"
  },
  "audit.filesUpload.links.adSchedulesPlk": {
    "defaultMessage": "Spot-Pläne (PLK)"
  },
  "audit.filesUpload.links.avgUpload": {
    "defaultMessage": "AVG hochladen"
  },
  "audit.filesUpload.links.bcrUpload": {
    "defaultMessage": "BCR hochladen"
  },
  "audit.filesUpload.links.liveMentionSchedulesCsv": {
    "defaultMessage": "Erwähnungspläne (CSV)"
  },
  "audit.filesUpload.links.ltxUpload": {
    "defaultMessage": "LTX hochladen"
  },
  "audit.filesUpload.ltxEntries": {
    "defaultMessage": "LTX entries ({count})"
  },
  "audit.filesUpload.materialId": {
    "defaultMessage": "Material-ID"
  },
  "audit.filesUpload.selectFileLabel": {
    "defaultMessage": "Archiv/e auswählen .{type}"
  },
  "audit.filesUpload.selectFileType": {
    "defaultMessage": "Select a file type from the side menu"
  },
  "audit.filesUpload.uploadError": {
    "defaultMessage": "An error occurred while uploading the file:"
  },
  "audit.filesUpload.uploadFile": {
    "defaultMessage": "Laden bestätigen"
  },
  "audit.filesUpload.uploadFiles": {
    "defaultMessage": "Laden bestätigen"
  },
  "audit.filesUpload.uploadSuccess": {
    "defaultMessage": "File uploaded successfully"
  },
  "audit.filesUpload.uploadSuccessMultiple": {
    "defaultMessage": "Dateien erfolgreich hochgeladen"
  },
  "audit.filesUpload.uploading": {
    "defaultMessage": "Wird hochgeladen..."
  },
  "audit.filesUpload.validateAvg": {
    "defaultMessage": "Eine oder mehrere Dateien .AVG auswählen"
  },
  "audit.filesUpload.validateBcr": {
    "defaultMessage": "Eine oder mehrere Dateien .BCR auswählen"
  },
  "audit.filesUpload.validateError": {
    "defaultMessage": "Beim Validieren der Datei ist ein Fehler aufgetreten:"
  },
  "audit.filesUpload.validateLtx": {
    "defaultMessage": "Eine oder mehrere Dateien .LTX auswählen"
  },
  "audit.gip.exportConditions.enableEfficiency": {
    "defaultMessage": "Mindesteffizienz prüfen"
  },
  "audit.gip.exportConditions.minEfficiency": {
    "defaultMessage": "Mindesteffizienz"
  },
  "audit.gip.report.efficiency": {
    "defaultMessage": "Effizienz"
  },
  "audit.gip.report.efficiencyHelp": {
    "defaultMessage": "Prozentsatz der verarbeiteten Schedules mit bestätigtem Match."
  },
  "audit.gip.report.missingMaterials": {
    "defaultMessage": "Fehlende Materialien"
  },
  "audit.gip.report.missingMaterialsHelp": {
    "defaultMessage": "Anzahl der von Schedules referenzierten Materialien, die noch nicht hochgeladen wurden."
  },
  "audit.gip.report.pending": {
    "defaultMessage": "Ausstehend"
  },
  "audit.gip.report.results": {
    "defaultMessage": "Ergebnisse"
  },
  "audit.gip.report.scheduleProgress": {
    "defaultMessage": "Schedule-Fortschritt"
  },
  "audit.gip.report.scheduleProgressHelp": {
    "defaultMessage": "Prozentsatz der bereits verarbeiteten Schedules am Gesamtwert. Ausstehende und zukünftige Schedules gelten noch nicht als verarbeitet."
  },
  "audit.gip.report.summary": {
    "defaultMessage": "Zusammenfassung"
  },
  "audit.gip.report.totalSchedules": {
    "defaultMessage": "Schedules gesamt"
  },
  "audit.gip.report.withMatch": {
    "defaultMessage": "Mit Match"
  },
  "audit.gip.report.withoutMatch": {
    "defaultMessage": "Ohne Match"
  },
  "audit.gipReport.columnCustomId": {
    "defaultMessage": "Benutzerdefinierte ID"
  },
  "audit.gipReport.columnMaterial": {
    "defaultMessage": "Material"
  },
  "audit.gipReport.columnStation": {
    "defaultMessage": "Sender"
  },
  "audit.gipReport.configTitle": {
    "defaultMessage": "Berichtskonfiguration"
  },
  "audit.gipReport.createModal.createdNotification": {
    "defaultMessage": "Bericht erstellt"
  },
  "audit.gipReport.createModal.createdNotificationLink": {
    "defaultMessage": "Bericht anzeigen"
  },
  "audit.gipReport.createModal.nameLabel": {
    "defaultMessage": "Name"
  },
  "audit.gipReport.createModal.namePlaceholder": {
    "defaultMessage": "Berichtsnamen eingeben"
  },
  "audit.gipReport.createModal.title": {
    "defaultMessage": "GIP-Bericht erstellen"
  },
  "audit.gipReport.error.dateRangeExceeded": {
    "defaultMessage": "Der Datumsbereich darf {maxDays} Tage nicht überschreiten."
  },
  "audit.gipReport.error.fromMustBeBeforeTo": {
    "defaultMessage": "Das Startdatum muss vor dem Enddatum liegen."
  },
  "audit.gipReport.excludedMatchesCount": {
    "defaultMessage": "{count, plural, one {Match ausgeschlossen} other {Matches ausgeschlossen}}"
  },
  "audit.gipReport.excludedMatchesLabel": {
    "defaultMessage": "Vom Export ausgeschlossene Matches"
  },
  "audit.gipReport.export.advancedLink": {
    "defaultMessage": "Erweitert"
  },
  "audit.gipReport.export.audioMatchIncludeAfterLabel": {
    "defaultMessage": "Sekunden nach dem Match einzubeziehen"
  },
  "audit.gipReport.export.audioMatchIncludeBeforeLabel": {
    "defaultMessage": "Sekunden vor dem Match einzubeziehen"
  },
  "audit.gipReport.export.audioMatchIncludeHelper": {
    "defaultMessage": "Zwischen 0 und 300 Sekunden"
  },
  "audit.gipReport.export.customTextInPath": {
    "defaultMessage": "Benutzerdefinierter Text im Pfad"
  },
  "audit.gipReport.export.definition": {
    "defaultMessage": "Vorlage"
  },
  "audit.gipReport.export.excludeVersion": {
    "defaultMessage": "Version ausschließen"
  },
  "audit.gipReport.export.filesConfig": {
    "defaultMessage": "Dateikonfiguration"
  },
  "audit.gipReport.export.noTemplatesAvailable": {
    "defaultMessage": "Keine Vorlagen verfügbar"
  },
  "audit.gipReport.export.pathFormat": {
    "defaultMessage": "Pfadformat"
  },
  "audit.gipReport.export.publicLink": {
    "defaultMessage": "Öffentlicher Link"
  },
  "audit.gipReport.export.retryBtn": {
    "defaultMessage": "Erneut starten"
  },
  "audit.gipReport.export.startBtn": {
    "defaultMessage": "Export starten"
  },
  "audit.gipReport.export.startNotification": {
    "defaultMessage": "Export gestartet"
  },
  "audit.gipReport.export.startNotificationError": {
    "defaultMessage": "Fehler beim Starten des Exports"
  },
  "audit.gipReport.export.title": {
    "defaultMessage": "Bericht exportieren"
  },
  "audit.gipReport.export.xlsConfig": {
    "defaultMessage": "XLS-Konfiguration"
  },
  "audit.gipReport.exportModal.createdNotificationError": {
    "defaultMessage": "Fehler beim Erstellen des Berichts"
  },
  "audit.gipReport.form.advertisers": {
    "defaultMessage": "Werbende"
  },
  "audit.gipReport.form.allAdvertisers": {
    "defaultMessage": "Alle Werbenden"
  },
  "audit.gipReport.form.allCampaigns": {
    "defaultMessage": "Alle Kampagnen"
  },
  "audit.gipReport.form.allOrders": {
    "defaultMessage": "Alle Aufträge"
  },
  "audit.gipReport.form.allStationsDefault": {
    "defaultMessage": "Alle Sender"
  },
  "audit.gipReport.form.allVersions": {
    "defaultMessage": "Alle Versionen"
  },
  "audit.gipReport.form.campaigns": {
    "defaultMessage": "Kampagnen"
  },
  "audit.gipReport.form.customField": {
    "defaultMessage": "Benutzerdefiniertes Feld"
  },
  "audit.gipReport.form.customFieldValue": {
    "defaultMessage": "Benutzerdefiniertes Feld"
  },
  "audit.gipReport.form.customIds": {
    "defaultMessage": "Custom ID"
  },
  "audit.gipReport.form.endDate": {
    "defaultMessage": "Enddatum"
  },
  "audit.gipReport.form.endTime": {
    "defaultMessage": "Endzeit"
  },
  "audit.gipReport.form.loadOrderParams": {
    "defaultMessage": "Auftragsparameter laden"
  },
  "audit.gipReport.form.loadOrderParamsMultiple": {
    "defaultMessage": "Auftragsparameter laden"
  },
  "audit.gipReport.form.orders": {
    "defaultMessage": "Aufträge"
  },
  "audit.gipReport.form.selectCustom": {
    "defaultMessage": "Benutzerdefiniert auswählen"
  },
  "audit.gipReport.form.startDate": {
    "defaultMessage": "Startdatum"
  },
  "audit.gipReport.form.startTime": {
    "defaultMessage": "Startzeit"
  },
  "audit.gipReport.form.stations": {
    "defaultMessage": "Sender"
  },
  "audit.gipReport.form.switchToAdvancedStationsFilter": {
    "defaultMessage": "Erweiterten Filter verwenden"
  },
  "audit.gipReport.form.switchToSimpleStationsFilter": {
    "defaultMessage": "Einfachen Filter verwenden"
  },
  "audit.gipReport.form.typeToSearch": {
    "defaultMessage": "Mindestens 2 Anfangszeichen eingeben"
  },
  "audit.gipReport.form.versions": {
    "defaultMessage": "Versionen"
  },
  "audit.gipReport.includeAllMatches": {
    "defaultMessage": "Alle im Export gefundenen Matches einbeziehen"
  },
  "audit.gipReport.info.createBtn": {
    "defaultMessage": "Bericht speichern"
  },
  "audit.gipReport.info.end": {
    "defaultMessage": "Enddatum/-zeit"
  },
  "audit.gipReport.info.start": {
    "defaultMessage": "Startdatum/-zeit"
  },
  "audit.gipReport.noCustomFieldFilter": {
    "defaultMessage": "Kein benutzerdefinierter Feldfilter"
  },
  "audit.gipReport.result.advertiser": {
    "defaultMessage": "Werbender"
  },
  "audit.gipReport.result.campaign": {
    "defaultMessage": "Kampagne"
  },
  "audit.gipReport.result.contract": {
    "defaultMessage": "Vertrag"
  },
  "audit.gipReport.result.date": {
    "defaultMessage": "Datum"
  },
  "audit.gipReport.result.dateTime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.gipReport.result.duration": {
    "defaultMessage": "Dauer"
  },
  "audit.gipReport.result.matchDateTime": {
    "defaultMessage": "Treffer: Datum und Uhrzeit"
  },
  "audit.gipReport.result.material.missing": {
    "defaultMessage": "Material {customId} fehlt"
  },
  "audit.gipReport.result.material.present": {
    "defaultMessage": "Material {customId} vorhanden"
  },
  "audit.gipReport.result.order": {
    "defaultMessage": "Auftrag"
  },
  "audit.gipReport.result.schedule": {
    "defaultMessage": "Zeitplan"
  },
  "audit.gipReport.result.showOffTolerance": {
    "defaultMessage": "Toleranzabweichung anzeigen"
  },
  "audit.gipReport.result.station": {
    "defaultMessage": "Sender"
  },
  "audit.gipReport.result.tabs.future": {
    "defaultMessage": "Zukunft"
  },
  "audit.gipReport.result.tabs.long.future": {
    "defaultMessage": "Zukünftige Zeitpläne"
  },
  "audit.gipReport.result.tabs.long.missingMaterials": {
    "defaultMessage": "Zeitpläne mit fehlenden Materialien"
  },
  "audit.gipReport.result.tabs.long.toBeProcessed": {
    "defaultMessage": "Zu verarbeitende Zeitpläne"
  },
  "audit.gipReport.result.tabs.long.withMatches": {
    "defaultMessage": "Zeitpläne mit Treffern"
  },
  "audit.gipReport.result.tabs.long.withoutMatches": {
    "defaultMessage": "Zeitpläne ohne Treffer"
  },
  "audit.gipReport.result.tabs.missingMaterials": {
    "defaultMessage": "Fehlende Materialien"
  },
  "audit.gipReport.result.tabs.toBeProcessed": {
    "defaultMessage": "Zu verarbeiten"
  },
  "audit.gipReport.result.tabs.withMatches": {
    "defaultMessage": "Mit Treffern"
  },
  "audit.gipReport.result.tabs.withoutMatches": {
    "defaultMessage": "Ohne Treffer"
  },
  "audit.gipReport.result.time": {
    "defaultMessage": "Zeit"
  },
  "audit.gipReport.result.type": {
    "defaultMessage": "Typ"
  },
  "audit.gipReport.result.version": {
    "defaultMessage": "Version"
  },
  "audit.gipReport.resultOptions": {
    "defaultMessage": "Ergebnisoptionen"
  },
  "audit.gipReport.title": {
    "defaultMessage": "GIP-Bericht"
  },
  "audit.globalMissingAudios.groupByHelp.groupByCustomId": {
    "defaultMessage": "Gruppieren nach <b>Custom-ID</b>: Schedules werden nach Custom-ID gruppiert, sodass nur ein Schedule pro fehlendes Audio für jede der ausgewählten Sender zurückgegeben wird."
  },
  "audit.globalMissingAudios.groupByHelp.groupByCustomIdAndRadio": {
    "defaultMessage": "Gruppieren nach <b>Custom-ID und Sender</b>: es wird ein Schedule pro Sender und Custom-ID zurückgegeben."
  },
  "audit.globalMissingAudios.groupByHelp.intro": {
    "defaultMessage": "Diese Option ermöglicht das Gruppieren von Schedules mit fehlenden Audios:"
  },
  "audit.globalMissingAudios.groupByHelp.noGroup": {
    "defaultMessage": "<b>Nicht gruppieren</b>: gibt alle gefundenen Schedules zurück. Es können mehrere Schedules mit derselben Custom-ID zurückgegeben werden."
  },
  "audit.globalReports.title": {
    "defaultMessage": "Globale Berichte"
  },
  "audit.liveMention.badge": {
    "defaultMessage": "Live Mention"
  },
  "audit.liveMentions.acceptMention": {
    "defaultMessage": "Erwähnung akzeptieren"
  },
  "audit.liveMentions.createError": {
    "defaultMessage": "Erwähnung nicht erstellt, bitte erneut versuchen"
  },
  "audit.liveMentions.created": {
    "defaultMessage": "Manuelle Erwähnung erstellt"
  },
  "audit.liveMentions.mentionMatch": {
    "defaultMessage": "Mention Match"
  },
  "audit.liveMentions.processingMessage": {
    "defaultMessage": "Live-Erwähnungen werden verarbeitet. Die Ergebnisse sind in Kürze verfügbar."
  },
  "audit.liveMentions.rejectConfirm": {
    "defaultMessage": "Ablehnung bestätigen"
  },
  "audit.liveMentions.rejectMention": {
    "defaultMessage": "Erwähnung ablehnen"
  },
  "audit.liveMentions.rejected": {
    "defaultMessage": "Erwähnung abgelehnt"
  },
  "audit.liveMentions.selectFromSchedules": {
    "defaultMessage": "Meldung aus Schedules auswählen"
  },
  "audit.liveMentions.status.ACCEPTED": {
    "defaultMessage": "Akzeptiert"
  },
  "audit.liveMentions.status.AUTO": {
    "defaultMessage": "Auto"
  },
  "audit.liveMentions.status.MANUAL": {
    "defaultMessage": "Manuell"
  },
  "audit.liveMentions.status.REJECTED": {
    "defaultMessage": "Abgelehnt"
  },
  "audit.liveMentionsAdd.createCustomMention": {
    "defaultMessage": "Benutzerdefinierte Erwähnung erstellen"
  },
  "audit.liveMentionsAdd.mentionFromSchedules": {
    "defaultMessage": "Erwähnung aus Schedules"
  },
  "audit.liveMentionsAdd.title": {
    "defaultMessage": "Live-Erwähnung hinzufügen"
  },
  "audit.liveMentionsScreen.noResults": {
    "defaultMessage": "Keine Ergebnisse gefunden"
  },
  "audit.lowerthird.duration": {
    "defaultMessage": "Dauer"
  },
  "audit.lowerthird.title": {
    "defaultMessage": "Un Drittel"
  },
  "audit.lowerthirdScreen.loading": {
    "defaultMessage": "Un Drittel werden geladen"
  },
  "audit.lowerthirdScreen.noResults": {
    "defaultMessage": "Keine Un Drittel gefunden"
  },
  "audit.ltxMatchesReport.emptyState.help": {
    "defaultMessage": "Vergleicht importierte LTX-Logs mit den System-Matches für den ausgewählten Tag. Hilft zu prüfen, welche Ausstrahlungen des externen Logs bestätigt wurden und welche nicht."
  },
  "audit.matchCategory.adOverlays": {
    "defaultMessage": "AD OVERLAYS"
  },
  "audit.matchCategory.customAds": {
    "defaultMessage": "SPOT"
  },
  "audit.matchCategory.mentions": {
    "defaultMessage": "MENTIONS"
  },
  "audit.matches.spotMatch": {
    "defaultMessage": "Spot Match"
  },
  "audit.matchesAdd.createError": {
    "defaultMessage": "Fehler beim Erstellen des Treffers"
  },
  "audit.matchesAdd.created": {
    "defaultMessage": "Treffer erstellt"
  },
  "audit.matchesAdd.playedDuration": {
    "defaultMessage": "Abgespielte Dauer"
  },
  "audit.matchesAdd.title": {
    "defaultMessage": "Treffer hinzufügen"
  },
  "audit.matchesAdd.useAudioDuration": {
    "defaultMessage": "Audiodauer verwenden"
  },
  "audit.matchesList.matchesWithSchedule": {
    "defaultMessage": "Übereinstimmung mit Schedule"
  },
  "audit.matchesScreen.downloadBtn": {
    "defaultMessage": "Media herunterladen"
  },
  "audit.matchesScreen.showOnStreamBtn": {
    "defaultMessage": "Im Stream anzeigen"
  },
  "audit.matchesScreen.title": {
    "defaultMessage": "Matches"
  },
  "audit.matchesWithSchedule": {
    "defaultMessage": "Übereinstimmung mit Plan"
  },
  "audit.mediaPlayer.viewMedia": {
    "defaultMessage": "Medien abspielen"
  },
  "audit.missingAudios.emptyState.help": {
    "defaultMessage": "Listet Material-IDs für Schedules im ausgewählten Zeitraum auf, deren Referenz-Media für den verknüpften Sender nicht geladen wurde. Nützlich, um Schedules ohne Media zum Erkennen zu finden."
  },
  "audit.missingAudios.groupBy.custom_id": {
    "defaultMessage": "Benutzerdefinierte ID"
  },
  "audit.missingAudios.groupBy.custom_id_station_id": {
    "defaultMessage": "Benutzerdefinierte ID und Sender"
  },
  "audit.missingAudios.groupBy.none": {
    "defaultMessage": "Keine Gruppierung"
  },
  "audit.missingAudios.scheduleDatetime": {
    "defaultMessage": "Zeitplan Datum/Uhrzeit"
  },
  "audit.missingAudios.title": {
    "defaultMessage": "Fehlende Audios"
  },
  "audit.missingAudios.viewScheduleBtn": {
    "defaultMessage": "Zeitplan anzeigen"
  },
  "audit.noMatchesReport.emptyState.help": {
    "defaultMessage": "Zeigt Mediendateien, die im ausgewählten Zeitraum hochgeladen wurden und für die in diesem Zeitraum oder im anderen angepassten Zeitraum kein Match erkannt wurde."
  },
  "audit.notEnabled": {
    "defaultMessage": "Nicht aktiviert"
  },
  "audit.notEnabled.htmlTitle": {
    "defaultMessage": "{stationName} - Audit nicht aktiviert"
  },
  "audit.notEnabledForStation.body": {
    "defaultMessage": "Kontaktieren Sie uns, um Audit für {stationName} zu aktivieren."
  },
  "audit.notEnabledForStation.title": {
    "defaultMessage": "Diese Funktion ist für diesen Sender nicht aktiviert"
  },
  "audit.preview.generating": {
    "defaultMessage": "Wird erstellt..."
  },
  "audit.preview.preview": {
    "defaultMessage": "Vorschau"
  },
  "audit.preview.previewCsv": {
    "defaultMessage": "CSV-Vorschau"
  },
  "audit.preview.previewXls": {
    "defaultMessage": "XLS-Vorschau"
  },
  "audit.props.advertiser": {
    "defaultMessage": "Werbender"
  },
  "audit.props.audio": {
    "defaultMessage": "Audio"
  },
  "audit.props.audioDuration": {
    "defaultMessage": "Audiodauer"
  },
  "audit.props.campaign": {
    "defaultMessage": "Kampagne"
  },
  "audit.props.creationRange": {
    "defaultMessage": "Audio-Erstellungszeitraum"
  },
  "audit.props.customAudioId": {
    "defaultMessage": "Audio-ID"
  },
  "audit.props.customId": {
    "defaultMessage": "Benutzerdefinierte ID"
  },
  "audit.props.date": {
    "defaultMessage": "Datum"
  },
  "audit.props.datetime": {
    "defaultMessage": "Zieldatum/-zeit"
  },
  "audit.props.duration": {
    "defaultMessage": "Abgespielte Dauer"
  },
  "audit.props.manualMatch": {
    "defaultMessage": "Manueller Treffer"
  },
  "audit.props.matches": {
    "defaultMessage": "Treffer"
  },
  "audit.props.mentionId": {
    "defaultMessage": "Erwähnungs-ID"
  },
  "audit.props.order": {
    "defaultMessage": "Auftrag"
  },
  "audit.props.score": {
    "defaultMessage": "Punktzahl"
  },
  "audit.props.time": {
    "defaultMessage": "Zeit"
  },
  "audit.props.tolerance": {
    "defaultMessage": "Toleranz"
  },
  "audit.props.tolerance.help": {
    "defaultMessage": "Die Werte sind in Minuten. Format: Minuten vorher / Minuten nachher zur geplanten Datum und Uhrzeit."
  },
  "audit.props.type": {
    "defaultMessage": "Typ"
  },
  "audit.props.version": {
    "defaultMessage": "Version"
  },
  "audit.report.created": {
    "defaultMessage": "Erstellt"
  },
  "audit.report.name": {
    "defaultMessage": "Name"
  },
  "audit.reportDefinitionEditor.columnLabel": {
    "defaultMessage": "Titel"
  },
  "audit.reportDefinitionEditor.columnType.boolean": {
    "defaultMessage": "Boolesch"
  },
  "audit.reportDefinitionEditor.columnType.boolean.falseLabel": {
    "defaultMessage": "Bezeichnung für falsch"
  },
  "audit.reportDefinitionEditor.columnType.boolean.trueLabel": {
    "defaultMessage": "Bezeichnung für wahr"
  },
  "audit.reportDefinitionEditor.columnType.date": {
    "defaultMessage": "Datum"
  },
  "audit.reportDefinitionEditor.columnType.date.format": {
    "defaultMessage": "Datumsformat"
  },
  "audit.reportDefinitionEditor.columnType.datetime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.reportDefinitionEditor.columnType.datetime.format": {
    "defaultMessage": "Datums- und Zeitformat"
  },
  "audit.reportDefinitionEditor.columnType.number": {
    "defaultMessage": "Zahl"
  },
  "audit.reportDefinitionEditor.columnType.string": {
    "defaultMessage": "Zeichenkette"
  },
  "audit.reportDefinitionEditor.columnType.string.case": {
    "defaultMessage": "Textformat"
  },
  "audit.reportDefinitionEditor.columnType.string.case.lowercase": {
    "defaultMessage": "Kleinbuchstaben"
  },
  "audit.reportDefinitionEditor.columnType.string.case.none": {
    "defaultMessage": "Kein Format"
  },
  "audit.reportDefinitionEditor.columnType.string.case.title": {
    "defaultMessage": "Titelformat"
  },
  "audit.reportDefinitionEditor.columnType.string.case.uppercase": {
    "defaultMessage": "Großbuchstaben"
  },
  "audit.reportDefinitionEditor.columnType.time": {
    "defaultMessage": "Zeit"
  },
  "audit.reportDefinitionEditor.columnType.time.format": {
    "defaultMessage": "Zeitformat"
  },
  "audit.reportDefinitionEditor.columnType.unknown": {
    "defaultMessage": "Unbekannt"
  },
  "audit.reportDefinitionEditor.columnType.url": {
    "defaultMessage": "URL"
  },
  "audit.reportDefinitionEditor.metadata.default": {
    "defaultMessage": "Standardvorlage"
  },
  "audit.reportDefinitionEditor.metadata.name": {
    "defaultMessage": "Name"
  },
  "audit.reportDefinitionEditor.metadata.name.helper": {
    "defaultMessage": "Name zur Identifikation dieser Vorlage"
  },
  "audit.reportDefinitionEditor.metadata.title": {
    "defaultMessage": "Informationen"
  },
  "audit.reportDefinitionEditor.title": {
    "defaultMessage": "Berichtsvorlage"
  },
  "audit.reportDefinitionList.actions": {
    "defaultMessage": "Aktionen"
  },
  "audit.reportDefinitionList.createdAt": {
    "defaultMessage": "Erstellt"
  },
  "audit.reportDefinitionList.defaultTemplate": {
    "defaultMessage": "Standardvorlage"
  },
  "audit.reportDefinitionList.editTooltip": {
    "defaultMessage": "Bearbeiten"
  },
  "audit.reportDefinitionList.name": {
    "defaultMessage": "Name"
  },
  "audit.reportDefinitionList.nameFilterPlaceholder": {
    "defaultMessage": "Nach Namen suchen"
  },
  "audit.reportDefinitionList.title": {
    "defaultMessage": "Berichtsvorlagen"
  },
  "audit.reportDefinitions.availableColumns.empty": {
    "defaultMessage": "Keine Spalten verfügbar"
  },
  "audit.reportDefinitions.cannotDeleteDefault": {
    "defaultMessage": "Die Standardvorlage kann nicht gelöscht werden"
  },
  "audit.reportDefinitions.cloneButton": {
    "defaultMessage": "Klonen"
  },
  "audit.reportDefinitions.cloneError": {
    "defaultMessage": "Fehler beim Klonen der Vorlage"
  },
  "audit.reportDefinitions.cloneSuccess": {
    "defaultMessage": "Vorlage erfolgreich geklont"
  },
  "audit.reportDefinitions.createError": {
    "defaultMessage": "Fehler beim Erstellen der Vorlage"
  },
  "audit.reportDefinitions.deleteError": {
    "defaultMessage": "Fehler beim Löschen der Vorlage"
  },
  "audit.reportDefinitions.deleteSuccess": {
    "defaultMessage": "Vorlage erfolgreich gelöscht"
  },
  "audit.reportDefinitions.deleteTemplateConfirm": {
    "defaultMessage": "Möchten Sie die Vorlage \"{name}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "audit.reportDefinitions.deleteTemplateTitle": {
    "defaultMessage": "Vorlage löschen"
  },
  "audit.reportDefinitions.loadCustomLogo": {
    "defaultMessage": "Benutzerdefiniertes Logo laden"
  },
  "audit.reportDefinitions.newTemplateButton": {
    "defaultMessage": "Neue Vorlage"
  },
  "audit.reportDefinitions.previewError": {
    "defaultMessage": "Fehler beim Generieren der Vorschau"
  },
  "audit.reportDefinitions.reportTemplateTitle": {
    "defaultMessage": "Berichtsvorlage"
  },
  "audit.reportDefinitions.reportTypeRequired": {
    "defaultMessage": "Berichtstyp ist erforderlich"
  },
  "audit.reportDefinitions.saveError": {
    "defaultMessage": "Fehler beim Speichern der Berichtsvorlage"
  },
  "audit.reportDefinitions.saveSuccess": {
    "defaultMessage": "Berichtsvorlage erfolgreich gespeichert"
  },
  "audit.reportDefinitions.segmentation.groupBy": {
    "defaultMessage": "Spalte"
  },
  "audit.reportDefinitions.segmentation.grouping": {
    "defaultMessage": "Segmentierung"
  },
  "audit.reportDefinitions.segmentation.helperText": {
    "defaultMessage": "In XLS-Dateien wird ein Blatt für jeden Wert des ausgewählten Felds erzeugt. In CSV-Dateien wird eine separate Datei in einer .zip-Datei erzeugt"
  },
  "audit.reportDefinitions.segmentation.hideColumn": {
    "defaultMessage": "Diese Spalte im Bericht ausblenden"
  },
  "audit.reportDefinitions.segmentation.noColumns": {
    "defaultMessage": "Sie müssen mindestens eine Spalte auswählen, um gruppieren zu können."
  },
  "audit.reportDefinitions.segmentation.removedNotification": {
    "defaultMessage": "Die Segmentierung wurde deaktiviert, da die zugehörige Spalte entfernt wurde."
  },
  "audit.reportDefinitions.segmentation.splitReport": {
    "defaultMessage": "In Abschnitte für eine der Spalten aufteilen"
  },
  "audit.reportDefinitions.segmentation.tour.description": {
    "defaultMessage": "Aktivieren Sie diese Option, um den Bericht in Abschnitte zu unterteilen (z. B. ein XLS-Blatt pro Wert der gewählten Spalte)."
  },
  "audit.reportDefinitions.segmentation.tour.title": {
    "defaultMessage": "Berichtssegmentierung"
  },
  "audit.reportDefinitions.selectedColumns.empty": {
    "defaultMessage": "Keine Spalten ausgewählt. Verwenden Sie den Pfeil-Button bei den verfügbaren Spalten, um sie hinzuzufügen."
  },
  "audit.reportDefinitions.sorting.noRules": {
    "defaultMessage": "Keine Sortierregeln. Klicken Sie auf \"Reihenfolge hinzufügen\", um eine hinzuzufügen."
  },
  "audit.reportDefinitions.sorting.order": {
    "defaultMessage": "Reihenfolge"
  },
  "audit.reportDefinitions.styleTitle": {
    "defaultMessage": "Stil"
  },
  "audit.reportDefinitions.templatesForReport": {
    "defaultMessage": "Vorlagen für Report {name}"
  },
  "audit.reportDefinitions.templatesTitle": {
    "defaultMessage": "Vorlagen"
  },
  "audit.reportDefinitions.useClientLogo": {
    "defaultMessage": "Kundenlogo verwenden"
  },
  "audit.reportDelete.deleteError": {
    "defaultMessage": "Bericht konnte nicht gelöscht werden"
  },
  "audit.reportDelete.deleted": {
    "defaultMessage": "Bericht gelöscht"
  },
  "audit.reportDelete.prompt": {
    "defaultMessage": "Möchten Sie diesen Bericht löschen? {br} Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "audit.reportDelete.title": {
    "defaultMessage": "Bericht löschen"
  },
  "audit.reportNames.AUDIT_BROADCAST_EVIDENCE": {
    "defaultMessage": "Broadcast Evidence"
  },
  "audit.reportNames.AUDIT_GIP_ALTERNATIVE_REPORT": {
    "defaultMessage": "GIP-Alternative"
  },
  "audit.reportNames.AUDIT_GIP_STATUS": {
    "defaultMessage": "GIP"
  },
  "audit.reportNames.BCR_MATCHES": {
    "defaultMessage": "BCR-Treffer"
  },
  "audit.reports.bcrMatches.noBcrEntries": {
    "defaultMessage": "No BCR entries found for the report"
  },
  "audit.reports.branding.logo": {
    "defaultMessage": "Logo"
  },
  "audit.reports.ltxMatches.noLtxEntries": {
    "defaultMessage": "Keine LTX-Einträge für den Bericht gefunden"
  },
  "audit.reports.section.availableColumns": {
    "defaultMessage": "Available columns"
  },
  "audit.reports.section.reportColumns": {
    "defaultMessage": "Report columns"
  },
  "audit.reports.sorting.add": {
    "defaultMessage": "Add"
  },
  "audit.reports.viewNotFound": {
    "defaultMessage": "View not found for report {type}"
  },
  "audit.reportsList.createdBy": {
    "defaultMessage": "Erstellt von"
  },
  "audit.reportsList.exportStatus": {
    "defaultMessage": "Exportstatus"
  },
  "audit.reportsList.noExport": {
    "defaultMessage": "Kein Export"
  },
  "audit.reportsList.onlyMine": {
    "defaultMessage": "Nur meine"
  },
  "audit.reportsList.title": {
    "defaultMessage": "Erstellte Berichte"
  },
  "audit.reportsList.type": {
    "defaultMessage": "Typ"
  },
  "audit.reportsScreen.bcrMatches.customId": {
    "defaultMessage": "Benutzerdefinierte ID (optional)"
  },
  "audit.reportsScreen.bcrMatches.date": {
    "defaultMessage": "Datum"
  },
  "audit.reportsScreen.bcrMatches.noSchedule": {
    "defaultMessage": "Kein Zeitplan"
  },
  "audit.reportsScreen.bcrMatches.tabs.unverifiedBcrEntries": {
    "defaultMessage": "Unbestätigte BCR-Einträge"
  },
  "audit.reportsScreen.bcrMatches.tabs.unverifiedMatches": {
    "defaultMessage": "Unbestätigte Treffer"
  },
  "audit.reportsScreen.bcrMatches.tabs.verified": {
    "defaultMessage": "Bestätigte Treffer"
  },
  "audit.reportsScreen.bcrMatches.title": {
    "defaultMessage": "BCR-Treffer"
  },
  "audit.reportsScreen.bcrMatches.unverifiedBcrEntries.customId": {
    "defaultMessage": "Benutzerdefinierte ID"
  },
  "audit.reportsScreen.bcrMatches.unverifiedBcrEntries.datetime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.reportsScreen.bcrMatches.unverifiedBcrEntries.name": {
    "defaultMessage": "Name"
  },
  "audit.reportsScreen.bcrMatches.unverifiedMatches.customId": {
    "defaultMessage": "Benutzerdefinierte ID"
  },
  "audit.reportsScreen.bcrMatches.unverifiedMatches.datetime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.reportsScreen.bcrMatches.verified.bcrEntryDatetime": {
    "defaultMessage": "BCR-Eintragszeit"
  },
  "audit.reportsScreen.bcrMatches.verified.bcrName": {
    "defaultMessage": "BCR-Name"
  },
  "audit.reportsScreen.bcrMatches.verified.matchCustomId": {
    "defaultMessage": "Benutzerdefinierte ID"
  },
  "audit.reportsScreen.bcrMatches.verified.matchDatetime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.reportsScreen.bcrMatches.verified.matchedSchedule": {
    "defaultMessage": "Zeitplan"
  },
  "audit.reportsScreen.equalMd5.title": {
    "defaultMessage": "Audios mit gleichem Inhalt"
  },
  "audit.reportsScreen.ltxMatches.customId": {
    "defaultMessage": "Custom ID (optional)"
  },
  "audit.reportsScreen.ltxMatches.date": {
    "defaultMessage": "Datum"
  },
  "audit.reportsScreen.ltxMatches.noSchedule": {
    "defaultMessage": "Kein Zeitplan"
  },
  "audit.reportsScreen.ltxMatches.tabs.unverifiedLtxEntries": {
    "defaultMessage": "Unverifizierte LTX-Einträge"
  },
  "audit.reportsScreen.ltxMatches.tabs.unverifiedMatches": {
    "defaultMessage": "Unverifizierte Matches"
  },
  "audit.reportsScreen.ltxMatches.tabs.verified": {
    "defaultMessage": "Verifizierte Matches"
  },
  "audit.reportsScreen.ltxMatches.title": {
    "defaultMessage": "LTX Matches"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.customId": {
    "defaultMessage": "Custom ID"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.datetime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.name": {
    "defaultMessage": "Name"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.type": {
    "defaultMessage": "Typ"
  },
  "audit.reportsScreen.ltxMatches.unverifiedMatches.customId": {
    "defaultMessage": "Custom ID"
  },
  "audit.reportsScreen.ltxMatches.unverifiedMatches.datetime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.reportsScreen.ltxMatches.verified.ltxEntryDatetime": {
    "defaultMessage": "LTX-Eintragszeit"
  },
  "audit.reportsScreen.ltxMatches.verified.ltxName": {
    "defaultMessage": "LTX-Name"
  },
  "audit.reportsScreen.ltxMatches.verified.matchCustomId": {
    "defaultMessage": "Custom ID"
  },
  "audit.reportsScreen.ltxMatches.verified.matchDatetime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.reportsScreen.ltxMatches.verified.matchedSchedule": {
    "defaultMessage": "Zeitplan"
  },
  "audit.reportsScreen.missingAudios.datetime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.reportsScreen.missingAudios.title": {
    "defaultMessage": "Fehlende Audios"
  },
  "audit.reportsScreen.missingAudios.viewScheduleBtn": {
    "defaultMessage": "Zeitplandetails anzeigen"
  },
  "audit.reportsScreen.noMatches.creationRange": {
    "defaultMessage": "Erstellungszeitraum"
  },
  "audit.reportsScreen.noMatches.matchRange": {
    "defaultMessage": "Trefferzeitraum"
  },
  "audit.reportsScreen.noMatches.sameAudioMatch.matchesLink": {
    "defaultMessage": "{audioId}-Treffer anzeigen"
  },
  "audit.reportsScreen.noMatches.sameAudioMatch.message": {
    "defaultMessage": "Es gibt ein Audio mit gleichem Inhalt und Treffern:"
  },
  "audit.reportsScreen.noMatches.title": {
    "defaultMessage": "Dateien ohne Treffer"
  },
  "audit.reportsScreen.noMatches.useSameRangeLabel": {
    "defaultMessage": "Gleichen Audio-Erstellungszeitraum verwenden"
  },
  "audit.reportsScreen.title": {
    "defaultMessage": "Berichte"
  },
  "audit.reportsView.cloneBtn": {
    "defaultMessage": "Klonen"
  },
  "audit.reportsView.created": {
    "defaultMessage": "Erstellt"
  },
  "audit.reportsView.createdBy": {
    "defaultMessage": "Erstellt von"
  },
  "audit.reportsView.createdByUnknown": {
    "defaultMessage": "Erstellt von Unbekannt"
  },
  "audit.reportsView.export": {
    "defaultMessage": "Export"
  },
  "audit.reportsView.exportBtn": {
    "defaultMessage": "Download report"
  },
  "audit.reportsView.exportDialog.confirm": {
    "defaultMessage": "Herunterladen"
  },
  "audit.reportsView.exportDialog.format": {
    "defaultMessage": "Format"
  },
  "audit.reportsView.exportDialog.noDefinitions": {
    "defaultMessage": "No templates available"
  },
  "audit.reportsView.exportDialog.title": {
    "defaultMessage": "Download report"
  },
  "audit.reportsView.exportFailed": {
    "defaultMessage": "Export fehlgeschlagen"
  },
  "audit.reportsView.exportInfo": {
    "defaultMessage": "Exportkonfiguration"
  },
  "audit.reportsView.name": {
    "defaultMessage": "Name"
  },
  "audit.reportsView.type": {
    "defaultMessage": "Typ"
  },
  "audit.scheduleStatus.detail.customId": {
    "defaultMessage": "Benutzerdefinierte ID"
  },
  "audit.scheduleStatus.detail.material": {
    "defaultMessage": "Material"
  },
  "audit.scheduleStatusPntScreen.confidence": {
    "defaultMessage": "Konfidenz"
  },
  "audit.scheduleStatusPntScreen.detailModal.matches": {
    "defaultMessage": "Treffer"
  },
  "audit.scheduleStatusPntScreen.status": {
    "defaultMessage": "Status"
  },
  "audit.scheduleStatusPntScreen.status.help": {
    "defaultMessage": "Die Zahlen stehen für Treffer mit Zeitplan / Zeitpläne.\n\nVollständig: jeder Zeitplan hat einen Treffer.\nTeilweise: nicht jeder Zeitplan hat einen Treffer.\nKeine Ausstrahlung: es gibt Zeitpläne und keine Treffer.\nKeine Treffer: es gibt weder Treffer noch Zeitpläne.\n\nDas Warnsymbol bedeutet, dass mindestens ein Treffer außerhalb der Toleranz liegt."
  },
  "audit.scheduleStatusScreen.detailModal.audio": {
    "defaultMessage": "Audio"
  },
  "audit.scheduleStatusScreen.detailModal.matchDatetime": {
    "defaultMessage": "Treffer-Datum und -Uhrzeit"
  },
  "audit.scheduleStatusScreen.detailModal.matchedSchedule": {
    "defaultMessage": "Zugeordneter Zeitplan"
  },
  "audit.scheduleStatusScreen.detailModal.matches": {
    "defaultMessage": "Bestätigter Treffer"
  },
  "audit.scheduleStatusScreen.detailModal.matchesCount": {
    "defaultMessage": "# Treffer"
  },
  "audit.scheduleStatusScreen.detailModal.matchesWithScheduleCount": {
    "defaultMessage": "# Treffer mit Zeitplan"
  },
  "audit.scheduleStatusScreen.detailModal.noMatchedSchedule": {
    "defaultMessage": "Kein Zeitplan"
  },
  "audit.scheduleStatusScreen.detailModal.noMatches": {
    "defaultMessage": "Keine Treffer gefunden"
  },
  "audit.scheduleStatusScreen.detailModal.offTolerance": {
    "defaultMessage": "Außerhalb Toleranz"
  },
  "audit.scheduleStatusScreen.detailModal.schedules": {
    "defaultMessage": "Zeitpläne"
  },
  "audit.scheduleStatusScreen.detailModal.schedulesCount": {
    "defaultMessage": "# Zeitpläne"
  },
  "audit.scheduleStatusScreen.detailModal.status": {
    "defaultMessage": "Status"
  },
  "audit.scheduleStatusScreen.detailModal.unmatchedMatches": {
    "defaultMessage": "Treffer ohne Zeitplan"
  },
  "audit.scheduleStatusScreen.filter.idPlaceholder": {
    "defaultMessage": "Alle"
  },
  "audit.scheduleStatusScreen.noAudio": {
    "defaultMessage": "Kein Audio"
  },
  "audit.scheduleStatusScreen.overview.all": {
    "defaultMessage": "Alle"
  },
  "audit.scheduleStatusScreen.status": {
    "defaultMessage": "Status"
  },
  "audit.scheduleStatusScreen.status.chipTooltip": {
    "defaultMessage": "{matchesCount} Treffer / {matchesWithScheduleCount} mit Zeitplan / {schedulesCount} Zeitpläne"
  },
  "audit.scheduleStatusScreen.status.chipTooltipOffTolerance": {
    "defaultMessage": "{matchesCount} Treffer / {matchesWithScheduleCount} mit Zeitplan / {schedulesCount} Zeitpläne ({offToleranceCount} außerhalb der Toleranz)"
  },
  "audit.scheduleStatusScreen.status.complete": {
    "defaultMessage": "Vollständig"
  },
  "audit.scheduleStatusScreen.status.help": {
    "defaultMessage": "Die Zahlen stehen für Treffer mit Zeitplan / Zeitpläne.\n\nVollständig: jeder Zeitplan hat einen Treffer.\nTeilweise: nicht jeder Zeitplan hat einen Treffer.\nKeine Ausstrahlung: es gibt Zeitpläne und keine Treffer.\nKeine Treffer: es gibt weder Treffer noch Zeitpläne.\n\nDas Warnsymbol bedeutet, dass mindestens ein Treffer außerhalb der Toleranz liegt."
  },
  "audit.scheduleStatusScreen.status.missingEmission": {
    "defaultMessage": "Keine Ausstrahlung"
  },
  "audit.scheduleStatusScreen.status.none": {
    "defaultMessage": "Keine Treffer"
  },
  "audit.scheduleStatusScreen.status.offTolerance": {
    "defaultMessage": "Außerhalb Toleranz"
  },
  "audit.scheduleStatusScreen.status.partial": {
    "defaultMessage": "Teilweise"
  },
  "audit.scheduleStatusScreen.title": {
    "defaultMessage": "Zeitplan"
  },
  "audit.schedulesList.matchDatetime": {
    "defaultMessage": "Match"
  },
  "audit.schedulesList.mentions.diff": {
    "defaultMessage": "- Diff: {diff} min"
  },
  "audit.schedulesList.mentions.diffLabel": {
    "defaultMessage": "Diff"
  },
  "audit.schedulesListScreen.filter.idPlaceholder": {
    "defaultMessage": "Nach Audio-IDs suchen (kommagetrennt)"
  },
  "audit.schedulesListScreen.inheritedTolerance": {
    "defaultMessage": "Geerbte Toleranz"
  },
  "audit.schedulesListScreen.noAudio": {
    "defaultMessage": "Kein Audio"
  },
  "audit.schedulesListScreen.noMatch": {
    "defaultMessage": "Kein Treffer"
  },
  "audit.schedulesListScreen.props.status": {
    "defaultMessage": "Status"
  },
  "audit.schedulesListScreen.title": {
    "defaultMessage": "Schedules"
  },
  "audit.schedulesListScreen.viewScheduleBtn": {
    "defaultMessage": "Details anzeigen"
  },
  "audit.schedulesNoMatches.includeMissingAudio": {
    "defaultMessage": "Fehlendes Audio einbeziehen"
  },
  "audit.schedulesNoMatches.title": {
    "defaultMessage": "Zeitpläne ohne Treffer"
  },
  "audit.schedulesPreview.advertiser": {
    "defaultMessage": "Anzeigenkunde"
  },
  "audit.schedulesPreview.campaign": {
    "defaultMessage": "Kampagne"
  },
  "audit.schedulesPreview.dateTime": {
    "defaultMessage": "Datum/Uhrzeit"
  },
  "audit.schedulesPreview.tolerance": {
    "defaultMessage": "Toleranz"
  },
  "audit.schedulesPreview.version": {
    "defaultMessage": "Version"
  },
  "audit.schedulesViewScreen.loading": {
    "defaultMessage": "Zeitplan wird geladen"
  },
  "audit.schedulesViewScreen.matchDiff": {
    "defaultMessage": "Differenz (Minuten)"
  },
  "audit.schedulesViewScreen.matchTime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "audit.schedulesViewScreen.matchesCount": {
    "defaultMessage": "{count, plural, =0 {Keine Ergebnisse für das Datum} one {1 Treffer gefunden} other {# Treffer gefunden} }"
  },
  "audit.schedulesViewScreen.title": {
    "defaultMessage": "Zeitplan #{id}"
  },
  "audit.screenbug.title": {
    "defaultMessage": "Screenbug"
  },
  "audit.sidenav.aod": {
    "defaultMessage": "AOD"
  },
  "audit.sidenav.config": {
    "defaultMessage": "Konfiguration"
  },
  "audit.sidenav.globalReports": {
    "defaultMessage": "Allgemeine Prüfung"
  },
  "audit.sidenav.stationAudit": {
    "defaultMessage": "Senderprüfung"
  },
  "audit.sorting.ascending": {
    "defaultMessage": "Aufsteigend"
  },
  "audit.sorting.descending": {
    "defaultMessage": "Absteigend"
  },
  "audit.streamScreen.adoverlay": {
    "defaultMessage": "Ad-Overlay"
  },
  "audit.streamScreen.audioMatches": {
    "defaultMessage": "Audio-Treffer"
  },
  "audit.streamScreen.liveMentions": {
    "defaultMessage": "Live-Erwähnungen"
  },
  "audit.streamScreen.lowerthird": {
    "defaultMessage": "Un Drittel"
  },
  "audit.streamScreen.transcriptions": {
    "defaultMessage": "Transkriptionen"
  },
  "audit.title": {
    "defaultMessage": "Prüfung"
  },
  "audit.transcriptionScreen.confidence": {
    "defaultMessage": "Konfidenz"
  },
  "audit.transcriptionScreen.editor": {
    "defaultMessage": "Editor"
  },
  "audit.transcriptionScreen.high": {
    "defaultMessage": "Hoch"
  },
  "audit.transcriptionScreen.loading": {
    "defaultMessage": "Transkriptionen werden geladen"
  },
  "audit.transcriptionScreen.low": {
    "defaultMessage": "Niedrig"
  },
  "audit.transcriptionScreen.medium": {
    "defaultMessage": "Mittel"
  },
  "audit.transcriptionScreen.music": {
    "defaultMessage": "[Musik / Stille]"
  },
  "audit.transcriptionScreen.noResults": {
    "defaultMessage": "Keine Transkriptionen gefunden"
  },
  "audit.transcriptionScreen.processingSpeakers": {
    "defaultMessage": "Transkription abgeschlossen, Sprecher werden verarbeitet"
  },
  "audit.transcriptionScreen.refresh": {
    "defaultMessage": "Aktualisieren"
  },
  "audit.transcriptionScreen.sentence": {
    "defaultMessage": "Satz"
  },
  "audit.transcriptionScreen.speakers": {
    "defaultMessage": "Sprecherbezeichnungen"
  },
  "audit.uploadScreen.apiHint": {
    "defaultMessage": "Sie können Audios auch über unsere API hochladen. {br} Siehe {docLink} für Anweisungen."
  },
  "audit.uploadScreen.documentation": {
    "defaultMessage": "Dokumentation"
  },
  "audit.uploadScreen.htmlTitle": {
    "defaultMessage": "{stationName} - Audit-Upload"
  },
  "audit.uploadScreen.item.code": {
    "defaultMessage": "(Fehlercode: {code})"
  },
  "audit.uploadScreen.item.completed": {
    "defaultMessage": "Erfolgreich hochgeladen"
  },
  "audit.uploadScreen.item.error": {
    "defaultMessage": "Fehler: {message}"
  },
  "audit.uploadScreen.item.notStarted": {
    "defaultMessage": "Nicht hochgeladen"
  },
  "audit.uploadScreen.item.overridden": {
    "defaultMessage": "(vorherige Audio-Version wurde aktualisiert)"
  },
  "audit.uploadScreen.item.remove": {
    "defaultMessage": "Entfernen"
  },
  "audit.uploadScreen.item.started": {
    "defaultMessage": "Wird hochgeladen"
  },
  "audit.uploadScreen.item.status": {
    "defaultMessage": "Status:"
  },
  "audit.uploadScreen.leavePrompt": {
    "defaultMessage": "Ein oder mehrere Uploads sind in Bearbeitung. Möchten Sie die Seite wirklich verlassen?"
  },
  "audit.uploadScreen.reset": {
    "defaultMessage": "Zurücksetzen"
  },
  "audit.uploadScreen.selectedCount": {
    "defaultMessage": "{count, plural, one {1 ausgewählte Datei} other {# ausgewählte Dateien} }"
  },
  "audit.uploadScreen.title": {
    "defaultMessage": "Audios hochladen"
  },
  "audit.uploadScreen.upload": {
    "defaultMessage": "Hochladen"
  },
  "audit.verifyMatch.accept": {
    "defaultMessage": "Akzeptieren"
  },
  "audit.verifyMatch.actionTitle": {
    "defaultMessage": "Erkennung überprüfen"
  },
  "audit.verifyMatch.broadcastTitle": {
    "defaultMessage": "Erkannte Ausstrahlung"
  },
  "audit.verifyMatch.creativeTitle": {
    "defaultMessage": "Referenz-Media"
  },
  "audit.verifyMatch.dialogTitle": {
    "defaultMessage": "Erkennung überprüfen"
  },
  "audit.verifyMatch.mentionContentTitle": {
    "defaultMessage": "Mention-Inhalt"
  },
  "audit.verifyMatch.navigationPosition": {
    "defaultMessage": "{current} / {total}"
  },
  "audit.verifyMatch.next": {
    "defaultMessage": "Weiter"
  },
  "audit.verifyMatch.noMentionContent": {
    "defaultMessage": "Kein Mention-Inhalt für diese Erkennung verfügbar."
  },
  "audit.verifyMatch.noScheduleConfirmation": {
    "defaultMessage": "Keine Bestätigung"
  },
  "audit.verifyMatch.noTranscription": {
    "defaultMessage": "Keine Transkription für dieses Media verfügbar."
  },
  "audit.verifyMatch.previous": {
    "defaultMessage": "Zurück"
  },
  "audit.verifyMatch.reject": {
    "defaultMessage": "Ablehnen"
  },
  "audit.verifyMatch.transcriptionTitle": {
    "defaultMessage": "Medien-Transkription"
  },
  "auth.LogoutPage.message": {
    "defaultMessage": "Abmelden"
  },
  "auth.errors.ERR_AUTH_FAILED": {
    "defaultMessage": "Bitte versuchen Sie es erneut oder kontaktieren Sie den Support."
  },
  "auth.errors.ERR_USER_NOT_REGISTERED": {
    "defaultMessage": "Der Benutzer ist nicht auf der Plattform registriert. Bitte kontaktieren Sie den Support."
  },
  "auth.impersonation.groups.clientAdmins": {
    "defaultMessage": "Kundenadministratoren"
  },
  "auth.impersonation.groups.clientUsers": {
    "defaultMessage": "Kundenbenutzer"
  },
  "auth.impersonation.groups.mediainboxUsers": {
    "defaultMessage": "Mediainbox-Benutzer"
  },
  "auth.impersonation.submitButton": {
    "defaultMessage": "Impersonate user"
  },
  "auth.loginScreen.errorTitle": {
    "defaultMessage": "Anmeldung fehlgeschlagen"
  },
  "auth.loginScreen.loginBtn": {
    "defaultMessage": "Anmelden"
  },
  "auth.loginScreen.title": {
    "defaultMessage": "Anmeldung"
  },
  "auth.noPermissionForPage": {
    "defaultMessage": "Sie haben keine Berechtigung, auf diese Seite zuzugreifen"
  },
  "auth.tokenGate.errorLabel": {
    "defaultMessage": "Auth error:"
  },
  "auth.userInfo.changeUser": {
    "defaultMessage": "Change user"
  },
  "common.action.clear": {
    "defaultMessage": "Löschen"
  },
  "common.actions": {
    "defaultMessage": "Aktionen"
  },
  "common.actions.back": {
    "defaultMessage": "Zurück"
  },
  "common.actions.buscar": {
    "defaultMessage": "Suchen"
  },
  "common.actions.cancel": {
    "defaultMessage": "Abbrechen"
  },
  "common.actions.clone": {
    "defaultMessage": "Klonen"
  },
  "common.actions.create": {
    "defaultMessage": "Neu erstellen"
  },
  "common.actions.createEntity": {
    "defaultMessage": "Erstellen"
  },
  "common.actions.delete": {
    "defaultMessage": "Löschen"
  },
  "common.actions.discard": {
    "defaultMessage": "Verwerfen"
  },
  "common.actions.draft": {
    "defaultMessage": "Entwurf"
  },
  "common.actions.edit": {
    "defaultMessage": "Bearbeiten"
  },
  "common.actions.export": {
    "defaultMessage": "Export"
  },
  "common.actions.exportAsCsv": {
    "defaultMessage": "Als CSV exportieren"
  },
  "common.actions.exportAsXls": {
    "defaultMessage": "Als XLS exportieren"
  },
  "common.actions.filterByValue": {
    "defaultMessage": "Nach diesem Wert filtern"
  },
  "common.actions.refresh": {
    "defaultMessage": "Aktualisieren"
  },
  "common.actions.reload": {
    "defaultMessage": "Neu laden"
  },
  "common.actions.resetFilters": {
    "defaultMessage": "Löschen"
  },
  "common.actions.save": {
    "defaultMessage": "Speichern"
  },
  "common.actions.select": {
    "defaultMessage": "Auswählen..."
  },
  "common.actions.selectAll": {
    "defaultMessage": "Alle auswählen"
  },
  "common.actions.selectNone": {
    "defaultMessage": "Alle abwählen"
  },
  "common.allStations": {
    "defaultMessage": "Alle Sender"
  },
  "common.apply": {
    "defaultMessage": "Anwenden"
  },
  "common.audio": {
    "defaultMessage": "audio"
  },
  "common.breadcrumb": {
    "defaultMessage": "Breadcrumb"
  },
  "common.cancel": {
    "defaultMessage": "Abbrechen"
  },
  "common.clear": {
    "defaultMessage": "Löschen"
  },
  "common.close": {
    "defaultMessage": "Schließen"
  },
  "common.columnIndex": {
    "defaultMessage": "#"
  },
  "common.confirm": {
    "defaultMessage": "Bestätigen"
  },
  "common.copiedToClipboard": {
    "defaultMessage": "In die Zwischenablage kopiert"
  },
  "common.createdAt": {
    "defaultMessage": "Erstellt am"
  },
  "common.customId": {
    "defaultMessage": "Benutzerdefinierte ID"
  },
  "common.customImage": {
    "defaultMessage": "Benutzerdefiniertes Bild"
  },
  "common.customScreen.demoRangeLabel": {
    "defaultMessage": "Demo: ausgewählter Zeitraum"
  },
  "common.customScreen.downloadMediaViewsDemoLabel": {
    "defaultMessage": "Demo jeder Download-Medien-Benachrichtigungsansicht"
  },
  "common.customScreen.localePrefix": {
    "defaultMessage": "Sprache:"
  },
  "common.customScreen.presetResultsLabel": {
    "defaultMessage": "Von/Bis nach Filtertyp"
  },
  "common.customScreen.showCompletedView": {
    "defaultMessage": "CompletedView anzeigen"
  },
  "common.customScreen.showErrorView": {
    "defaultMessage": "ErrorView anzeigen"
  },
  "common.customScreen.showLoadingView": {
    "defaultMessage": "LoadingView anzeigen"
  },
  "common.customScreen.showPendingView": {
    "defaultMessage": "PendingView anzeigen"
  },
  "common.customScreen.tab.dateRange": {
    "defaultMessage": "Datumsbereich"
  },
  "common.customScreen.tab.downloadMediaNotificationViews": {
    "defaultMessage": "Download-Medien-Benachrichtigungsansichten"
  },
  "common.customScreen.title": {
    "defaultMessage": "Custom Screen"
  },
  "common.date": {
    "defaultMessage": "Datum"
  },
  "common.dateEnd": {
    "defaultMessage": "Enddatum"
  },
  "common.dateRangeSelector.apply": {
    "defaultMessage": "Anwenden"
  },
  "common.dateRangeSelector.labelToNow": {
    "defaultMessage": "{from} bis jetzt"
  },
  "common.dateRangeSelector.preset.allTime": {
    "defaultMessage": "Gesamter Zeitraum"
  },
  "common.dateRangeSelector.preset.customFixedDateRange": {
    "defaultMessage": "Benutzerdefinierter fester Zeitraum..."
  },
  "common.dateRangeSelector.preset.customSingleDate": {
    "defaultMessage": "Benutzerdefiniertes Datum..."
  },
  "common.dateRangeSelector.preset.fromCustomDateUntilNow": {
    "defaultMessage": "Von benutzerdefiniertem Datum bis jetzt..."
  },
  "common.dateRangeSelector.preset.last14Days": {
    "defaultMessage": "Letzte 14 Tage"
  },
  "common.dateRangeSelector.preset.last180Days": {
    "defaultMessage": "Letzte 180 Tage"
  },
  "common.dateRangeSelector.preset.last24Hours": {
    "defaultMessage": "Letzte 24 Stunden"
  },
  "common.dateRangeSelector.preset.last30Days": {
    "defaultMessage": "Letzte 30 Tage"
  },
  "common.dateRangeSelector.preset.last7Days": {
    "defaultMessage": "Letzte 7 Tage"
  },
  "common.dateRangeSelector.preset.last90Days": {
    "defaultMessage": "Letzte 90 Tage"
  },
  "common.dateRangeSelector.preset.lastHour": {
    "defaultMessage": "Letzte Stunde"
  },
  "common.dateRangeSelector.preset.lastMonth": {
    "defaultMessage": "Letzter Monat"
  },
  "common.dateRangeSelector.preset.lastNHours": {
    "defaultMessage": "Letzte {hours} Stunden"
  },
  "common.dateRangeSelector.preset.lastWeek": {
    "defaultMessage": "Letzte Woche"
  },
  "common.dateRangeSelector.preset.thisMonth": {
    "defaultMessage": "Dieser Monat"
  },
  "common.dateRangeSelector.preset.thisWeek": {
    "defaultMessage": "Diese Woche"
  },
  "common.dateRangeSelector.preset.today": {
    "defaultMessage": "Heute"
  },
  "common.dateRangeSelector.preset.yearToDate": {
    "defaultMessage": "Seit Jahresbeginn"
  },
  "common.dateRangeSelector.preset.yesterday": {
    "defaultMessage": "Gestern"
  },
  "common.dateRangeSelector.selectDateRangeTitle": {
    "defaultMessage": "Datumsbereich auswählen"
  },
  "common.dateRangeSelector.selectDateTitle": {
    "defaultMessage": "Datum auswählen"
  },
  "common.dateRangeSelector.selectedLabel": {
    "defaultMessage": "Ausgewählt: {from} – {to}"
  },
  "common.dateSelector.preset.dayMinus2": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus3": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus4": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus5": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus6": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.today": {
    "defaultMessage": "Heute"
  },
  "common.dateSelector.preset.yesterday": {
    "defaultMessage": "Gestern"
  },
  "common.dateSelector.selectDate": {
    "defaultMessage": "Datum auswählen"
  },
  "common.dateStart": {
    "defaultMessage": "Startdatum"
  },
  "common.datetime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "common.datetimeRange": {
    "defaultMessage": "Zeitraum"
  },
  "common.default": {
    "defaultMessage": "Standard"
  },
  "common.delete": {
    "defaultMessage": "Löschen"
  },
  "common.detailBtn": {
    "defaultMessage": "Details anzeigen"
  },
  "common.disabled": {
    "defaultMessage": "Deaktiviert"
  },
  "common.download": {
    "defaultMessage": "Herunterladen"
  },
  "common.duration": {
    "defaultMessage": "Dauer"
  },
  "common.edit": {
    "defaultMessage": "Bearbeiten"
  },
  "common.email": {
    "defaultMessage": "E-Mail"
  },
  "common.enabled": {
    "defaultMessage": "Aktiviert"
  },
  "common.entities.fragments": {
    "defaultMessage": "Fragmente"
  },
  "common.entities.group": {
    "defaultMessage": "Gruppe"
  },
  "common.entities.groups": {
    "defaultMessage": "Gruppen"
  },
  "common.entities.station": {
    "defaultMessage": "Sender"
  },
  "common.entities.stations": {
    "defaultMessage": "Sender"
  },
  "common.entities.user": {
    "defaultMessage": "Benutzer"
  },
  "common.error": {
    "defaultMessage": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut"
  },
  "common.errorOccurredTryAgain": {
    "defaultMessage": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut"
  },
  "common.form.errorNotification": {
    "defaultMessage": "Ein Fehler ist aufgetreten. Bitte prüfen Sie alle Felder und versuchen Sie es erneut. Wenn der Fehler bestehen bleibt, kontaktieren Sie den Support"
  },
  "common.form.saveBtnText": {
    "defaultMessage": "Speichern"
  },
  "common.frameSelector.frameSelected": {
    "defaultMessage": "Frame selected:"
  },
  "common.frameSelector.useThisFrame": {
    "defaultMessage": "Use this frame"
  },
  "common.groupBy": {
    "defaultMessage": "Gruppieren nach"
  },
  "common.help": {
    "defaultMessage": "Hilfe"
  },
  "common.hotkeys.or": {
    "defaultMessage": "or"
  },
  "common.insertContentHere": {
    "defaultMessage": "Inhalt hier einfügen"
  },
  "common.jobFailed": {
    "defaultMessage": "Auftrag fehlgeschlagen"
  },
  "common.jobInProgress": {
    "defaultMessage": "Auftrag wird ausgeführt"
  },
  "common.jobStatus.CANCELLED": {
    "defaultMessage": "Abgebrochen"
  },
  "common.jobStatus.COMPLETED": {
    "defaultMessage": "Abgeschlossen"
  },
  "common.jobStatus.FAILED": {
    "defaultMessage": "Fehlgeschlagen"
  },
  "common.jobStatus.IN_PROGRESS": {
    "defaultMessage": "In Bearbeitung"
  },
  "common.jobStatus.SCHEDULED": {
    "defaultMessage": "Geplant"
  },
  "common.jobStatus.WAITING": {
    "defaultMessage": "In Warteschlange"
  },
  "common.languageSelect.defaultLabel": {
    "defaultMessage": "Sprache"
  },
  "common.listView.clearAllFilters": {
    "defaultMessage": "Alle Filter löschen"
  },
  "common.listView.noMoreResults": {
    "defaultMessage": "No hay más resultados"
  },
  "common.listView.noResults": {
    "defaultMessage": "Keine Ergebnisse"
  },
  "common.listView.totalResults": {
    "defaultMessage": "{count, number} Ergebnisse"
  },
  "common.listView.tryOtherFiltersOrClear": {
    "defaultMessage": "Versuche andere Filter oder entferne die angewendeten, um mehr Ergebnisse zu sehen."
  },
  "common.listView.useFiltersToFindMore": {
    "defaultMessage": "Nutze die Filter, um weitere Ergebnisse zu finden"
  },
  "common.loadCoverImage": {
    "defaultMessage": "Titelbild laden"
  },
  "common.loadFile": {
    "defaultMessage": "Datei laden"
  },
  "common.loadImage": {
    "defaultMessage": "Bild laden"
  },
  "common.loadMore": {
    "defaultMessage": "Frühere anzeigen"
  },
  "common.loadThumbnail": {
    "defaultMessage": "Miniaturbild laden"
  },
  "common.loading": {
    "defaultMessage": "Wird geladen..."
  },
  "common.loadingEntity": {
    "defaultMessage": "Entität wird geladen"
  },
  "common.logout": {
    "defaultMessage": "Abmelden"
  },
  "common.name": {
    "defaultMessage": "Name"
  },
  "common.no": {
    "defaultMessage": "Nein"
  },
  "common.noOptions": {
    "defaultMessage": "Keine Ergebnisse gefunden"
  },
  "common.noResults": {
    "defaultMessage": "Keine Ergebnisse"
  },
  "common.noStations.message": {
    "defaultMessage": "Warten..."
  },
  "common.noStations.title": {
    "defaultMessage": "Es sind noch keine Sender zugewiesen"
  },
  "common.notes": {
    "defaultMessage": "Notizen"
  },
  "common.notifications.deleteError": {
    "defaultMessage": "Fehler beim Löschen"
  },
  "common.notifications.deleted": {
    "defaultMessage": "Erfolgreich gelöscht"
  },
  "common.notifications.updated": {
    "defaultMessage": "{entity} aktualisiert"
  },
  "common.optional": {
    "defaultMessage": "(optional)"
  },
  "common.pause": {
    "defaultMessage": "Pause"
  },
  "common.play": {
    "defaultMessage": "Abspielen"
  },
  "common.preview": {
    "defaultMessage": "Vorschau"
  },
  "common.quantity": {
    "defaultMessage": "Menge"
  },
  "common.refresh": {
    "defaultMessage": "Aktualisieren"
  },
  "common.remove": {
    "defaultMessage": "Entfernen"
  },
  "common.removeFilter": {
    "defaultMessage": "Filter entfernen"
  },
  "common.required": {
    "defaultMessage": "Erforderlich"
  },
  "common.routeNotFound.help": {
    "defaultMessage": "Der Link ist möglicherweise ungültig oder die Seite wurde verschoben."
  },
  "common.routeNotFound.title": {
    "defaultMessage": "Diese Seite existiert nicht"
  },
  "common.select": {
    "defaultMessage": "Auswählen"
  },
  "common.selectFileLabel": {
    "defaultMessage": "Datei auswählen {extensions}"
  },
  "common.show": {
    "defaultMessage": "Show"
  },
  "common.simpleTableAriaLabel": {
    "defaultMessage": "Datentabelle"
  },
  "common.station": {
    "defaultMessage": "Sender"
  },
  "common.stationNotFound.help": {
    "defaultMessage": "Er existiert möglicherweise nicht oder du hast keinen Zugriff darauf."
  },
  "common.stationNotFound.text": {
    "defaultMessage": "Sender nicht gefunden"
  },
  "common.stations": {
    "defaultMessage": "Sender"
  },
  "common.stations.shared.tooltip": {
    "defaultMessage": "Externer Sender"
  },
  "common.stations.type.AFFILIATE": {
    "defaultMessage": "Partner"
  },
  "common.stations.type.HEADER": {
    "defaultMessage": "Header"
  },
  "common.stations.type.REPEATER": {
    "defaultMessage": "Repeater"
  },
  "common.stations.type.STANDALONE": {
    "defaultMessage": "Eigenständig"
  },
  "common.stations.youtubeNative.tooltip": {
    "defaultMessage": "YouTube-nativer Sender"
  },
  "common.status": {
    "defaultMessage": "Status"
  },
  "common.status.active": {
    "defaultMessage": "Aktiv"
  },
  "common.status.inactive": {
    "defaultMessage": "Inaktiv"
  },
  "common.text": {
    "defaultMessage": "Text"
  },
  "common.text.actions": {
    "defaultMessage": "Aktionen"
  },
  "common.text.addFilter": {
    "defaultMessage": "Filter"
  },
  "common.text.all": {
    "defaultMessage": "Alle"
  },
  "common.text.back": {
    "defaultMessage": "Zurück"
  },
  "common.text.clear": {
    "defaultMessage": "Löschen"
  },
  "common.text.content": {
    "defaultMessage": "Inhalt"
  },
  "common.text.count": {
    "defaultMessage": "Anzahl"
  },
  "common.text.date": {
    "defaultMessage": "Datum"
  },
  "common.text.description": {
    "defaultMessage": "Beschreibung"
  },
  "common.text.duration": {
    "defaultMessage": "Dauer"
  },
  "common.text.filter": {
    "defaultMessage": "Anwenden"
  },
  "common.text.language": {
    "defaultMessage": "Sprache"
  },
  "common.text.name": {
    "defaultMessage": "Name"
  },
  "common.text.next": {
    "defaultMessage": "Weiter"
  },
  "common.text.no": {
    "defaultMessage": "Nein"
  },
  "common.text.notSet": {
    "defaultMessage": "Nicht festgelegt"
  },
  "common.text.subtitle": {
    "defaultMessage": "Untertitel"
  },
  "common.text.time": {
    "defaultMessage": "Zeit"
  },
  "common.text.timezone": {
    "defaultMessage": "Zeitzone"
  },
  "common.text.title": {
    "defaultMessage": "Titel"
  },
  "common.text.type": {
    "defaultMessage": "Typ"
  },
  "common.text.yes": {
    "defaultMessage": "Ja"
  },
  "common.thumbType": {
    "defaultMessage": "Miniaturtyp"
  },
  "common.thumbnail": {
    "defaultMessage": "Miniaturansicht"
  },
  "common.timeEnd": {
    "defaultMessage": "Endzeit"
  },
  "common.timeSelector.selectTime": {
    "defaultMessage": "Uhrzeit auswählen"
  },
  "common.timeStart": {
    "defaultMessage": "Startzeit"
  },
  "common.title": {
    "defaultMessage": "Titel"
  },
  "common.prose.showLess": {
    "defaultMessage": "Weniger anzeigen"
  },
  "common.prose.showMore": {
    "defaultMessage": "Mehr anzeigen"
  },
  "common.truncate.hide": {
    "defaultMessage": "Hide"
  },
  "common.truncate.showAll": {
    "defaultMessage": "Show all"
  },
  "common.type": {
    "defaultMessage": "Typ"
  },
  "common.updatedAt": {
    "defaultMessage": "Aktualisiert am"
  },
  "common.url": {
    "defaultMessage": "URL:"
  },
  "common.user": {
    "defaultMessage": "Benutzer"
  },
  "common.users": {
    "defaultMessage": "Benutzer"
  },
  "common.video": {
    "defaultMessage": "video"
  },
  "common.videoFrame": {
    "defaultMessage": "Videobild"
  },
  "common.visualize": {
    "defaultMessage": "Visualisieren"
  },
  "common.wizard.back": {
    "defaultMessage": "Zurück"
  },
  "common.wizard.finish": {
    "defaultMessage": "Finish"
  },
  "common.wizard.next": {
    "defaultMessage": "Weiter"
  },
  "common.yes": {
    "defaultMessage": "Ja"
  },
  "compose.createComposition.action": {
    "defaultMessage": "Komposition erstellen"
  },
  "compose.createPage.fieldName": {
    "defaultMessage": "Name"
  },
  "compose.createPage.submit": {
    "defaultMessage": "Komposition erstellen"
  },
  "compose.createPage.successToast": {
    "defaultMessage": "Komposition erstellt"
  },
  "compose.createPage.title": {
    "defaultMessage": "Komposition erstellen"
  },
  "compose.delete.message": {
    "defaultMessage": "Möchten Sie die Komposition \"{name}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "compose.delete.successToast": {
    "defaultMessage": "Komposition gelöscht"
  },
  "compose.delete.title": {
    "defaultMessage": "Komposition löschen"
  },
  "compose.editPage.successToast": {
    "defaultMessage": "Komposition aktualisiert"
  },
  "compose.editPage.title": {
    "defaultMessage": "Komposition bearbeiten"
  },
  "compose.filters.compositionName": {
    "defaultMessage": "Name der Komposition"
  },
  "compose.filters.compositionNamePending": {
    "defaultMessage": "Die Namenssuche ist verfügbar, sobald das Backend den entsprechenden Query-Parameter hinzufügt."
  },
  "compose.listCard.editsCount": {
    "defaultMessage": "{count, plural, one {# edit} other {# edits}}"
  },
  "compose.listCard.unpublished": {
    "defaultMessage": "Nicht veröffentlicht"
  },
  "compose.listEmptyState.help": {
    "defaultMessage": "Erstellen Sie eine Komposition, um zu beginnen, oder passen Sie den Namen oder den Datumsbereich an, wenn Sie filtern."
  },
  "compose.listEmptyState.message": {
    "defaultMessage": "Keine Kompositionen"
  },
  "compose.listScreen.hubLabel": {
    "defaultMessage": "Compose"
  },
  "compose.listScreen.title": {
    "defaultMessage": "Compose"
  },
  "compose.navTitle": {
    "defaultMessage": "Compose"
  },
  "compose.publish.tabTitle": {
    "defaultMessage": "Netzwerke"
  },
  "compose.videoEditions.tabTitle": {
    "defaultMessage": "Bearbeitungen"
  },
  "contentAi.articleNumber": {
    "defaultMessage": "ARTIKEL {number}"
  },
  "contentAi.articles.generateContent": {
    "defaultMessage": "Generate content"
  },
  "contentAi.articles.instructions": {
    "defaultMessage": "Instructions"
  },
  "contentAi.backToArticleSelection": {
    "defaultMessage": "Zurück zur Artikelauswahl"
  },
  "contentAi.configPerStation": {
    "defaultMessage": "Konfiguration pro Sender"
  },
  "contentAi.configTitle": {
    "defaultMessage": "Content-AI-Konfiguration"
  },
  "contentAi.contentOrigin": {
    "defaultMessage": "Inhaltsherkunft:"
  },
  "contentAi.contentsList.fragment": {
    "defaultMessage": "Fragment"
  },
  "contentAi.contentsList.source": {
    "defaultMessage": "Quelle"
  },
  "contentAi.contentsList.title": {
    "defaultMessage": "Content AI - Inhalte"
  },
  "contentAi.contentsList.view": {
    "defaultMessage": "Anzeigen"
  },
  "contentAi.copyToClipboard": {
    "defaultMessage": "In die Zwischenablage kopieren"
  },
  "contentAi.externalExportEnabled": {
    "defaultMessage": "Externer Export aktiviert"
  },
  "contentAi.fragment": {
    "defaultMessage": "Fragment"
  },
  "contentAi.fragmentContentExists": {
    "defaultMessage": "Für dieses Fragment existiert bereits ein Inhalt"
  },
  "contentAi.goToContent": {
    "defaultMessage": "Zum Inhalt"
  },
  "contentAi.instructionsOptional": {
    "defaultMessage": "Anweisungen (optional)"
  },
  "contentAi.instructionsPlaceholder": {
    "defaultMessage": "Geben Sie die Anweisungen hier ein."
  },
  "contentAi.placeholder.tone": {
    "defaultMessage": "Positiv, negativ, neutral"
  },
  "contentAi.preparingMedia": {
    "defaultMessage": "Medien werden für die Analyse vorbereitet"
  },
  "contentAi.regenerateArticles": {
    "defaultMessage": "Artikel neu generieren"
  },
  "contentAi.saveAndContinue": {
    "defaultMessage": "Speichern und fortfahren"
  },
  "contentAi.socialVersion.generateFor": {
    "defaultMessage": "Generate content for {platform}"
  },
  "contentAi.socialVersion.generatedFor": {
    "defaultMessage": "Content generated for {platform}"
  },
  "contentAi.socialVersion.publishContent": {
    "defaultMessage": "Publish content"
  },
  "contentAi.socialVersion.publishError": {
    "defaultMessage": "Beim Veröffentlichen der Version ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
  },
  "contentAi.socialVersion.regenerate": {
    "defaultMessage": "Regenerate"
  },
  "contentAi.stationConfig.addPrompt": {
    "defaultMessage": "Neuen Prompt hinzufügen"
  },
  "contentAi.stationConfig.promptsTitle": {
    "defaultMessage": "Prompts"
  },
  "contentAi.stationConfig.updated": {
    "defaultMessage": "Content-AI-Konfiguration für {stationName} aktualisiert"
  },
  "contentAi.steps.adaptAndPublish": {
    "defaultMessage": "Anpassen und in Netzwerken veröffentlichen"
  },
  "contentAi.steps.aiArticles.choosePrompt": {
    "defaultMessage": "Prompt auswählen"
  },
  "contentAi.steps.editContent": {
    "defaultMessage": "Inhalt bearbeiten"
  },
  "contentAi.steps.generateArticles": {
    "defaultMessage": "Artikel generieren"
  },
  "contentAi.title": {
    "defaultMessage": "Content AI"
  },
  "contentAi.useThisArticle": {
    "defaultMessage": "Diesen Artikel verwenden"
  },
  "contentAi.userArticle.generatedForWeb": {
    "defaultMessage": "Content generated for Web"
  },
  "contentAi.userArticle.primaryArticle": {
    "defaultMessage": "Primary article"
  },
  "contentAi.userArticle.useFooter": {
    "defaultMessage": "Use footer:"
  },
  "contentAi.viewFullArticle": {
    "defaultMessage": "Vollständigen Artikel anzeigen"
  },
  "contentAi.wizard.adaptContentTitle": {
    "defaultMessage": "Passen Sie den Inhalt an und veröffentlichen Sie ihn in den sozialen Medien."
  },
  "contentAi.wizard.almostThereTitle": {
    "defaultMessage": "Fast geschafft! Noch {count} Schritte."
  },
  "contentAi.wizard.createFragmentStep": {
    "defaultMessage": "Fragment erstellen"
  },
  "contentAi.wizard.editArticleTitle": {
    "defaultMessage": "Bearbeiten Sie Ihren Artikel zum Veröffentlichen."
  },
  "core.screen.hotkeys.description": {
    "defaultMessage": "Beschreibung"
  },
  "core.screen.hotkeys.hotkey": {
    "defaultMessage": "Tastenkürzel"
  },
  "core.screen.hotkeys.modalTitle": {
    "defaultMessage": "Tastenkürzel"
  },
  "core.screen.hotkeys.showBtnText": {
    "defaultMessage": "Tastenkürzel"
  },
  "core.sidenav.accountPopover.accountSection": {
    "defaultMessage": "Konto"
  },
  "core.sidenav.accountPopover.clientSection": {
    "defaultMessage": "Kunde"
  },
  "core.sidenav.adminIndicatorText": {
    "defaultMessage": "Admin"
  },
  "core.sidenav.collapseTooltip": {
    "defaultMessage": "Menü schließen"
  },
  "core.sidenav.darkModeTooltip": {
    "defaultMessage": "Dunkel"
  },
  "core.sidenav.defaultModeLabel": {
    "defaultMessage": "Default"
  },
  "core.sidenav.expandTooltip": {
    "defaultMessage": "Menü öffnen"
  },
  "core.sidenav.lightModeTooltip": {
    "defaultMessage": "Hell"
  },
  "core.sidenav.logoutBtnText": {
    "defaultMessage": "Abmelden"
  },
  "core.sidenav.notificationsEmpty": {
    "defaultMessage": "Keine Benachrichtigungen"
  },
  "core.sidenav.settingsBtnText": {
    "defaultMessage": "Benutzereinstellungen"
  },
  "core.sidenav.themeToggle.tour.description": {
    "defaultMessage": "Öffne das Kontomenü, um Default, Dunkel oder Hell zu wählen."
  },
  "core.sidenav.themeToggle.tour.title": {
    "defaultMessage": "Designoptionen verfügbar"
  },
  "date.justNow": {
    "defaultMessage": "Gerade eben"
  },
  "demo.stationsAdvancedFilter.noOptionsSelected": {
    "defaultMessage": "No options selected"
  },
  "demo.stationsAdvancedFilter.selectedOptions": {
    "defaultMessage": "Selected Options:"
  },
  "demo.stationsAdvancedFilter.title": {
    "defaultMessage": "Stations Advanced Filter Demo"
  },
  "featureState.connected": {
    "defaultMessage": "Integration verbunden"
  },
  "featureState.connectionConfiguredBy": {
    "defaultMessage": "Verbindung vom Benutzer konfiguriert"
  },
  "featureState.notConnected": {
    "defaultMessage": "Integration nicht verbunden"
  },
  "fleet.devices.card.lastSeen": {
    "defaultMessage": "Zuletzt gesehen {relativeTime}"
  },
  "fleet.devices.card.mapAlt": {
    "defaultMessage": "Karte von {name}"
  },
  "fleet.devices.card.noLastSeen": {
    "defaultMessage": "Nie online gesehen"
  },
  "fleet.devices.card.openAdminPanel": {
    "defaultMessage": "Admin-Panel öffnen"
  },
  "fleet.devices.card.viewOnMap": {
    "defaultMessage": "Auf Karte anzeigen"
  },
  "fleet.devices.filters.id": {
    "defaultMessage": "ID"
  },
  "fleet.devices.filters.idPlaceholder": {
    "defaultMessage": "Nach ID suchen"
  },
  "fleet.devices.filters.name": {
    "defaultMessage": "Name"
  },
  "fleet.devices.filters.namePlaceholder": {
    "defaultMessage": "Nach Namen suchen"
  },
  "fleet.devices.filters.status": {
    "defaultMessage": "Status"
  },
  "fleet.devices.listScreen.title": {
    "defaultMessage": "Devices"
  },
  "fleet.devices.pagination.rowsPerPage": {
    "defaultMessage": "Zeilen pro Seite"
  },
  "fleet.devices.status.offline": {
    "defaultMessage": "Offline"
  },
  "fleet.devices.status.online": {
    "defaultMessage": "Online"
  },
  "fleet.devices.type.airnode": {
    "defaultMessage": "AirNode"
  },
  "fleet.devices.type.streamBox": {
    "defaultMessage": "StreamBox"
  },
  "fleet.nav.title": {
    "defaultMessage": "Devices"
  },
  "form.array.addButtonLabel": {
    "defaultMessage": "Hinzufügen"
  },
  "form.array.emptyMessage": {
    "defaultMessage": "Noch keine Einträge definiert"
  },
  "form.array.fieldError": {
    "defaultMessage": "Fehler im Feld"
  },
  "form.frameThumbnailLabel": {
    "defaultMessage": "Frame als Vorschaubild verwenden"
  },
  "fragmentMedia.audio.chunkPill.unlabeledChunk": {
    "defaultMessage": "Segment {n}"
  },
  "fragments.addScreen.createAndGoShort": {
    "defaultMessage": "Erstellen und gehen"
  },
  "fragments.addScreen.createAndOpen": {
    "defaultMessage": "Erstellen und zum Fragment gehen"
  },
  "fragments.addScreen.createError": {
    "defaultMessage": "Fragment konnte nicht erstellt werden"
  },
  "fragments.addScreen.createOnly": {
    "defaultMessage": "Erstellen"
  },
  "fragments.addScreen.created": {
    "defaultMessage": "Fragment erstellt"
  },
  "fragments.addScreen.exportError": {
    "defaultMessage": "Externer Export konnte nicht gestartet werden"
  },
  "fragments.addScreen.exportMissingConnection": {
    "defaultMessage": "Export konnte nicht gestartet werden: Veröffentlichungskonto fehlt"
  },
  "fragments.addScreen.externalExportError": {
    "defaultMessage": "Externer Export konnte nicht gestartet werden"
  },
  "fragments.addScreen.goTo": {
    "defaultMessage": "Zum Fragment"
  },
  "fragments.addScreen.splitSubmit.tour.description": {
    "defaultMessage": "Über dieses Menü kannst du das Fragment erstellen und zur Detailansicht in einem Schritt gehen."
  },
  "fragments.addScreen.splitSubmit.tour.title": {
    "defaultMessage": "Erstellen und zum Fragment gehen"
  },
  "fragments.addScreen.updateError": {
    "defaultMessage": "Fragment konnte nicht aktualisiert werden"
  },
  "fragments.addScreen.updated": {
    "defaultMessage": "Fragment aktualisiert"
  },
  "fragments.card.posterProcessing": {
    "defaultMessage": "Verarbeitung"
  },
  "fragments.cloneScreen.cloneError": {
    "defaultMessage": "Fragment konnte nicht geklont werden"
  },
  "fragments.cloneScreen.cloned": {
    "defaultMessage": "Fragment geklont"
  },
  "fragments.cloneScreen.defaultTitle": {
    "defaultMessage": "{title} (Kopie)"
  },
  "fragments.cloneScreen.inputLabel": {
    "defaultMessage": "Neuer Titel"
  },
  "fragments.cloneScreen.inputRequired": {
    "defaultMessage": "Titel ist erforderlich"
  },
  "fragments.cloneScreen.title": {
    "defaultMessage": "Fragment klonen"
  },
  "fragments.contentAi.generateFromFragment": {
    "defaultMessage": "Generate content from this fragment"
  },
  "fragments.contentAi.noPermission": {
    "defaultMessage": "You do not have permission to create content"
  },
  "fragments.deleteScreen.deleteError": {
    "defaultMessage": "Fragment konnte nicht gelöscht werden"
  },
  "fragments.deleteScreen.deleted": {
    "defaultMessage": "Fragment gelöscht"
  },
  "fragments.deleteScreen.prompt": {
    "defaultMessage": "Möchten Sie das Fragment <b>{title}</b> löschen? {br} Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "fragments.deleteScreen.title": {
    "defaultMessage": "Fragment löschen"
  },
  "fragments.delivery.destinationStation": {
    "defaultMessage": "Zielstation"
  },
  "fragments.delivery.exportStartError": {
    "defaultMessage": "Beim Starten des Exports ist ein Fehler aufgetreten, bitte kontaktieren Sie den Support (Status: {status})"
  },
  "fragments.delivery.exportStarted": {
    "defaultMessage": "Export gestartet"
  },
  "fragments.delivery.savedAt": {
    "defaultMessage": "Gespeichert unter {uri}"
  },
  "fragments.deliveryStatus.destinationStationLabel": {
    "defaultMessage": "Zielsender"
  },
  "fragments.deliveryStatus.enable": {
    "defaultMessage": "Externen Export aktivieren"
  },
  "fragments.deliveryStatus.none": {
    "defaultMessage": "Fragment nicht exportiert"
  },
  "fragments.deliveryStatus.start": {
    "defaultMessage": "Externen Export starten"
  },
  "fragments.export.audioMp3GeneratingTooltip": {
    "defaultMessage": "MP3-Generierung läuft"
  },
  "fragments.export.downloadAudioMp3": {
    "defaultMessage": "Audio herunterladen (MP3)"
  },
  "fragments.export.downloadMedia": {
    "defaultMessage": "Download {type}"
  },
  "fragments.export.downloadMediaAudioAac": {
    "defaultMessage": "Download {type} (aac)"
  },
  "fragments.export.export": {
    "defaultMessage": "Export"
  },
  "fragments.export.publish": {
    "defaultMessage": "Publish"
  },
  "fragments.export.publishError": {
    "defaultMessage": "Beim Veröffentlichen ist ein Fehler aufgetreten"
  },
  "fragments.export.publishingInProgress": {
    "defaultMessage": "Veröffentlichung läuft..."
  },
  "fragments.export.videoNotPublished": {
    "defaultMessage": "Video nicht veröffentlicht"
  },
  "fragments.exportStatus.error": {
    "defaultMessage": "Beim Export ist ein Fehler aufgetreten. Kontaktieren Sie den Support."
  },
  "fragments.exportStatus.externalExportNotEnabled": {
    "defaultMessage": "Der externe Export ist nicht aktiviert, bitte kontaktieren Sie den Support."
  },
  "fragments.exportStatus.initialize": {
    "defaultMessage": "Export zum konfigurierten Speicher starten"
  },
  "fragments.exportStatus.none": {
    "defaultMessage": "Fragment noch nicht exportiert"
  },
  "fragments.exportStatus.process": {
    "defaultMessage": "Fragment wird exportiert..."
  },
  "fragments.exportStatus.ready": {
    "defaultMessage": "Bereit"
  },
  "fragments.exportStatus.readyMsg": {
    "defaultMessage": "Export bereit"
  },
  "fragments.exportStatus.title": {
    "defaultMessage": "Externer Export"
  },
  "fragments.exportStatus.waiting": {
    "defaultMessage": "Warten auf Medien zum Start des Exports"
  },
  "fragments.exportView.tabExternalExport": {
    "defaultMessage": "Export"
  },
  "fragments.exportView.tabFiles": {
    "defaultMessage": "Dateien"
  },
  "fragments.exportView.tabPublish": {
    "defaultMessage": "Netzwerke"
  },
  "fragments.exportView.tabSocialExport": {
    "defaultMessage": "Social Export"
  },
  "fragments.exportView.title": {
    "defaultMessage": "Export"
  },
  "fragments.externalExport.exportStartError": {
    "defaultMessage": "Beim Starten des Exports ist ein Fehler aufgetreten, bitte wenden Sie sich an den Support (Status: {status})"
  },
  "fragments.externalExport.exportStarted": {
    "defaultMessage": "Export gestartet"
  },
  "fragments.externalExport.targetStation": {
    "defaultMessage": "Zielsender"
  },
  "fragments.filter.hasContentAi": {
    "defaultMessage": "Contenido AI"
  },
  "fragments.filter.hasExternalDelivery": {
    "defaultMessage": "Externer Export"
  },
  "fragments.filter.onlyMine": {
    "defaultMessage": "Nur meine"
  },
  "fragments.filter.publishedPlatforms": {
    "defaultMessage": "Plataformas publicadas"
  },
  "fragments.filters.dateRange": {
    "defaultMessage": "Datumsbereich"
  },
  "fragments.form.addEmoji": {
    "defaultMessage": "Add emoji"
  },
  "fragments.form.description.placeholder": {
    "defaultMessage": "z. B.: Aufgenommen im Luschniki-Stadion in Moskau während der WM"
  },
  "fragments.form.emojiPickerOk": {
    "defaultMessage": "OK"
  },
  "fragments.form.emojiSearchPlaceholder": {
    "defaultMessage": "Suchen"
  },
  "fragments.form.footer.placeholder": {
    "defaultMessage": "Add footer"
  },
  "fragments.form.header": {
    "defaultMessage": "Fragment erstellen"
  },
  "fragments.form.header.noRangeSelected": {
    "defaultMessage": "Kein Bereich ausgewählt"
  },
  "fragments.form.publishOn": {
    "defaultMessage": "Schnell veröffentlichen"
  },
  "fragments.form.tags.label": {
    "defaultMessage": "Tags (kommagetrennt)"
  },
  "fragments.form.tags.placeholder": {
    "defaultMessage": "z. B.: Interview, Messi, Weltmeisterschaft, Moskau"
  },
  "fragments.form.title.placeholder": {
    "defaultMessage": "z. B.: Interview mit Messi"
  },
  "fragments.form.useFooter": {
    "defaultMessage": "Use footer:"
  },
  "fragments.form.useTags": {
    "defaultMessage": "Use tags:"
  },
  "fragments.info.moreInfo": {
    "defaultMessage": "+INFO"
  },
  "fragments.list.filterCreatedBy": {
    "defaultMessage": "Erstellt von"
  },
  "fragments.list.filterTag": {
    "defaultMessage": "Tag"
  },
  "fragments.list.filterTitle": {
    "defaultMessage": "Titel"
  },
  "fragments.listScreen.allFragments": {
    "defaultMessage": "Fragmente"
  },
  "fragments.listScreen.completed": {
    "defaultMessage": "Abgeschlossen"
  },
  "fragments.listScreen.contentAiCreated": {
    "defaultMessage": "Mit Content AI erstellt"
  },
  "fragments.listScreen.externalExport": {
    "defaultMessage": "externer Export"
  },
  "fragments.listScreen.failed": {
    "defaultMessage": "Fehlgeschlagen beim Senden an"
  },
  "fragments.listScreen.scheduled": {
    "defaultMessage": "Geplant"
  },
  "fragments.listScreen.sentTo": {
    "defaultMessage": "Gesendet an"
  },
  "fragments.listScreen.statuses": {
    "defaultMessage": "Status"
  },
  "fragments.listScreen.unpublished": {
    "defaultMessage": "Nicht veröffentlicht"
  },
  "fragments.listV3.empty": {
    "defaultMessage": "Keine Fragmente"
  },
  "fragments.listV3.layout.compact": {
    "defaultMessage": "Kompakte Ansicht"
  },
  "fragments.listV3.layout.large": {
    "defaultMessage": "Weite Ansicht"
  },
  "fragments.listV3.layout.normal": {
    "defaultMessage": "Normale Ansicht"
  },
  "fragments.listV3.rowsPerPage": {
    "defaultMessage": "Zeilen pro Seite"
  },
  "fragments.listV3.section.previous": {
    "defaultMessage": "Früher"
  },
  "fragments.listV3.section.today": {
    "defaultMessage": "Heute"
  },
  "fragments.listV3.section.yesterday": {
    "defaultMessage": "Gestern"
  },
  "fragments.listV3.tour.addFilter.description": {
    "defaultMessage": "Fügen Sie Filter wie KI-Inhalt, externer Export und veröffentlichte Plattformen über diese Schaltfläche hinzu, um die Fragmentliste einzugrenzen."
  },
  "fragments.listV3.tour.addFilter.title": {
    "defaultMessage": "Neue Filter verfügbar"
  },
  "fragments.listV3.tour.viewToggle.description": {
    "defaultMessage": "Wechseln Sie zwischen Liste und Raster (breit, normal oder kompakt), um Fragmente nach Ihren Wünschen anzuzeigen."
  },
  "fragments.listV3.tour.viewToggle.title": {
    "defaultMessage": "Fragmentansicht"
  },
  "fragments.listV3.useFilterToFind": {
    "defaultMessage": "Nutze die Filter, um weitere Ausschnitte zu finden"
  },
  "fragments.listV3.view.grid": {
    "defaultMessage": "Raster"
  },
  "fragments.listV3.view.list": {
    "defaultMessage": "Liste"
  },
  "fragments.mediaStatus.error": {
    "defaultMessage": "Beim Erzeugen der Medien ist ein Fehler aufgetreten. Kontaktieren Sie den Support."
  },
  "fragments.mediaStatus.ready": {
    "defaultMessage": "Fragment-Medien korrekt erzeugt"
  },
  "fragments.mediaStatus.regenerate": {
    "defaultMessage": "Kein Fortschritt? Medien neu erzeugen"
  },
  "fragments.mediaStatus.regenerateError": {
    "defaultMessage": "Medien konnten nicht neu erzeugt werden"
  },
  "fragments.mediaStatus.regenerateStarted": {
    "defaultMessage": "Regenerierung der Fragment-Medien gestartet"
  },
  "fragments.mediaStatus.title": {
    "defaultMessage": "Mediendatei"
  },
  "fragments.mediaStatus.waiting": {
    "defaultMessage": "Medien werden erzeugt"
  },
  "fragments.props.basicInfo": {
    "defaultMessage": "Basisinformationen"
  },
  "fragments.props.createdBy": {
    "defaultMessage": "Erstellt von"
  },
  "fragments.props.date": {
    "defaultMessage": "Datum"
  },
  "fragments.props.dateTime": {
    "defaultMessage": "Datum und Uhrzeit"
  },
  "fragments.props.description": {
    "defaultMessage": "Beschreibung"
  },
  "fragments.props.endTime": {
    "defaultMessage": "Endzeit"
  },
  "fragments.props.startTime": {
    "defaultMessage": "Startzeit"
  },
  "fragments.props.tag": {
    "defaultMessage": "Tag"
  },
  "fragments.props.tags": {
    "defaultMessage": "Tags"
  },
  "fragments.props.title": {
    "defaultMessage": "Titel"
  },
  "fragments.subtitlesStatus.add": {
    "defaultMessage": "Sprecher-ID hinzufügen"
  },
  "fragments.subtitlesStatus.download": {
    "defaultMessage": "Untertitel herunterladen"
  },
  "fragments.subtitlesStatus.error": {
    "defaultMessage": "Beim Erzeugen der Untertitel ist ein Fehler aufgetreten. Kontaktieren Sie den Support."
  },
  "fragments.subtitlesStatus.formatJson": {
    "defaultMessage": ".JSON"
  },
  "fragments.subtitlesStatus.formatSrt": {
    "defaultMessage": ".SRT"
  },
  "fragments.subtitlesStatus.formatTxt": {
    "defaultMessage": ".TXT"
  },
  "fragments.subtitlesStatus.ready": {
    "defaultMessage": "Fragment-Untertitel korrekt erzeugt"
  },
  "fragments.subtitlesStatus.title": {
    "defaultMessage": "Untertitel"
  },
  "fragments.subtitlesStatus.waiting": {
    "defaultMessage": "Untertitel werden erzeugt"
  },
  "fragments.title": {
    "defaultMessage": "Fragmente"
  },
  "fragments.transcription.canceled": {
    "defaultMessage": "Transkription abgebrochen"
  },
  "fragments.transcription.errorUpdateFragment": {
    "defaultMessage": "Beim Aktualisieren des Fragments ist ein Fehler aufgetreten"
  },
  "fragments.transcription.errorUpdateSpeaker": {
    "defaultMessage": "Beim Aktualisieren des Sprechers {speaker} ist ein Fehler aufgetreten"
  },
  "fragments.transcription.panelTitle": {
    "defaultMessage": "Transkription"
  },
  "fragments.transcription.replace": {
    "defaultMessage": "Replace"
  },
  "fragments.transcription.replaceAll": {
    "defaultMessage": "Replace all"
  },
  "fragments.transcription.v2.editModeLabel": {
    "defaultMessage": "Bearbeiten"
  },
  "fragments.transcription.v2.editModeTooltipOff": {
    "defaultMessage": "Bearbeitungsmodus: aus"
  },
  "fragments.transcription.v2.editModeTooltipOn": {
    "defaultMessage": "Bearbeitungsmodus: an"
  },
  "fragments.transcription.v2.editSaveError": {
    "defaultMessage": "Wort konnte nicht gespeichert werden. Bitte erneut versuchen."
  },
  "fragments.transcription.v2.efficiencyTooltipOff": {
    "defaultMessage": "Effizienz pro Wort: inaktiv"
  },
  "fragments.transcription.v2.efficiencyTooltipOn": {
    "defaultMessage": "Effizienz pro Wort: aktiv"
  },
  "fragments.transcription.v2.searchNoMatches": {
    "defaultMessage": "Keine Treffer"
  },
  "fragments.transcription.v2.searchTooltipOff": {
    "defaultMessage": "Suche: aus"
  },
  "fragments.transcription.v2.searchTooltipOn": {
    "defaultMessage": "Suche: an"
  },
  "fragments.transcription.v2.syncTooltipOff": {
    "defaultMessage": "Transkription mit Wiedergabe synchronisieren: inaktiv"
  },
  "fragments.transcription.v2.syncTooltipOn": {
    "defaultMessage": "Transkription mit Wiedergabe synchronisieren: aktiv"
  },
  "fragments.transcription.waitingForMedia": {
    "defaultMessage": "Waiting for fragment media generation..."
  },
  "fragments.transcriptionStart.btnText": {
    "defaultMessage": "Fragment transkribieren"
  },
  "fragments.transcriptionStart.cancelBtn": {
    "defaultMessage": "Transkription abbrechen"
  },
  "fragments.transcriptionStart.cancelCancel": {
    "defaultMessage": "Nein, Verarbeitung fortsetzen"
  },
  "fragments.transcriptionStart.cancelConfirm": {
    "defaultMessage": "Ja, Transkription abbrechen"
  },
  "fragments.transcriptionStart.cancelPrompt": {
    "defaultMessage": "Möchten Sie die laufende Transkription wirklich abbrechen?"
  },
  "fragments.transcriptionStart.modalTitle": {
    "defaultMessage": "Fragment transkribieren"
  },
  "fragments.transcriptionStart.notice": {
    "defaultMessage": "Hinweis: Transkriptionen können lange dauern und zusätzliche Kosten verursachen"
  },
  "fragments.transcriptionStart.retry": {
    "defaultMessage": "Transkription erneut versuchen"
  },
  "fragments.transcriptionStart.startBtn": {
    "defaultMessage": "Starten"
  },
  "fragments.transcriptionStart.started": {
    "defaultMessage": "Transkription gestartet"
  },
  "fragments.transcriptionStart.startedBtn": {
    "defaultMessage": "Gestartet"
  },
  "fragments.transcriptionView.noTranscription": {
    "defaultMessage": "Dieses Fragment wurde noch nicht transkribiert"
  },
  "fragments.video.subtitlesTrackLabel": {
    "defaultMessage": "Untertitel"
  },
  "fragments.view.descriptionTitle": {
    "defaultMessage": "Beschreibung"
  },
  "fragments.view.metadata.openInLogger": {
    "defaultMessage": "Im Logger öffnen:"
  },
  "fragments.view.metadata.goToStream": {
    "defaultMessage": "Start"
  },
  "fragments.view.metadata.goToStreamFromPlayback": {
    "defaultMessage": "Aktuelle Zeit"
  },
  "fragments.view.metadata.goToStreamWithSelection": {
    "defaultMessage": "Auswahl"
  },
  "fragments.view.regenerateMedia": {
    "defaultMessage": "Medien neu erzeugen"
  },
  "fragments.viewScreen.mediaNotReadyTooltip": {
    "defaultMessage": "Warten auf Medien des Fragments"
  },
  "fragments.viewScreen.noDescription": {
    "defaultMessage": "Keine Beschreibung"
  },
  "fragments.viewScreen.noTags": {
    "defaultMessage": "Keine Tags"
  },
  "fragments.viewScreen.noUser": {
    "defaultMessage": "Kein Benutzer"
  },
  "fragments.viewScreen.title": {
    "defaultMessage": "Info"
  },
  "fragments.viewScreen.transcriptionNotReadyTooltip": {
    "defaultMessage": "Warten auf Transkription des Fragments"
  },
  "fragments.wordEditor.tooltipHelp": {
    "defaultMessage": "Eingabe zum Speichern oder Escape zum Abbrechen"
  },
  "globalLivePlayer.title": {
    "defaultMessage": "Live-Player"
  },
  "impersonation.currentUserTitle": {
    "defaultMessage": "Aktueller Benutzer"
  },
  "impersonation.deleteAriaLabel": {
    "defaultMessage": "Löschen"
  },
  "impersonation.recentUsersTitle": {
    "defaultMessage": "Kürzlich impersonierte Benutzer"
  },
  "itemsViewLayout.gridCompact": {
    "defaultMessage": "Kompakte Raster"
  },
  "itemsViewLayout.gridNormal": {
    "defaultMessage": "Normale Raster"
  },
  "itemsViewLayout.gridWide": {
    "defaultMessage": "Breite Raster"
  },
  "itemsViewLayout.list": {
    "defaultMessage": "Liste"
  },
  "jointFragments.chunkLabel.edit": {
    "defaultMessage": "Bezeichnung bearbeiten"
  },
  "jointFragments.chunkLabel.field": {
    "defaultMessage": "Neue Bezeichnung"
  },
  "jointFragments.chunkLabel.modalTitle": {
    "defaultMessage": "Segmentbezeichnung setzen"
  },
  "jointFragments.editorScreen.chunkActions.delete": {
    "defaultMessage": "Dieses Segment löschen"
  },
  "jointFragments.editorScreen.chunkActions.moveAfter": {
    "defaultMessage": "Danach verschieben"
  },
  "jointFragments.editorScreen.chunkActions.moveBefore": {
    "defaultMessage": "Davor verschieben"
  },
  "jointFragments.editorScreen.noChunks": {
    "defaultMessage": "Dem Fragment wurden noch keine Segmente hinzugefügt"
  },
  "jointFragments.editorScreen.title": {
    "defaultMessage": "Editor"
  },
  "jointFragments.editorScreen.toolbar.create": {
    "defaultMessage": "Fragment erstellen"
  },
  "jointFragments.form.description.placeholder": {
    "defaultMessage": "z. B.: Aufgenommen im Radio City mit dem Journalisten Pepe López"
  },
  "jointFragments.form.externalExport.allowedLabel": {
    "defaultMessage": "Externer Export"
  },
  "jointFragments.form.tags.label": {
    "defaultMessage": "Tags (kommagetrennt)"
  },
  "jointFragments.form.tags.placeholder": {
    "defaultMessage": "z. B.: Interview, Messi, Qualifikation"
  },
  "jointFragments.form.title.placeholder": {
    "defaultMessage": "z. B.: Podcast-Interview mit Messi"
  },
  "jointFragments.overview.closeEditor": {
    "defaultMessage": "Editor schließen"
  },
  "jointFragments.overview.createNew": {
    "defaultMessage": "Neues Fragment erstellen"
  },
  "jointFragments.overview.detailLink": {
    "defaultMessage": "Fragmentdetails anzeigen"
  },
  "jointFragments.overview.message": {
    "defaultMessage": "Fragment wurde gespeichert"
  },
  "jointFragments.props.chunk": {
    "defaultMessage": "Segment"
  },
  "jointFragments.props.description": {
    "defaultMessage": "Beschreibung"
  },
  "livePlayer.pin": {
    "defaultMessage": "Player in App anheften"
  },
  "livePlayer.toggle.mode.fullscreen": {
    "defaultMessage": "Open in fullscreen"
  },
  "livePlayer.toggle.mode.inline": {
    "defaultMessage": "Open in thumbnail"
  },
  "livePlayer.toggle.tooltip": {
    "defaultMessage": "LIVE öffnen"
  },
  "livePlayer.unpin": {
    "defaultMessage": "Player lösen"
  },
  "logger.auditControls.audioMatches": {
    "defaultMessage": "Audio-Treffer"
  },
  "logger.auditControls.mentionMatches": {
    "defaultMessage": "Erwähnungs-Treffer"
  },
  "logger.diarization.confidence": {
    "defaultMessage": "Konfidenz"
  },
  "logger.downloadingSegments": {
    "defaultMessage": "Segmente werden heruntergeladen {progress}%"
  },
  "logger.liveMentions.showMention": {
    "defaultMessage": "Erwähnung anzeigen"
  },
  "logger.navLabel": {
    "defaultMessage": "Logger"
  },
  "logger.persons.empty": {
    "defaultMessage": "Keine Personen in diesem Zeitraum erkannt"
  },
  "logger.persons.filter.all": {
    "defaultMessage": "Alle"
  },
  "logger.persons.filter.face": {
    "defaultMessage": "Mit Gesicht"
  },
  "logger.persons.filter.unknown": {
    "defaultMessage": "Nicht identifiziert"
  },
  "logger.persons.filter.voice": {
    "defaultMessage": "Mit Stimme"
  },
  "logger.persons.source.face": {
    "defaultMessage": "Gesicht"
  },
  "logger.persons.source.voice": {
    "defaultMessage": "Stimme"
  },
  "logger.persons.table.appearances": {
    "defaultMessage": "Auftritte"
  },
  "logger.persons.table.appearancesDetail": {
    "defaultMessage": "Auftrittsdetails"
  },
  "logger.persons.table.confidence": {
    "defaultMessage": "Konfidenz"
  },
  "logger.persons.table.onScreen": {
    "defaultMessage": "Im Bild"
  },
  "logger.persons.table.sources": {
    "defaultMessage": "Quellen"
  },
  "logger.persons.table.speaking": {
    "defaultMessage": "Spricht"
  },
  "logger.persons.table.timeline": {
    "defaultMessage": "Auftritte im Fokus"
  },
  "logger.persons.track.collapse": {
    "defaultMessage": "Einklappen"
  },
  "logger.persons.track.lanes": {
    "defaultMessage": "Nach Person anzeigen"
  },
  "logger.persons.track.more": {
    "defaultMessage": "+{count} weitere"
  },
  "logger.persons.track.title": {
    "defaultMessage": "Personen"
  },
  "logger.persons.unknown": {
    "defaultMessage": "Nicht identifizierte Person"
  },
  "logger.reports.loggerReportsTitle": {
    "defaultMessage": "Logger-Berichte"
  },
  "logger.reports.streamQuality.availability.rangeBrush.label": {
    "defaultMessage": "Bereich anpassen"
  },
  "logger.reports.streamQuality.availability.rangeBrush.resetFullRange": {
    "defaultMessage": "Vollen Berichtszeitraum anzeigen"
  },
  "logger.reports.streamQuality.availability.sectionTitle": {
    "defaultMessage": "Verfügbarkeit pro Sender"
  },
  "logger.reports.streamQuality.availability.table.action.openLogger": {
    "defaultMessage": "Logger zu diesem Zeitpunkt öffnen"
  },
  "logger.reports.streamQuality.availability.table.col.duration": {
    "defaultMessage": "Dauer"
  },
  "logger.reports.streamQuality.availability.table.col.end": {
    "defaultMessage": "Ende"
  },
  "logger.reports.streamQuality.availability.table.col.issueType": {
    "defaultMessage": "Typ"
  },
  "logger.reports.streamQuality.availability.table.col.start": {
    "defaultMessage": "Beginn"
  },
  "logger.reports.streamQuality.availability.table.col.station": {
    "defaultMessage": "Sender"
  },
  "logger.reports.streamQuality.availability.table.empty": {
    "defaultMessage": "Keine Vorfälle oder Ausfälle in diesem Zeitraum."
  },
  "logger.reports.streamQuality.availability.tooltip.clickOpenLogger": {
    "defaultMessage": "Klicken, um im Logger anzuzeigen"
  },
  "logger.reports.streamQuality.availability.tooltip.duration": {
    "defaultMessage": "Dauer: {duration}"
  },
  "logger.reports.streamQuality.availability.tooltip.gap": {
    "defaultMessage": "Keine Ausstrahlung"
  },
  "logger.reports.streamQuality.availability.tooltip.issueKind.poorQuality": {
    "defaultMessage": "Schlechte Qualität"
  },
  "logger.reports.streamQuality.availability.tooltip.issueKind.silent": {
    "defaultMessage": "Stille"
  },
  "logger.reports.streamQuality.availability.tooltip.range": {
    "defaultMessage": "{from} – {to}"
  },
  "logger.reports.streamQuality.availability.tooltip.station": {
    "defaultMessage": "Sender: {stationId}"
  },
  "logger.reports.streamQuality.emptyState.help": {
    "defaultMessage": "Wählen Sie Zeitraum und Sender aus, um den Bericht zu erstellen."
  },
  "logger.reports.streamQuality.emptyState.title": {
    "defaultMessage": "Sie haben den Bericht noch nicht erstellt"
  },
  "logger.reports.streamQuality.form.dateRangeLabel": {
    "defaultMessage": "Datumsbereich"
  },
  "logger.reports.streamQuality.form.stationsLabel": {
    "defaultMessage": "Sender"
  },
  "logger.reports.streamQuality.form.stationsPlaceholder": {
    "defaultMessage": "Alle Sender"
  },
  "logger.reports.streamQuality.kpis.continuityIncidentDurationAvg": {
    "defaultMessage": "Durchschnittliche Dauer der Kontinuitätsvorfälle"
  },
  "logger.reports.streamQuality.kpis.continuityIncidentsTotal": {
    "defaultMessage": "Kontinuitätsvorfälle"
  },
  "logger.reports.streamQuality.kpis.healthScore": {
    "defaultMessage": "Gesundheitswert"
  },
  "logger.reports.streamQuality.kpis.qualityAvgNotApplicable": {
    "defaultMessage": "—"
  },
  "logger.reports.streamQuality.kpis.qualityIncidentDurationAvg": {
    "defaultMessage": "Durchschnittliche Dauer der Qualitätsvorfälle"
  },
  "logger.reports.streamQuality.kpis.qualityIncidentsTotal": {
    "defaultMessage": "Qualitätsvorfälle"
  },
  "logger.reports.streamQuality.kpis.stationsWithContinuityIncidents": {
    "defaultMessage": "Stationen mit Kontinuitätsvorfällen"
  },
  "logger.reports.streamQuality.kpis.stationsWithIncidents": {
    "defaultMessage": "Stationen mit Vorfällen"
  },
  "logger.reports.streamQuality.kpis.stationsWithQualityIncidents": {
    "defaultMessage": "Stationen mit Qualitätsvorfällen"
  },
  "logger.reports.streamQuality.pageTitle": {
    "defaultMessage": "Stream-Qualitätsbericht"
  },
  "logger.reports.streamQuality.stationStatusFilter.disabledAnalysisIntervalsLegend": {
    "defaultMessage": "= Intervall ohne Qualitätsprüfung"
  },
  "logger.reports.streamQuality.stationStatusFilter.discontinuity": {
    "defaultMessage": "Unterbrechung"
  },
  "logger.reports.streamQuality.stationStatusFilter.filterByIncidentsLabel": {
    "defaultMessage": "Nach Vorfällen filtern: "
  },
  "logger.reports.streamQuality.stationStatusFilter.noIncidents": {
    "defaultMessage": "Keine Vorfälle"
  },
  "logger.reports.streamQuality.stationStatusFilter.noMatchingStations": {
    "defaultMessage": "Keine Sender entsprechen den ausgewählten Filtern. Wählen Sie eine andere Kombination."
  },
  "logger.reports.streamQuality.stationStatusFilter.poorQuality": {
    "defaultMessage": "Schlechte Qualität"
  },
  "logger.reports.streamQuality.stationStatusFilter.silent": {
    "defaultMessage": "Stille"
  },
  "logger.reports.streamQuality.tabLabel": {
    "defaultMessage": "Streamqualität"
  },
  "logger.sidenav.panorama": {
    "defaultMessage": "Panorama"
  },
  "logger.sidenav.reportes": {
    "defaultMessage": "Berichte"
  },
  "logger.sidenav.youtube": {
    "defaultMessage": "YouTube"
  },
  "logger.status.filter.all": {
    "defaultMessage": "Alle"
  },
  "logger.status.filter.offline": {
    "defaultMessage": "Offline"
  },
  "logger.status.filter.online": {
    "defaultMessage": "Online"
  },
  "logger.statusScreen.cleanFilters": {
    "defaultMessage": "Filter löschen"
  },
  "logger.statusScreen.count": {
    "defaultMessage": "{count, plural, =0 {Keine Sender gefunden} one {1 Sender gefunden} other {# Sender gefunden} }"
  },
  "logger.statusScreen.enterFullscreen": {
    "defaultMessage": "Vollbild"
  },
  "logger.statusScreen.exitFullscreen": {
    "defaultMessage": "Vollbild beenden"
  },
  "logger.statusScreen.favoritesSection": {
    "defaultMessage": "Favoriten ({count})"
  },
  "logger.statusScreen.groupSection": {
    "defaultMessage": "{name} ({count})"
  },
  "logger.statusScreen.loading": {
    "defaultMessage": "Logger-Status wird geladen"
  },
  "logger.statusScreen.myStationsSection": {
    "defaultMessage": "Meine Sender ({count})"
  },
  "logger.statusScreen.noActivity": {
    "defaultMessage": "Keine aktuelle Aktivität registriert"
  },
  "logger.statusScreen.sharedStationsSection": {
    "defaultMessage": "Externe Sender ({count})"
  },
  "logger.statusScreen.stationAccess": {
    "defaultMessage": "Senderzugriff"
  },
  "logger.statusScreen.stationAccessOwned": {
    "defaultMessage": "Meine Sender"
  },
  "logger.statusScreen.stationAccessShared": {
    "defaultMessage": "Externe Sender"
  },
  "logger.statusScreen.stationType": {
    "defaultMessage": "Sendertyp"
  },
  "logger.statusScreen.stationTypeRadio": {
    "defaultMessage": "Radio"
  },
  "logger.statusScreen.stationTypeTv": {
    "defaultMessage": "TV"
  },
  "logger.statusScreen.stationTypeYoutube": {
    "defaultMessage": "YouTube"
  },
  "logger.statusScreen.statusActivity": {
    "defaultMessage": "Status"
  },
  "logger.statusScreen.title": {
    "defaultMessage": "Panorama"
  },
  "logger.statusScreen.tour.viewToggle.description": {
    "defaultMessage": "Wechseln Sie zwischen Liste und Raster (breit, normal oder kompakt), um Stationen nach Ihren Wünschen anzuzeigen."
  },
  "logger.statusScreen.tour.viewToggle.title": {
    "defaultMessage": "Stationsansicht"
  },
  "logger.statusScreen.viewGrid2": {
    "defaultMessage": "2 Spalten"
  },
  "logger.statusScreen.viewGrid3": {
    "defaultMessage": "3 Spalten"
  },
  "logger.statusScreen.viewGrid4": {
    "defaultMessage": "4 Spalten"
  },
  "logger.statusScreen.viewList": {
    "defaultMessage": "Liste"
  },
  "logger.statusScreen.viewMode": {
    "defaultMessage": "Ansichtsmodus"
  },
  "logger.statusScreen.youtubeNative.last24h": {
    "defaultMessage": "Letzte 24 Stunden"
  },
  "logger.statusScreen.youtubeNative.last72h": {
    "defaultMessage": "Letzte 72 Stunden"
  },
  "logger.statusScreen.youtubeNative.noEmissionInProgress": {
    "defaultMessage": "Keine Sendung in Betrieb"
  },
  "logger.statusScreen.youtubeNative.noRecentBroadcastsHelp": {
    "defaultMessage": "In den letzten 24 Stunden wurden keine Übertragungen registriert."
  },
  "logger.statusScreen.youtubeNative.offline": {
    "defaultMessage": "OFFLINE"
  },
  "logger.statusScreen.youtubeNative.peakViewersTooltip": {
    "defaultMessage": "{count} Zuschauer (Höchststand)"
  },
  "logger.statusScreen.youtubeNative.recentTransmissions": {
    "defaultMessage": "Letzte Übertragungen"
  },
  "logger.statusScreen.youtubeNative.today": {
    "defaultMessage": "Heute"
  },
  "logger.statusScreen.youtubeNative.yesterday": {
    "defaultMessage": "Gestern"
  },
  "logger.streamBox.goToDevice": {
    "defaultMessage": "Zum Gerät"
  },
  "logger.streamScreen.audit.adOverlayLabel": {
    "defaultMessage": "Ad Overlay"
  },
  "logger.streamScreen.auditControls.adOverlay": {
    "defaultMessage": "Werbefläche"
  },
  "logger.streamScreen.auditControls.liveTopics": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.auditControls.youTubeViewers": {
    "defaultMessage": "YouTube-Zuschauer"
  },
  "logger.streamScreen.autoOpenFragment.never": {
    "defaultMessage": "Nie"
  },
  "logger.streamScreen.autoOpenFragment.onStartAndEnd": {
    "defaultMessage": "Beim Markieren von Start und Ende"
  },
  "logger.streamScreen.autoOpenFragment.onStartOrEnd": {
    "defaultMessage": "Beim Markieren von Start oder Ende"
  },
  "logger.streamScreen.controls.liveIndicator": {
    "defaultMessage": "Live"
  },
  "logger.streamScreen.controls.loadLatestBtn": {
    "defaultMessage": "Neueste Aufnahme laden"
  },
  "logger.streamScreen.controls.partialSegmentCoverage.tooltip": {
    "defaultMessage": "Für den gesamten ausgewählten Zeitraum ist keine Sendung verfügbar. Es wird nur der Teil des Zeitraums angezeigt, in dem gesendet wurde. (Verfügbarer Zeitraum: {fromTime} - {toTime})"
  },
  "logger.streamScreen.controls.playLive": {
    "defaultMessage": "Live-Stream abspielen"
  },
  "logger.streamScreen.controls.stop": {
    "defaultMessage": "Stopp"
  },
  "logger.streamScreen.controls.timeMove.back15m": {
    "defaultMessage": "-15m"
  },
  "logger.streamScreen.controls.timeMove.back1h": {
    "defaultMessage": "-1h"
  },
  "logger.streamScreen.controls.timeMove.forward15m": {
    "defaultMessage": "+15m"
  },
  "logger.streamScreen.controls.timeMove.forward1h": {
    "defaultMessage": "+1h"
  },
  "logger.streamScreen.controls.updated": {
    "defaultMessage": "Aktualisiert <time>{time}</time>"
  },
  "logger.streamScreen.controls.youtubeBroadcastsList": {
    "defaultMessage": "Alle Übertragungen anzeigen"
  },
  "logger.streamScreen.controls.youtubeLiveViewers": {
    "defaultMessage": "{count} Live-Zuschauer"
  },
  "logger.streamScreen.copyCursorAt": {
    "defaultMessage": "Link mit Zeitstempel {value} kopieren"
  },
  "logger.streamScreen.copyCursorLinkCopied": {
    "defaultMessage": "Link in die Zwischenablage kopiert"
  },
  "logger.streamScreen.cursorMenu.cancel": {
    "defaultMessage": "Abbrechen"
  },
  "logger.streamScreen.cursorMenu.endSelection": {
    "defaultMessage": "Auswahl hier beenden"
  },
  "logger.streamScreen.cursorMenu.pause": {
    "defaultMessage": "Pause"
  },
  "logger.streamScreen.cursorMenu.play": {
    "defaultMessage": "Ab Cursor/Abspielposition abspielen"
  },
  "logger.streamScreen.cursorMenu.startSelection": {
    "defaultMessage": "Auswahl hier beginnen"
  },
  "logger.streamScreen.downloadMedia.download": {
    "defaultMessage": "Herunterladen"
  },
  "logger.streamScreen.downloadMedia.downloadError": {
    "defaultMessage": "Download-Link konnte nicht abgerufen werden"
  },
  "logger.streamScreen.downloadMedia.enqueueError": {
    "defaultMessage": "Export konnte nicht gestartet werden. Bitte erneut versuchen."
  },
  "logger.streamScreen.downloadMedia.error": {
    "defaultMessage": "Fehler beim Laden des Exportstatus"
  },
  "logger.streamScreen.downloadMedia.fileGeneratedSuccessfully": {
    "defaultMessage": "Datei erfolgreich erstellt"
  },
  "logger.streamScreen.downloadMedia.preparing": {
    "defaultMessage": "Datei wird vorbereitet..."
  },
  "logger.streamScreen.focusTracks.hide": {
    "defaultMessage": "Spur ausblenden"
  },
  "logger.streamScreen.focusTracks.show": {
    "defaultMessage": "Spur einblenden"
  },
  "logger.streamScreen.goToPanorama": {
    "defaultMessage": "Zum Panorama"
  },
  "logger.streamScreen.hotkeys.ADD_CHUNK_FROM_FOCUS_SELECTION.label": {
    "defaultMessage": "Auswahl zum Verbundfragment hinzufügen"
  },
  "logger.streamScreen.hotkeys.CLEAR_SELECTION.label": {
    "defaultMessage": "Auswahl aufheben"
  },
  "logger.streamScreen.hotkeys.CREATE_FRAGMENT.label": {
    "defaultMessage": "Fragment aus Auswahl erstellen"
  },
  "logger.streamScreen.hotkeys.CURSOR_BACK_1S.label": {
    "defaultMessage": "Cursor 1 Sekunde zurück"
  },
  "logger.streamScreen.hotkeys.CURSOR_BACK_5S.label": {
    "defaultMessage": "Cursor 5 Sekunden zurück"
  },
  "logger.streamScreen.hotkeys.CURSOR_FORWARD_1S.label": {
    "defaultMessage": "Cursor 1 Sekunde vor"
  },
  "logger.streamScreen.hotkeys.CURSOR_FORWARD_5S.label": {
    "defaultMessage": "Cursor 5 Sekunden vor"
  },
  "logger.streamScreen.hotkeys.DECREMENT_CURSOR_SELECTION.label": {
    "defaultMessage": "Auswahlbereich 5 Sekunden verkleinern"
  },
  "logger.streamScreen.hotkeys.DOWNLOAD_AUDIO_SELECTION_VIDEO_ONLY.label": {
    "defaultMessage": "Audio der Auswahl herunterladen (nur bei Video-Sendern)"
  },
  "logger.streamScreen.hotkeys.DOWNLOAD_SELECTION.label": {
    "defaultMessage": "Auswahl herunterladen"
  },
  "logger.streamScreen.hotkeys.END_CURSOR_SELECTION.label": {
    "defaultMessage": "Auswahl am Cursor beenden"
  },
  "logger.streamScreen.hotkeys.END_PLAY_TS_SELECTION.label": {
    "defaultMessage": "Auswahl an aktuellem Abspielzeitpunkt beenden"
  },
  "logger.streamScreen.hotkeys.FOCUS_BACK_5M.label": {
    "defaultMessage": "Fokus 5 Minuten zurück"
  },
  "logger.streamScreen.hotkeys.FOCUS_FORWARD_5M.label": {
    "defaultMessage": "Fokus 5 Minuten vor"
  },
  "logger.streamScreen.hotkeys.FOCUS_FULL_IN.label": {
    "defaultMessage": "Vollzoom auf Cursor oder Auswahl"
  },
  "logger.streamScreen.hotkeys.FOCUS_FULL_OUT.label": {
    "defaultMessage": "Vollzoom herauszoomen"
  },
  "logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_IN.label": {
    "defaultMessage": "Zoom auf Auswahlanfang"
  },
  "logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_OUT.label": {
    "defaultMessage": "Zoom auf Auswahlende"
  },
  "logger.streamScreen.hotkeys.INCREMENT_CURSOR_SELECTION.label": {
    "defaultMessage": "Auswahlbereich 5 Sekunden vergrößern"
  },
  "logger.streamScreen.hotkeys.PLAY_PAUSE.label": {
    "defaultMessage": "Wiedergabe / Pause"
  },
  "logger.streamScreen.hotkeys.START_CURSOR_SELECTION.label": {
    "defaultMessage": "Auswahl am Cursor starten"
  },
  "logger.streamScreen.hotkeys.START_PLAY_TS_SELECTION.label": {
    "defaultMessage": "Auswahl an aktuellem Abspielzeitpunkt starten"
  },
  "logger.streamScreen.hotkeys.STREAM_BACK_1H.label": {
    "defaultMessage": "Fokus 1 Stunde zurück"
  },
  "logger.streamScreen.hotkeys.STREAM_FORWARD_1H.label": {
    "defaultMessage": "Fokus 1 Stunde vor"
  },
  "logger.streamScreen.hotkeys.ZOOM_IN_FOCUS.label": {
    "defaultMessage": "Fokus vergrößern"
  },
  "logger.streamScreen.hotkeys.ZOOM_OUT_FOCUS.label": {
    "defaultMessage": "Fokus verkleinern"
  },
  "logger.streamScreen.hotkeys.category.cursor": {
    "defaultMessage": "Cursor"
  },
  "logger.streamScreen.hotkeys.category.focus": {
    "defaultMessage": "Fokus"
  },
  "logger.streamScreen.hotkeys.category.playback": {
    "defaultMessage": "Wiedergabe"
  },
  "logger.streamScreen.hotkeys.category.selection": {
    "defaultMessage": "Auswahl"
  },
  "logger.streamScreen.htmlTitle": {
    "defaultMessage": "Logger {stationName}{dateRange}"
  },
  "logger.streamScreen.liveTopic.comesFrom": {
    "defaultMessage": "Kommt von: "
  },
  "logger.streamScreen.liveTopic.goToTime": {
    "defaultMessage": "Zum Zeitpunkt gehen"
  },
  "logger.streamScreen.liveTopics.entities.orgs": {
    "defaultMessage": "Organisationen"
  },
  "logger.streamScreen.liveTopics.entities.people": {
    "defaultMessage": "Personen"
  },
  "logger.streamScreen.liveTopics.entities.places": {
    "defaultMessage": "Orte"
  },
  "logger.streamScreen.liveTopics.noTopicsForRange": {
    "defaultMessage": "Keine Themen für diesen Bereich erkannt"
  },
  "logger.streamScreen.liveTopics.panel.categoryFilterLabel": {
    "defaultMessage": "Kategorie"
  },
  "logger.streamScreen.liveTopics.panel.categoryFilterPlaceholder": {
    "defaultMessage": "Alle Kategorien"
  },
  "logger.streamScreen.liveTopics.panel.goTo": {
    "defaultMessage": "Gehen"
  },
  "logger.streamScreen.liveTopics.panel.itemDeveloping": {
    "defaultMessage": "In Entwicklung"
  },
  "logger.streamScreen.liveTopics.panel.itemNew": {
    "defaultMessage": "Neu"
  },
  "logger.streamScreen.liveTopics.panel.keyPoints": {
    "defaultMessage": "Schlüsselpunkte"
  },
  "logger.streamScreen.liveTopics.panel.loadMoreOtherDay": {
    "defaultMessage": "Frühere anzeigen vor {date} {time}"
  },
  "logger.streamScreen.liveTopics.panel.loadMoreToday": {
    "defaultMessage": "Frühere anzeigen vor {time}"
  },
  "logger.streamScreen.liveTopics.panel.newTopics": {
    "defaultMessage": "{count, plural, one {# neues Thema} other {# neue Themen}}"
  },
  "logger.streamScreen.liveTopics.panel.next": {
    "defaultMessage": "Weiter"
  },
  "logger.streamScreen.liveTopics.panel.openPanel": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.liveTopics.panel.previous": {
    "defaultMessage": "Zurück"
  },
  "logger.streamScreen.liveTopics.panel.textFilterClearButton": {
    "defaultMessage": "Suche löschen"
  },
  "logger.streamScreen.liveTopics.panel.textFilterLabel": {
    "defaultMessage": "Text"
  },
  "logger.streamScreen.liveTopics.panel.textFilterPlaceholder": {
    "defaultMessage": "Thema suchen"
  },
  "logger.streamScreen.liveTopics.panel.title": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.liveTopics.popup.openInPanel": {
    "defaultMessage": "Mehr Details anzeigen"
  },
  "logger.streamScreen.liveTopics.topicDetailPanel.empty": {
    "defaultMessage": "Kein Thema ausgewählt"
  },
  "logger.streamScreen.liveTopics.topicDetailPanel.title": {
    "defaultMessage": "Themendetails"
  },
  "logger.streamScreen.liveTopics.track.title": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.loading": {
    "defaultMessage": "Stream <b>{stationName}</b> wird geladen"
  },
  "logger.streamScreen.modes.defaultMode": {
    "defaultMessage": "Standardmodus"
  },
  "logger.streamScreen.modes.editorMode": {
    "defaultMessage": "Editor-Modus"
  },
  "logger.streamScreen.pickDateTime.confirmBtn": {
    "defaultMessage": "Bestätigen"
  },
  "logger.streamScreen.pickDateTime.dateLabel": {
    "defaultMessage": "Stream-Datum"
  },
  "logger.streamScreen.pickDateTime.timeLabel": {
    "defaultMessage": "Startzeit"
  },
  "logger.streamScreen.pickDateTime.title": {
    "defaultMessage": "Datum und Uhrzeit auswählen"
  },
  "logger.streamScreen.screenSettings.autoOpenFragment": {
    "defaultMessage": "Fragmenterstellung beim Auswählen öffnen (Standardmodus)"
  },
  "logger.streamScreen.screenSettings.btn": {
    "defaultMessage": "Einstellungen"
  },
  "logger.streamScreen.screenSettings.keepSelectionOnRangeChange": {
    "defaultMessage": "Auswahl beim Ändern des Bereichs beibehalten"
  },
  "logger.streamScreen.screenSettings.playOnCursorSet": {
    "defaultMessage": "Beim Markieren abspielen"
  },
  "logger.streamScreen.screenSettings.screenMode": {
    "defaultMessage": "Bildschirmmodus"
  },
  "logger.streamScreen.screenSettings.tooltip": {
    "defaultMessage": "Bildschirmeinstellungen"
  },
  "logger.streamScreen.selection.clear": {
    "defaultMessage": "Auswahl löschen"
  },
  "logger.streamScreen.selectionMenu.addChunk": {
    "defaultMessage": "Segment zum Fragment hinzufügen"
  },
  "logger.streamScreen.selectionMenu.copyQuickShare": {
    "defaultMessage": "Schnellfreigabe kopieren"
  },
  "logger.streamScreen.selectionMenu.copyQuickShareDone": {
    "defaultMessage": "Link kopiert"
  },
  "logger.streamScreen.selectionMenu.createFragment": {
    "defaultMessage": "Fragment erstellen"
  },
  "logger.streamScreen.selectionMenu.downloadAudio": {
    "defaultMessage": "Audio herunterladen"
  },
  "logger.streamScreen.selectionMenu.downloadVideo": {
    "defaultMessage": "Video herunterladen"
  },
  "logger.streamScreen.selectionMenu.play": {
    "defaultMessage": "Auswahl abspielen"
  },
  "logger.streamScreen.selectionMenu.unselect": {
    "defaultMessage": "Abwählen"
  },
  "logger.youtubeBroadcasts.noYoutubeNativeStations": {
    "defaultMessage": "Keine Sender mit YouTube-Native-Integration"
  },
  "logger.youtubeBroadcasts.pageTitle": {
    "defaultMessage": "YouTube-Übertragungen"
  },
  "logger.youtubePanorama.noRecentBroadcasts": {
    "defaultMessage": "Keine aktuellen Übertragungen"
  },
  "logger.youtubePanorama.recentTransmissionTitle": {
    "defaultMessage": "Neueste Übertragung"
  },
  "logger.youtubePanorama.recentTransmissionsTitle": {
    "defaultMessage": "Neueste Übertragungen"
  },
  "logger.youtubePanorama.viewAll": {
    "defaultMessage": "Alle Übertragungen anzeigen"
  },
  "logger.youtubeStats.legend.channels": {
    "defaultMessage": "Kanäle"
  },
  "logger.youtubeStats.legend.otherChannels": {
    "defaultMessage": "Andere Kanäle"
  },
  "logger.youtubeStats.legend.ownChannel": {
    "defaultMessage": "Eigener Kanal"
  },
  "logger.youtubeStats.legend.selectAll": {
    "defaultMessage": "Alle auswählen"
  },
  "logger.youtubeStats.legend.selectNone": {
    "defaultMessage": "Keine auswählen"
  },
  "logger.youtubeStats.noDataForPeriod": {
    "defaultMessage": "Keine Daten für diesen Zeitraum verfügbar"
  },
  "logger.youtubeStats.openYoutubeAtThisMoment": {
    "defaultMessage": "Klicken Sie, um zu YouTube zu diesem Zeitpunkt zu springen"
  },
  "logger.youtubeStats.timeLegend": {
    "defaultMessage": "Zeit"
  },
  "modulesAdminLocaleEs.m.admin.groups.addScreen.title": {
    "defaultMessage": "Neue Gruppe erstellen"
  },
  "modulesAdminLocaleEs.m.admin.groups.editScreen.title": {
    "defaultMessage": "Edit group"
  },
  "notifications.feed.archive": {
    "defaultMessage": "Archivieren"
  },
  "notifications.feed.filterAll": {
    "defaultMessage": "Alle"
  },
  "notifications.feed.filterRead": {
    "defaultMessage": "Gelesen"
  },
  "notifications.feed.filterUnread": {
    "defaultMessage": "Ungelesen"
  },
  "notifications.feed.loadMore": {
    "defaultMessage": "Mehr laden"
  },
  "notifications.feed.markAllRead": {
    "defaultMessage": "Alle als gelesen markieren"
  },
  "notifications.feed.title": {
    "defaultMessage": "Benachrichtigungen"
  },
  "notifications.item.fallbackTitle": {
    "defaultMessage": "Benachrichtigung"
  },
  "notifications.item.openVideo": {
    "defaultMessage": "Video ansehen"
  },
  "notifications.item.download": {
    "defaultMessage": "Herunterladen"
  },
  "notifications.preferences.category.audit": {
    "defaultMessage": "Audit"
  },
  "notifications.preferences.category.fragments": {
    "defaultMessage": "Fragmente"
  },
  "notifications.preferences.category.socialUpload": {
    "defaultMessage": "Netzwerke"
  },
  "notifications.preferences.channel.email": {
    "defaultMessage": "E-Mail"
  },
  "notifications.preferences.channel.inApp": {
    "defaultMessage": "In App"
  },
  "notifications.preferences.saveError": {
    "defaultMessage": "Einstellungen konnten nicht gespeichert werden"
  },
  "notifications.preferences.title": {
    "defaultMessage": "Benachrichtigungseinstellungen"
  },
  "notifications.preferences.unavailable": {
    "defaultMessage": "Benachrichtigungseinstellungen sind nicht verfügbar."
  },
  "notifications.preferences.workflow.aodDeficiencyBreached.description": {
    "defaultMessage": "Wenn ein AOD-Lauf den Mindesteffizienz-Schwellenwert nicht erreicht"
  },
  "notifications.preferences.workflow.aodDeficiencyBreached.title": {
    "defaultMessage": "Unzureichende AOD-Effizienz"
  },
  "notifications.preferences.workflow.evidenceExportCompleted.description": {
    "defaultMessage": "Wenn das Nachweispaket eines Berichts bereit ist"
  },
  "notifications.preferences.workflow.evidenceExportCompleted.title": {
    "defaultMessage": "Nachweise zum Download bereit"
  },
  "notifications.preferences.workflow.socialUploadCompleted.description": {
    "defaultMessage": "Wenn ein Video erfolgreich in einem sozialen Netzwerk veröffentlicht wird"
  },
  "notifications.preferences.workflow.socialUploadCompleted.title": {
    "defaultMessage": "Erfolgreiche Veröffentlichung"
  },
  "notifications.preferences.workflow.socialUploadFailed.description": {
    "defaultMessage": "Wenn die Veröffentlichung eines Videos in einem sozialen Netzwerk fehlschlägt"
  },
  "notifications.preferences.workflow.socialUploadFailed.title": {
    "defaultMessage": "Veröffentlichungsfehler"
  },
  "notifications.toast.close": {
    "defaultMessage": "Schließen"
  },
  "notifications.toast.story.showAgain": {
    "defaultMessage": "Erneut anzeigen"
  },
  "notifications.toast.viewLink": {
    "defaultMessage": "Ansehen"
  },
  "notifications.tour.bell.description": {
    "defaultMessage": "Wir zentralisieren den Status deiner Exports, Berichte und Systemalarme. Klicke auf die Glocke, um deine letzte Aktivität zu prüfen."
  },
  "notifications.tour.bell.title": {
    "defaultMessage": "Benachrichtigungszentrum"
  },
  "notifications.tour.demo.aod.body": {
    "defaultMessage": "In der geplanten Kampagne wurde ein Mangel erkannt."
  },
  "notifications.tour.demo.aod.title": {
    "defaultMessage": "AOD-Mangel: Sommerkampagne"
  },
  "notifications.tour.demo.export.title": {
    "defaultMessage": "Evidenzexport bereit"
  },
  "notifications.tour.demo.time.hourAgo": {
    "defaultMessage": "vor 1 Stunde"
  },
  "notifications.tour.demo.time.recent": {
    "defaultMessage": "vor 5 Minuten"
  },
  "notifications.tour.demo.time.yesterday": {
    "defaultMessage": "gestern"
  },
  "notifications.tour.demo.upload.title": {
    "defaultMessage": "YouTube-Upload abgeschlossen"
  },
  "notifications.tour.feed.description": {
    "defaultMessage": "Filtere, lies oder archiviere deine Alarme von hier. Nutze das Zahnrad-Symbol (⚙️), um anzupassen, welche Hinweise du erhalten möchtest."
  },
  "notifications.tour.feed.title": {
    "defaultMessage": "Verwalte deine Benachrichtigungen"
  },
  "permissions.empty.description": {
    "defaultMessage": "Es sind keine Berechtigungen verfügbar."
  },
  "permissions.empty.title": {
    "defaultMessage": "Keine Berechtigungen gefunden"
  },
  "permissions.error.description": {
    "defaultMessage": "Beim Laden der Berechtigungen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
  },
  "permissions.error.title": {
    "defaultMessage": "Fehler beim Laden der Berechtigungen"
  },
  "playback.rangeWaveformPlayer.noSegments": {
    "defaultMessage": "Kein Audio für diesen Zeitraum verfügbar."
  },
  "search.contactAdmin": {
    "defaultMessage": "Kontaktieren Sie Ihren Administrator"
  },
  "search.dateTime": {
    "defaultMessage": "Zeit"
  },
  "search.featureNotAvailable": {
    "defaultMessage": "Diese Funktion ist nicht verfügbar für"
  },
  "search.helpFistLine": {
    "defaultMessage": "Für erweiterte Suchoperationen:"
  },
  "search.helpPlusOp": {
    "defaultMessage": "Das Symbol + entspricht dem logischen Operator UND"
  },
  "search.helpVertialBarOp": {
    "defaultMessage": "Das Symbol | entspricht dem logischen Operator ODER"
  },
  "search.preview": {
    "defaultMessage": "Vorschau"
  },
  "search.title": {
    "defaultMessage": "Suche"
  },
  "search.transcription": {
    "defaultMessage": "Transkription"
  },
  "segments.listScreen.futureRange": {
    "defaultMessage": "Der ausgewählte Bereich liegt in der Zukunft"
  },
  "segments.listScreen.futureRange.help": {
    "defaultMessage": "Wählen Sie einen früheren Bereich, um die Sendung anzuzeigen."
  },
  "segments.listScreen.noSegments": {
    "defaultMessage": "Keine Sendung"
  },
  "segments.listScreen.noSegments.help": {
    "defaultMessage": "Versuchen Sie, den ausgewählten Zeitbereich zu ändern."
  },
  "segments.listScreen.tooRecentRange": {
    "defaultMessage": "Der Bereich ist zu aktuell"
  },
  "segments.listScreen.tooRecentRange.help": {
    "defaultMessage": "Wählen Sie einen Bereich von mindestens {minutes} Minuten vor dem aktuellen Zeitpunkt."
  },
  "settings.userSettings.form.name.label": {
    "defaultMessage": "Name"
  },
  "settings.userSettings.form.surname.label": {
    "defaultMessage": "Nachname"
  },
  "settings.userSettings.title": {
    "defaultMessage": "Benutzereinstellungen"
  },
  "socialExport.connect": {
    "defaultMessage": "Verbinden"
  },
  "socialExport.connectAlternatives.dialogTitle": {
    "defaultMessage": "Verbindungsart für {platform} wählen"
  },
  "socialExport.connectAlternatives.permissionsLabel": {
    "defaultMessage": "Berechtigungen"
  },
  "socialExport.connectAlternatives.recommendedBadge": {
    "defaultMessage": "Empfohlen"
  },
  "socialExport.connectAlternatives.redirecting": {
    "defaultMessage": "Weiterleitung zu {platform} zum Verbinden..."
  },
  "socialExport.connectionSuccess.configureBelow": {
    "defaultMessage": "Bitte konfigurieren Sie die Integration unten."
  },
  "socialExport.connectionSuccess.linkStations": {
    "defaultMessage": "Verknüpfen Sie Sender mit diesem Konto und konfigurieren Sie die Standardwerte."
  },
  "socialExport.connectionSuccess.title": {
    "defaultMessage": "Verbindung erfolgreich mit {name}"
  },
  "socialExport.connections.accountIdentification": {
    "defaultMessage": "Kontoidentifikation"
  },
  "socialExport.connections.connectedAccounts": {
    "defaultMessage": "Verbundene Konten"
  },
  "socialExport.connections.connectedByPrefix": {
    "defaultMessage": "Verbunden von"
  },
  "socialExport.connections.customName": {
    "defaultMessage": "Benutzerdefinierter Name"
  },
  "socialExport.connections.customNameHelper": {
    "defaultMessage": "Optional. Nützlich, wenn es mehr als eine Verbindung zum selben Profil gibt."
  },
  "socialExport.connections.defaultConnectionName": {
    "defaultMessage": "Standard"
  },
  "socialExport.connections.disconnectConfirmDescription": {
    "defaultMessage": "Sie sind dabei, diese Integration zu trennen. Sind Sie sicher?"
  },
  "socialExport.connections.disconnectWithStationsWarning": {
    "defaultMessage": "Dieses Konto ist mit {count, plural, one {# Sender} other {# Sendern}} verknüpft. Nach dem Trennen können diese Sender nicht mehr damit veröffentlichen. Sind Sie sicher?"
  },
  "socialExport.connections.empty": {
    "defaultMessage": "Keine verbundenen Konten"
  },
  "socialExport.connections.emptyHelp": {
    "defaultMessage": "Verbinden Sie ein Konto, um auf dieser Plattform zu veröffentlichen."
  },
  "socialExport.connections.linkedStationsCount": {
    "defaultMessage": "{count, plural, =0 {Keine verknüpften Sender} one {# verknüpfter Sender} other {# verknüpfte Sender}}"
  },
  "socialExport.connections.noLinkedStations": {
    "defaultMessage": "Noch keine verknüpften Sender"
  },
  "socialExport.connections.noneAssignedForStation": {
    "defaultMessage": "Für diesen Sender sind keine verbundenen Konten dieser Plattform zugewiesen."
  },
  "socialExport.connections.connectionDetail": {
    "defaultMessage": "Details"
  },
  "socialExport.connections.selectConnection": {
    "defaultMessage": "Wählen Sie ein Konto, um Details anzuzeigen"
  },
  "socialExport.connections.selectForPublish": {
    "defaultMessage": "Veröffentlichungskonto"
  },
  "socialExport.connections.selectStations": {
    "defaultMessage": "Sender"
  },
  "socialExport.connections.selectStationsHelper": {
    "defaultMessage": "Nur diese Sender können mit diesem Konto veröffentlichen."
  },
  "socialExport.connections.selectStationsPlaceholder": {
    "defaultMessage": "Einen oder mehrere Sender auswählen"
  },
  "socialExport.connections.settingsTitle": {
    "defaultMessage": "{name} konfigurieren"
  },
  "socialExport.connections.stationsPublishingWithAccount": {
    "defaultMessage": "Verknüpfte Sender"
  },
  "socialExport.dailymotion.apiKey": {
    "defaultMessage": "API-Schlüssel"
  },
  "socialExport.dailymotion.apiSecret": {
    "defaultMessage": "API-Geheimnis"
  },
  "socialExport.dailymotion.channel.animals": {
    "defaultMessage": "Tiere"
  },
  "socialExport.dailymotion.channel.auto": {
    "defaultMessage": "Autos"
  },
  "socialExport.dailymotion.channel.creation": {
    "defaultMessage": "Kreation"
  },
  "socialExport.dailymotion.channel.fun": {
    "defaultMessage": "Spaß"
  },
  "socialExport.dailymotion.channel.kids": {
    "defaultMessage": "Kinder"
  },
  "socialExport.dailymotion.channel.lifestyle": {
    "defaultMessage": "Lifestyle"
  },
  "socialExport.dailymotion.channel.music": {
    "defaultMessage": "Musik"
  },
  "socialExport.dailymotion.channel.news": {
    "defaultMessage": "Nachrichten"
  },
  "socialExport.dailymotion.channel.people": {
    "defaultMessage": "Menschen"
  },
  "socialExport.dailymotion.channel.school": {
    "defaultMessage": "Schule"
  },
  "socialExport.dailymotion.channel.shortfilms": {
    "defaultMessage": "Kurzfilme"
  },
  "socialExport.dailymotion.channel.sport": {
    "defaultMessage": "Sport"
  },
  "socialExport.dailymotion.channel.tech": {
    "defaultMessage": "Technologie"
  },
  "socialExport.dailymotion.channel.travel": {
    "defaultMessage": "Reisen"
  },
  "socialExport.dailymotion.channel.tv": {
    "defaultMessage": "TV"
  },
  "socialExport.dailymotion.channel.videogames": {
    "defaultMessage": "Videospiele"
  },
  "socialExport.dailymotion.channel.webcam": {
    "defaultMessage": "Webcam"
  },
  "socialExport.dailymotion.channelId": {
    "defaultMessage": "Kanal-ID"
  },
  "socialExport.dailymotion.channelIdHelper": {
    "defaultMessage": "7-stellige Kennung"
  },
  "socialExport.dailymotion.connect.apiKeyDescription": {
    "defaultMessage": "Geben Sie Key, Secret und Kanal-ID aus dem Dailymotion Studio ein. Ideal für Organisationen."
  },
  "socialExport.dailymotion.connect.apiKeyName": {
    "defaultMessage": "Privater API-Schlüssel"
  },
  "socialExport.dailymotion.connect.loginDescription": {
    "defaultMessage": "Wir leiten Sie zu Dailymotion weiter, um sich anzumelden und den Zugriff auf Ihren Kanal zu autorisieren."
  },
  "socialExport.dailymotion.connect.loginName": {
    "defaultMessage": "Dailymotion-Konto"
  },
  "socialExport.dailymotion.connectApiKeyTitle": {
    "defaultMessage": "Dailymotion per API-Schlüssel verbinden"
  },
  "socialExport.dailymotion.connectTitle": {
    "defaultMessage": "{stationName} mit Dailymotion per API-Schlüssel verbinden"
  },
  "socialExport.dailymotion.connectViaApiKey": {
    "defaultMessage": "Connect via API key"
  },
  "socialExport.dailymotion.connectViaLogin": {
    "defaultMessage": "Connect via login"
  },
  "socialExport.facebook.connect.businessDescription": {
    "defaultMessage": "Aus Facebook-Business-Konten veröffentlichen"
  },
  "socialExport.facebook.connect.businessName": {
    "defaultMessage": "Facebook Business"
  },
  "socialExport.facebook.connect.businessPermissions": {
    "defaultMessage": "Seitenzugriff über Facebook Business. WICHTIG: Beim Erteilen von Berechtigungen für die Anwendung nur Zugriff auf die Seite gewähren, auf der Sie veröffentlichen möchten."
  },
  "socialExport.facebook.connect.standardDescription": {
    "defaultMessage": "Auf Facebook-Seiten veröffentlichen"
  },
  "socialExport.facebook.connect.standardName": {
    "defaultMessage": "Facebook"
  },
  "socialExport.facebook.connect.standardPermissions": {
    "defaultMessage": "Seitenzugriff. WICHTIG: Beim Erteilen von Berechtigungen für die Anwendung nur Zugriff auf die Seite gewähren, auf der Sie veröffentlichen möchten."
  },
  "socialExport.facebook.connectBusiness": {
    "defaultMessage": "Verbinden (Facebook Business)"
  },
  "socialExport.facebook.permissionsNote": {
    "defaultMessage": "WICHTIG: Beim Erteilen von Berechtigungen für die Anwendung sollte nur Zugriff auf die Seite gewährt werden, auf der Sie veröffentlichen möchten."
  },
  "socialExport.featureNotEnabled": {
    "defaultMessage": "Funktion nicht aktiviert, bitte wenden Sie sich an den Support"
  },
  "socialExport.form.category": {
    "defaultMessage": "Kategorie"
  },
  "socialExport.form.commaSeparatedValues": {
    "defaultMessage": "Kommagetrennte Werte"
  },
  "socialExport.form.content": {
    "defaultMessage": "Inhalt"
  },
  "socialExport.form.defaultValuesUploads": {
    "defaultMessage": "Standardwerte für Uploads"
  },
  "socialExport.form.deleteDelay": {
    "defaultMessage": "Löschverzögerung (ms)"
  },
  "socialExport.form.deleteDelayHelper": {
    "defaultMessage": "Wartezeit vor dem Löschen (0-60000 ms, Standard: 2000)"
  },
  "socialExport.form.demoConfig": {
    "defaultMessage": "Demo-Konfiguration"
  },
  "socialExport.form.demoData": {
    "defaultMessage": "Demo-Daten"
  },
  "socialExport.form.description": {
    "defaultMessage": "Beschreibung"
  },
  "socialExport.form.forKids": {
    "defaultMessage": "Für Kinder geeignete Inhalte"
  },
  "socialExport.form.idsSeparatedByComma": {
    "defaultMessage": "IDs durch Komma getrennt"
  },
  "socialExport.form.platform": {
    "defaultMessage": "Plattform"
  },
  "socialExport.form.publish": {
    "defaultMessage": "Veröffentlichen"
  },
  "socialExport.form.publishDateLabel": {
    "defaultMessage": "Veröffentlichungsdatum und -zeit"
  },
  "socialExport.form.publishDelay": {
    "defaultMessage": "Veröffentlichungsverzögerung (ms)"
  },
  "socialExport.form.publishDelayHelper": {
    "defaultMessage": "Wartezeit vor der Veröffentlichung (0-60000 ms, Standard: 10000)"
  },
  "socialExport.form.publishImmediately": {
    "defaultMessage": "Sofort veröffentlichen"
  },
  "socialExport.form.publishToFeed": {
    "defaultMessage": "Auch im Feed veröffentlichen"
  },
  "socialExport.form.replyConfig": {
    "defaultMessage": "Antwortkonfiguration"
  },
  "socialExport.form.schedule": {
    "defaultMessage": "Zeitplan"
  },
  "socialExport.form.scheduling": {
    "defaultMessage": "Zeitplanung"
  },
  "socialExport.form.settings": {
    "defaultMessage": "Veröffentlichungsparameter"
  },
  "socialExport.form.shareToFeed": {
    "defaultMessage": "Auch im Feed teilen"
  },
  "socialExport.form.taggedUsers": {
    "defaultMessage": "Markierte Benutzer"
  },
  "socialExport.form.tags": {
    "defaultMessage": "Tags"
  },
  "socialExport.form.thumbnail": {
    "defaultMessage": "Miniaturbild"
  },
  "socialExport.form.thumbnailAndSettings": {
    "defaultMessage": "Miniaturbild und Einstellungen"
  },
  "socialExport.form.title": {
    "defaultMessage": "Titel"
  },
  "socialExport.form.unsavedChangesLeavePrompt": {
    "defaultMessage": "Möchten Sie die Seite wirklich verlassen? Nicht gespeicherte Änderungen gehen verloren."
  },
  "socialExport.form.uploadAsPrivate": {
    "defaultMessage": "Als privates Video hochladen"
  },
  "socialExport.history": {
    "defaultMessage": "Verlauf"
  },
  "socialExport.manage.configure": {
    "defaultMessage": "Configure"
  },
  "socialExport.manage.disconnect": {
    "defaultMessage": "Disconnect"
  },
  "socialExport.mediaLimits.blocked": {
    "defaultMessage": "Das Video überschreitet die maximal zulässige Dauer der Plattform."
  },
  "socialExport.mediaLimits.blockedWithMax": {
    "defaultMessage": "Das Video überschreitet die maximal zulässige Dauer der Plattform ({maxMinutes} Min.)."
  },
  "socialExport.mediaLimits.needsTranscoding": {
    "defaultMessage": "Die Videogröße überschreitet das Plattformlimit; sie wird auf {quality}p reduziert, damit die Veröffentlichung möglich ist."
  },
  "socialExport.mediaLimits.platformDisplaysLower": {
    "defaultMessage": "{platformName} zeigt es mit bis zu {quality}p an."
  },
  "socialExport.noStationsEnabledForFeature": {
    "defaultMessage": "Keine für diese Funktion aktivierten Sender gefunden"
  },
  "socialExport.profile.publicationAccount": {
    "defaultMessage": "Veröffentlichungskonto"
  },
  "socialExport.profile.videosWillBeUploadedTo": {
    "defaultMessage": "Videos will be uploaded to"
  },
  "socialExport.publish.chip.cancelled": {
    "defaultMessage": "Abgebrochen"
  },
  "socialExport.publish.chip.error": {
    "defaultMessage": "Fehler"
  },
  "socialExport.publish.chip.errorCode": {
    "defaultMessage": "Code: {errorCode}"
  },
  "socialExport.publish.chip.inProgress": {
    "defaultMessage": "In Bearbeitung"
  },
  "socialExport.publish.chip.published": {
    "defaultMessage": "Veröffentlicht"
  },
  "socialExport.publish.chip.scheduled": {
    "defaultMessage": "Geplant"
  },
  "socialExport.publish.chip.waitingForMedia": {
    "defaultMessage": "Warten auf Medium"
  },
  "socialExport.publish.connectionNotReady": {
    "defaultMessage": "Die Social-Media-Verbindung wird noch geladen; bitte versuche es in einem Moment erneut."
  },
  "socialExport.publish.createdBy": {
    "defaultMessage": "Erstellt von {user}"
  },
  "socialExport.publish.deleteFromPlatform": {
    "defaultMessage": "Von {platform} entfernen"
  },
  "socialExport.publish.deleteScheduledPublishMessage": {
    "defaultMessage": "Möchten Sie diese geplante Veröffentlichung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "socialExport.publish.deleteScheduledPublishTitle": {
    "defaultMessage": "Geplante Veröffentlichung löschen"
  },
  "socialExport.publish.deleteVideoFromPlatformMessage": {
    "defaultMessage": "Möchten Sie dieses Video wirklich von der Plattform löschen? Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "socialExport.publish.deleteVideoFromPlatformTitle": {
    "defaultMessage": "Video von {platform} löschen"
  },
  "socialExport.publish.editionWithName": {
    "defaultMessage": "Edit: {name}"
  },
  "socialExport.publish.error.youtubeReconnectRequired": {
    "defaultMessage": "Die YouTube-Anmeldedaten sind veraltet. Sie müssen das Konto erneut verbinden."
  },
  "socialExport.publish.errorDeletingPublication": {
    "defaultMessage": "Beim Löschen der Veröffentlichung ist ein Fehler aufgetreten"
  },
  "socialExport.publish.errorDeletingVideo": {
    "defaultMessage": "Beim Löschen des Videos ist ein Fehler aufgetreten"
  },
  "socialExport.publish.errorPublishingNow": {
    "defaultMessage": "Beim sofortigen Veröffentlichen ist ein Fehler aufgetreten"
  },
  "socialExport.publish.forKidsDescription": {
    "defaultMessage": "Es gelten die Einschränkungen der Plattform für Inhalte für Kinder."
  },
  "socialExport.publish.manageVideo": {
    "defaultMessage": "Video verwalten auf {platform}"
  },
  "socialExport.publish.mediaSelector.edition": {
    "defaultMessage": "Edit"
  },
  "socialExport.publish.mediaSelector.label": {
    "defaultMessage": "Zu veröffentlichendes Video"
  },
  "socialExport.publish.mediaSelector.originalMedia": {
    "defaultMessage": "Originalmedien"
  },
  "socialExport.publish.mediaSelector.renderNotReadyComposition": {
    "defaultMessage": "Das Video dieser Bearbeitung wurde noch nicht erstellt. Erstellen Sie es im Tab „Bearbeitungen“."
  },
  "socialExport.publish.mediaSelector.renderNotReadyFragment": {
    "defaultMessage": "Das Video dieses edit wurde noch nicht generiert. Generieren Sie es im Tab „edits“."
  },
  "socialExport.publish.noAdditionalActions": {
    "defaultMessage": "Die Plattform erlaubt keine weiteren Aktionen"
  },
  "socialExport.publish.noAllowedSourceError": {
    "defaultMessage": "Für diese Station ist keine verfügbare Quelle zum Veröffentlichen vorhanden."
  },
  "socialExport.publish.noOAuthConnectionForPlatform": {
    "defaultMessage": "{platformName} ist für diese Station nicht verbunden."
  },
  "socialExport.publish.noPlatformsToPublish": {
    "defaultMessage": "Keine Plattformen zum Veröffentlichen"
  },
  "socialExport.publish.noRenderedEdit": {
    "defaultMessage": "Es gibt keine Bearbeitung mit generiertem Video zum Veröffentlichen."
  },
  "socialExport.publish.noStation": {
    "defaultMessage": "Dieser Komposition ist keine Station zugewiesen."
  },
  "socialExport.publish.panorama.goToEdits": {
    "defaultMessage": "Zu edits"
  },
  "socialExport.publish.panorama.noConnectedPlatforms": {
    "defaultMessage": "Es sind keine Plattformen zum Veröffentlichen verbunden."
  },
  "socialExport.publish.panorama.noSourcesComposition": {
    "defaultMessage": "Um in sozialen Netzwerken zu veröffentlichen, müssen Sie ein Video aus einer Videobearbeitung generieren."
  },
  "socialExport.publish.panorama.noSourcesFragment": {
    "defaultMessage": "Um in sozialen Netzwerken zu veröffentlichen, müssen Sie aus dem Fragment ein Video erstellen."
  },
  "socialExport.publish.panorama.notPublishedComposition": {
    "defaultMessage": "Sie haben diese Komposition noch nicht in sozialen Netzwerken veröffentlicht."
  },
  "socialExport.publish.panorama.notPublishedFragment": {
    "defaultMessage": "Sie haben dieses Fragment noch nicht in sozialen Netzwerken veröffentlicht."
  },
  "socialExport.publish.platformSwitcherLabel": {
    "defaultMessage": "Plattform"
  },
  "socialExport.publish.postPublishProcessingNotice": {
    "defaultMessage": "Nach dem Veröffentlichen kann es einige Minuten dauern, bis der Inhalt verarbeitet und in deinem Profil sichtbar ist."
  },
  "socialExport.publish.publicationDeleted": {
    "defaultMessage": "Veröffentlichung gelöscht"
  },
  "socialExport.publish.publicationStarted": {
    "defaultMessage": "Veröffentlichung gestartet"
  },
  "socialExport.publish.publicationsSectionTitle": {
    "defaultMessage": "Veröffentlichungen ({count})"
  },
  "socialExport.publish.publishImmediatelyDescription": {
    "defaultMessage": "Deaktivieren, um ein zukünftiges Veröffentlichungsdatum und -uhrzeit zu wählen"
  },
  "socialExport.publish.publishNow": {
    "defaultMessage": "Jetzt veröffentlichen"
  },
  "socialExport.publish.publishNowConfirmMessage": {
    "defaultMessage": "Möchten Sie dieses Video jetzt veröffentlichen, anstatt auf den geplanten Termin zu warten?"
  },
  "socialExport.publish.publishNowConfirmTitle": {
    "defaultMessage": "Jetzt veröffentlichen"
  },
  "socialExport.publish.publishTo": {
    "defaultMessage": "Veröffentlichen in"
  },
  "socialExport.publish.publishToSectionTitle": {
    "defaultMessage": "Veröffentlichen in"
  },
  "socialExport.publish.publishToSocialNetworks": {
    "defaultMessage": "In sozialen Netzwerken veröffentlichen"
  },
  "socialExport.publish.publishedOn": {
    "defaultMessage": "Veröffentlicht am:"
  },
  "socialExport.publish.retry": {
    "defaultMessage": "Wiederholen"
  },
  "socialExport.publish.scheduledAlertTitle": {
    "defaultMessage": "Geplante Veröffentlichung"
  },
  "socialExport.publish.sectionTitle": {
    "defaultMessage": "Soziale Netzwerke"
  },
  "socialExport.publish.sendToPlatform": {
    "defaultMessage": "Auf {platformName} veröffentlichen"
  },
  "socialExport.publish.shareToFeedDescription": {
    "defaultMessage": "Neben dem Reel wird der Beitrag auch im Haupt-Feed des Kontos erscheinen."
  },
  "socialExport.publish.startPublicationError": {
    "defaultMessage": "An error occurred while starting the publication, please contact support"
  },
  "socialExport.publish.uploadAsPrivateDescription": {
    "defaultMessage": "Das Video ist nur im Konto sichtbar, bis es öffentlich veröffentlicht wird"
  },
  "socialExport.publish.uploadDetail.publishedTitle": {
    "defaultMessage": "Veröffentlicht"
  },
  "socialExport.publish.videoDeletedFromPlatform": {
    "defaultMessage": "Video von der Plattform gelöscht"
  },
  "socialExport.publish.videoPreview.title": {
    "defaultMessage": "Vorschau des Videos"
  },
  "socialExport.publish.videoWillPublishAt": {
    "defaultMessage": "Das Video wird veröffentlicht am:"
  },
  "socialExport.publish.viewVideo": {
    "defaultMessage": "Video ansehen"
  },
  "socialExport.publish.waitingPublicLink": {
    "defaultMessage": "Warte auf öffentlichen Link"
  },
  "socialExport.select.none": {
    "defaultMessage": "None"
  },
  "socialExport.settings.updated": {
    "defaultMessage": "Konfiguration erfolgreich aktualisiert"
  },
  "socialExport.rudo.accessToken": {
    "defaultMessage": "Access token"
  },
  "socialExport.rudo.accessTokenHelper": {
    "defaultMessage": "Statisches Token aus Ihrem Rudo.video-Konto"
  },
  "socialExport.rudo.connectApiKeyTitle": {
    "defaultMessage": "Rudo mit Access-Token verbinden"
  },
  "socialExport.rudo.displayName": {
    "defaultMessage": "Anzeigename"
  },
  "socialExport.rudo.displayNameHelper": {
    "defaultMessage": "Optional. Nützlich, wenn Sie mehr als ein Rudo-Konto verbinden."
  },
  "socialExport.rudo.folder.create": {
    "defaultMessage": "Ordner erstellen"
  },
  "socialExport.rudo.folder.createCancel": {
    "defaultMessage": "Abbrechen"
  },
  "socialExport.rudo.folder.createSubmit": {
    "defaultMessage": "Erstellen"
  },
  "socialExport.rudo.folder.createSuccess": {
    "defaultMessage": "Ordner erstellt"
  },
  "socialExport.rudo.folder.createTitle": {
    "defaultMessage": "Neuer Ordner"
  },
  "socialExport.rudo.folder.helper": {
    "defaultMessage": "Zielordner auf Rudo"
  },
  "socialExport.rudo.folder.label": {
    "defaultMessage": "Ordner"
  },
  "socialExport.rudo.folder.name": {
    "defaultMessage": "Ordnername"
  },
  "socialExport.rudo.folder.noOptions": {
    "defaultMessage": "Keine Ordner verfügbar"
  },
  "socialExport.rudo.restriction.label": {
    "defaultMessage": "VOD-Einschränkung"
  },
  "socialExport.rudo.restriction.none": {
    "defaultMessage": "Keine Einschränkung"
  },
  "socialExport.rudo.restriction.premium": {
    "defaultMessage": "Premium"
  },
  "socialExport.rudo.restriction.registration": {
    "defaultMessage": "Nur registrierte Nutzer"
  },
  "socialExport.stationsState.active": {
    "defaultMessage": "Aktiv"
  },
  "socialExport.stationsState.disabled": {
    "defaultMessage": "Deaktiviert"
  },
  "socialExport.stationsState.inactive": {
    "defaultMessage": "Inaktiv"
  },
  "socialExport.tiktok.disclosure.brandedContent.description": {
    "defaultMessage": "Sie bewerben eine andere Marke oder einen Dritten. Dieses Video wird als Markeninhalt eingestuft."
  },
  "socialExport.tiktok.disclosure.brandedContent.label": {
    "defaultMessage": "Markeninhalt"
  },
  "socialExport.tiktok.disclosure.brandedContentAndMusicAgree": {
    "defaultMessage": "Mit der Veröffentlichung stimmen Sie TikToks {brandedContentLink} und {musicLink} zu."
  },
  "socialExport.tiktok.disclosure.brandedContentPolicyLink": {
    "defaultMessage": "Richtlinie für Markeninhalte"
  },
  "socialExport.tiktok.disclosure.brandedContentVisibilityCannotBePrivate": {
    "defaultMessage": "Die Privatsphäre von Werbeinhalt einer anderen Marke kann nicht auf \"Nur ich\" stehen."
  },
  "socialExport.tiktok.disclosure.brandedContentVisibilityTooltip": {
    "defaultMessage": "Die Sichtbarkeit von Markeninhalten kann nicht auf privat gesetzt werden."
  },
  "socialExport.tiktok.disclosure.description": {
    "defaultMessage": "Aktivieren Sie, um anzuzeigen, dass dieses Video Waren oder Dienstleistungen im Tausch gegen etwas von Wert bewirbt. Ihr Video kann Sie selbst, einen Dritten oder beides bewerben."
  },
  "socialExport.tiktok.disclosure.labelPaidPartnership": {
    "defaultMessage": "Ihr Video wird als \"Bezahlte Partnerschaft\" gekennzeichnet."
  },
  "socialExport.tiktok.disclosure.labelPaidPartnershipAlert": {
    "defaultMessage": "Ihr Video wird als \"Bezahlte Partnerschaft\" gekennzeichnet. Dies kann nach der Veröffentlichung nicht geändert werden."
  },
  "socialExport.tiktok.disclosure.labelPromotionalContent": {
    "defaultMessage": "Ihr Video wird als \"Werbeinhalt\" gekennzeichnet."
  },
  "socialExport.tiktok.disclosure.musicUsageAgree": {
    "defaultMessage": "Mit der Veröffentlichung stimmen Sie unserer {link} zu."
  },
  "socialExport.tiktok.disclosure.musicUsageConfirmationLink": {
    "defaultMessage": "Bestätigung zur Musiknutzung"
  },
  "socialExport.tiktok.disclosure.promotionalLabel": {
    "defaultMessage": "Ihr Video wird als \"Werbeinhalt\" gekennzeichnet. Dies kann nach der Veröffentlichung nicht geändert werden."
  },
  "socialExport.tiktok.disclosure.selectAtLeastOne": {
    "defaultMessage": "Sie müssen angeben, ob Ihr Inhalt Sie selbst, einen Dritten oder beides bewirbt."
  },
  "socialExport.tiktok.disclosure.selectAtLeastOneHint": {
    "defaultMessage": "Sie müssen angeben, ob Ihr Inhalt Sie selbst, einen Dritten oder beides bewirbt."
  },
  "socialExport.tiktok.disclosure.toggle": {
    "defaultMessage": "Videocontent offenlegen"
  },
  "socialExport.tiktok.disclosure.yourBrand.description": {
    "defaultMessage": "Sie bewerben sich selbst oder Ihr eigenes Unternehmen. Dieses Video wird als Brand Organic eingestuft."
  },
  "socialExport.tiktok.disclosure.yourBrand.label": {
    "defaultMessage": "Ihre Marke"
  },
  "socialExport.tiktok.privacy.followers": {
    "defaultMessage": "Follower"
  },
  "socialExport.tiktok.privacy.friends": {
    "defaultMessage": "Freunde"
  },
  "socialExport.tiktok.privacy.public": {
    "defaultMessage": "Öffentlich"
  },
  "socialExport.tiktok.privacy.self": {
    "defaultMessage": "Nur ich"
  },
  "socialExport.tiktok.settings.allowComment": {
    "defaultMessage": "Kommentieren"
  },
  "socialExport.tiktok.settings.allowDuet": {
    "defaultMessage": "Duett"
  },
  "socialExport.tiktok.settings.allowStitch": {
    "defaultMessage": "Stitch"
  },
  "socialExport.tiktok.settings.allowUsersTo": {
    "defaultMessage": "Benutzern erlauben "
  },
  "socialExport.tiktok.settings.disableComment": {
    "defaultMessage": "Kommentare deaktivieren"
  },
  "socialExport.tiktok.settings.disableDuet": {
    "defaultMessage": "Duette deaktivieren"
  },
  "socialExport.tiktok.settings.disableStitch": {
    "defaultMessage": "Stitch deaktivieren"
  },
  "socialExport.tiktok.settings.disabledByTiktokPrivacyTooltip": {
    "defaultMessage": "In den Privatsphäre-Einstellungen deines TikTok-Kontos deaktiviert."
  },
  "socialExport.tiktok.settings.privacyLabel": {
    "defaultMessage": "Datenschutz"
  },
  "socialExport.tiktok.settings.sectionTitle": {
    "defaultMessage": "Standardwerte für Uploads"
  },
  "socialExport.twitter.replyEveryone": {
    "defaultMessage": "Alle"
  },
  "socialExport.twitter.replyFollowing": {
    "defaultMessage": "Personen, denen Sie folgen"
  },
  "socialExport.twitter.replyMentioned": {
    "defaultMessage": "Erwähnte Benutzer"
  },
  "socialExport.twitter.replySubscribers": {
    "defaultMessage": "Abonnenten"
  },
  "socialExport.twitter.replyVerified": {
    "defaultMessage": "Verifiziert"
  },
  "socialExport.uploaded.columnFragment": {
    "defaultMessage": "Fragment"
  },
  "socialExport.uploaded.columnPublished": {
    "defaultMessage": "Veröffentlicht"
  },
  "socialExport.uploaded.columnStation": {
    "defaultMessage": "Sender"
  },
  "socialExport.uploaded.columnStatus": {
    "defaultMessage": "Status"
  },
  "socialExport.uploaded.linkLabel": {
    "defaultMessage": "Veröffentlichte Videos"
  },
  "socialExport.uploaded.title": {
    "defaultMessage": "Kürzlich veröffentlichte Videos"
  },
  "socialExport.validation.youtubeTitleForbiddenChars": {
    "defaultMessage": "Der Titel darf die Zeichen < oder > nicht enthalten"
  },
  "socialExport.youtube.category": {
    "defaultMessage": "Kategorie"
  },
  "socialExport.youtube.connect.advancedDescription": {
    "defaultMessage": "Playlists verwalten und Videos löschen"
  },
  "socialExport.youtube.connect.advancedName": {
    "defaultMessage": "Erweiterter Modus"
  },
  "socialExport.youtube.connect.advancedPermissions": {
    "defaultMessage": "Videos hochladen, zu Playlists hinzufügen und Videos löschen"
  },
  "socialExport.youtube.connect.basicDescription": {
    "defaultMessage": "Videos veröffentlichen ohne Playlists zu verwalten oder zu löschen"
  },
  "socialExport.youtube.connect.basicName": {
    "defaultMessage": "Basismodus"
  },
  "socialExport.youtube.connect.basicPermissions": {
    "defaultMessage": "Nur Videos hochladen"
  },
  "socialExport.youtube.connectAdvanced": {
    "defaultMessage": "Im erweiterten Modus verbinden"
  },
  "socialExport.youtube.connectAdvancedDescription": {
    "defaultMessage": "Ermöglicht das Hinzufügen von Videos zu Playlists und auch das Löschen."
  },
  "socialExport.youtube.connectBasic": {
    "defaultMessage": "Im Basismodus verbinden"
  },
  "socialExport.youtube.connectBasicDescription": {
    "defaultMessage": "Ermöglicht nur das Hochladen von Videos."
  },
  "socialExport.youtube.idealSize": {
    "defaultMessage": "Ideale Größe: 1280 x 720 px"
  },
  "socialExport.youtube.madeForKids": {
    "defaultMessage": "Für Kinder geeignete Inhalte"
  },
  "socialExport.youtube.playlist.helperText": {
    "defaultMessage": "Eine oder mehrere Wiedergabelisten auswählen"
  },
  "socialExport.youtube.playlist.label": {
    "defaultMessage": "Wiedergabelisten"
  },
  "socialExport.youtube.playlist.noManagePermissions": {
    "defaultMessage": "Die aktuelle Verbindung hat keine Berechtigungen zum Verwalten von Wiedergabelisten. Es muss eine erneute Verbindung hergestellt werden, um diese Berechtigungen zu erteilen."
  },
  "socialExport.youtube.playlist.noOptions": {
    "defaultMessage": "Keine Wiedergabelisten verfügbar"
  },
  "socialExport.youtube.playlist.notFound": {
    "defaultMessage": "Wiedergabeliste nicht gefunden?"
  },
  "socialExport.youtube.playlist.privacyStatus.private": {
    "defaultMessage": "Privat"
  },
  "socialExport.youtube.playlist.privacyStatus.public": {
    "defaultMessage": "Öffentlich"
  },
  "socialExport.youtube.playlist.privacyStatus.unlisted": {
    "defaultMessage": "Nicht gelistet"
  },
  "socialExport.youtube.playlist.refresh": {
    "defaultMessage": "Liste aktualisieren"
  },
  "socialExport.youtube.playlist.videoCount": {
    "defaultMessage": "{count, plural, one {# Video} other {# Videos}}"
  },
  "stationConfig.noPrompts": {
    "defaultMessage": "Keine Prompts registriert"
  },
  "stations.noVideoStations": {
    "defaultMessage": "Keine Video-Sender registriert"
  },
  "stations.selector.allStations": {
    "defaultMessage": "Alle Sender"
  },
  "stations.selector.favorites": {
    "defaultMessage": "Favoriten"
  },
  "stations.selector.myStations": {
    "defaultMessage": "Meine Sender"
  },
  "stations.selector.recent": {
    "defaultMessage": "Zuletzt verwendet"
  },
  "stations.selector.removeRecent": {
    "defaultMessage": "Aus Zuletzt verwendet entfernen"
  },
  "stations.selector.shared": {
    "defaultMessage": "Externe Sender"
  },
  "stations.selector.sharedGroup": {
    "defaultMessage": "{name}"
  },
  "streamBox.device.coords": {
    "defaultMessage": "(Lat. {lat}, Long. {lng})"
  },
  "streamBox.listScreen.count": {
    "defaultMessage": "{count, plural, one {1 Gerät gefunden} other {# Geräte gefunden} }"
  },
  "streamBox.listScreen.loading": {
    "defaultMessage": "Geräte werden geladen"
  },
  "streamBox.listScreen.manageBtn": {
    "defaultMessage": "Gerät verwalten"
  },
  "streamBox.listScreen.noDevices": {
    "defaultMessage": "Keine Geräte gefunden"
  },
  "streamBox.listScreen.title": {
    "defaultMessage": "StreamBox-Geräte"
  },
  "streamBox.nav.title": {
    "defaultMessage": "Stream Box"
  },
  "streamBox.props.device": {
    "defaultMessage": "Gerät"
  },
  "streamBox.props.id": {
    "defaultMessage": "ID"
  },
  "streamBox.props.location": {
    "defaultMessage": "Standort"
  },
  "streamBox.props.service": {
    "defaultMessage": "Dienst"
  },
  "streamBox.props.services": {
    "defaultMessage": "Dienste"
  },
  "streamBox.props.status": {
    "defaultMessage": "Status"
  },
  "streamBox.viewScreen.actions.reboot.btn": {
    "defaultMessage": "Neustart"
  },
  "streamBox.viewScreen.actions.reboot.confirm": {
    "defaultMessage": "Möchten Sie das Gerät wirklich neu starten?"
  },
  "streamBox.viewScreen.actions.reboot.done": {
    "defaultMessage": "Gerät-Neustart angefordert"
  },
  "streamBox.viewScreen.actions.rename.btn": {
    "defaultMessage": "Umbenennen"
  },
  "streamBox.viewScreen.actions.rename.done": {
    "defaultMessage": "Gerät umbenannt"
  },
  "streamBox.viewScreen.actions.rename.label": {
    "defaultMessage": "Neuer Name"
  },
  "streamBox.viewScreen.actions.rename.title": {
    "defaultMessage": "Gerät umbenennen"
  },
  "streamBox.viewScreen.actions.setCoords.button": {
    "defaultMessage": "Koordinaten festlegen"
  },
  "streamBox.viewScreen.actions.setCoords.done": {
    "defaultMessage": "Koordinaten aktualisiert"
  },
  "streamBox.viewScreen.actions.setCoords.latitude": {
    "defaultMessage": "Breitengrad"
  },
  "streamBox.viewScreen.actions.setCoords.longitude": {
    "defaultMessage": "Längengrad"
  },
  "streamBox.viewScreen.actions.setCoords.title": {
    "defaultMessage": "Koordinaten setzen"
  },
  "streamBox.viewScreen.clickLocation": {
    "defaultMessage": "Klicken, um Standort auf der Karte anzuzeigen"
  },
  "streamBox.viewScreen.loading": {
    "defaultMessage": "Gerät wird geladen"
  },
  "streamBox.viewScreen.services.actions.config.btn": {
    "defaultMessage": "Konfiguration"
  },
  "streamBox.viewScreen.services.actions.config.title": {
    "defaultMessage": "Dienst konfigurieren"
  },
  "streamBox.viewScreen.services.actions.restart.btn": {
    "defaultMessage": "Neustart"
  },
  "streamBox.viewScreen.services.actions.restart.done": {
    "defaultMessage": "Dienst-Neustart angefordert"
  },
  "streamBox.viewScreen.services.actions.restart.error": {
    "defaultMessage": "Dienst konnte nicht neu gestartet werden"
  },
  "streamBox.viewScreen.services.actions.restart.prompt": {
    "defaultMessage": "Möchten Sie den Dienst wirklich neu starten?"
  },
  "streamBox.viewScreen.services.actions.start.btn": {
    "defaultMessage": "Starten"
  },
  "streamBox.viewScreen.services.actions.start.done": {
    "defaultMessage": "Dienst-Start angefordert"
  },
  "streamBox.viewScreen.services.actions.start.error": {
    "defaultMessage": "Dienst konnte nicht gestartet werden"
  },
  "streamBox.viewScreen.services.actions.start.prompt": {
    "defaultMessage": "Möchten Sie den Dienst wirklich starten?"
  },
  "streamBox.viewScreen.services.actions.stop.btn": {
    "defaultMessage": "Stopp"
  },
  "streamBox.viewScreen.services.actions.stop.done": {
    "defaultMessage": "Dienst-Stopp angefordert"
  },
  "streamBox.viewScreen.services.actions.stop.error": {
    "defaultMessage": "Dienst konnte nicht gestoppt werden"
  },
  "streamBox.viewScreen.services.actions.stop.prompt": {
    "defaultMessage": "Möchten Sie den Dienst wirklich stoppen?"
  },
  "streamBox.viewScreen.services.config.done": {
    "defaultMessage": "Dienstkonfiguration aktualisiert"
  },
  "streamBox.viewScreen.services.config.error": {
    "defaultMessage": "Dienstkonfiguration konnte nicht aktualisiert werden"
  },
  "streamBox.viewScreen.services.config.noVars": {
    "defaultMessage": "Für diesen Dienst sind keine Variablen verfügbar"
  },
  "streamBox.viewScreen.title": {
    "defaultMessage": "Gerät {deviceName} / StreamBox"
  },
  "tagGroups.defaultGroup": {
    "defaultMessage": "Standardgruppe"
  },
  "tagGroups.groupName": {
    "defaultMessage": "Gruppenname"
  },
  "tagGroups.tags": {
    "defaultMessage": "Tags"
  },
  "tagGroups.tagsPlaceholder": {
    "defaultMessage": "Tippen und Enter/Komma zum Hinzufügen von Tags drücken"
  },
  "tours.driver.done": {
    "defaultMessage": "Fertig"
  },
  "tours.driver.new": {
    "defaultMessage": "Neu"
  },
  "tours.driver.next": {
    "defaultMessage": "Weiter"
  },
  "tours.driver.previous": {
    "defaultMessage": "Zurück"
  },
  "tours.driver.progress": {
    "defaultMessage": "{current} von {total}"
  },
  "ui.copyUrlButton.copyLink": {
    "defaultMessage": "Link zum Teilen kopieren"
  },
  "ui.stationsFilter.label": {
    "defaultMessage": "Sender filtern"
  },
  "ui.stationsFilter.optionType.long.individualStation": {
    "defaultMessage": "Einzelsender"
  },
  "ui.stationsFilter.optionType.long.stationGroup": {
    "defaultMessage": "Sendergruppe"
  },
  "ui.stationsFilter.optionType.long.stationType": {
    "defaultMessage": "Sendertyp"
  },
  "ui.stationsFilter.optionType.short.individualStation": {
    "defaultMessage": "Sender"
  },
  "ui.stationsFilter.optionType.short.stationGroup": {
    "defaultMessage": "Gruppe"
  },
  "ui.stationsFilter.optionType.short.stationType": {
    "defaultMessage": "Typ"
  },
  "ui.stationsFilter.placeholder": {
    "defaultMessage": "Sender, Gruppe oder Typ wählen..."
  },
  "ui.stationsSelector.enterToGo": {
    "defaultMessage": "Eingabe zum Öffnen"
  },
  "ui.stationsSelector.searchPlaceholder": {
    "defaultMessage": "Sender suchen"
  },
  "ui.versionChecker.appUpToDate": {
    "defaultMessage": "App ist aktuell ({version})"
  },
  "ui.versionChecker.newVersionAvailable": {
    "defaultMessage": "Eine neue App-Version ist verfügbar"
  },
  "ui.versionChecker.newVersionAvailableExpand": {
    "defaultMessage": "Neue Version verfügbar, klicken zum Erweitern"
  },
  "ui.versionChecker.newVersionAvailableReload": {
    "defaultMessage": "Neue Version verfügbar, klicken zum Aktualisieren"
  },
  "ui.versionChecker.update": {
    "defaultMessage": "Aktualisieren"
  },
  "userPermission.inheritsFromGroup": {
    "defaultMessage": "Erbt von Gruppe"
  },
  "users.chipList.unknownUser": {
    "defaultMessage": "Unbekannter Benutzer"
  },
  "validateUpload.fileLabel": {
    "defaultMessage": "File:"
  },
  "validateUpload.itemsCreated": {
    "defaultMessage": "{count} items created"
  },
  "validateUpload.process": {
    "defaultMessage": "Process"
  },
  "validateUpload.processNewFile": {
    "defaultMessage": "Process new file"
  },
  "validateUpload.tryAgain": {
    "defaultMessage": "Erneut versuchen"
  },
  "validateUpload.verifyError": {
    "defaultMessage": "Beim Überprüfen der Datei ist ein Fehler aufgetreten"
  },
  "validation.maxValue60000": {
    "defaultMessage": "Muss kleiner oder gleich 60000 sein"
  },
  "validation.minValueZero": {
    "defaultMessage": "Muss größer oder gleich 0 sein"
  },
  "videoEditions.autoEditName": {
    "defaultMessage": "Edit {n}"
  },
  "videoEditions.category.draftChip": {
    "defaultMessage": "Entwürfe & in Arbeit ({count})"
  },
  "videoEditions.category.generatedChip": {
    "defaultMessage": "Generiert ({count})"
  },
  "videoEditions.clone": {
    "defaultMessage": "Edit klonen"
  },
  "videoEditions.cloneDialog.nameLabel": {
    "defaultMessage": "Name"
  },
  "videoEditions.cloneDialog.submit": {
    "defaultMessage": "Klonen"
  },
  "videoEditions.cloneDialog.title": {
    "defaultMessage": "Edit klonen"
  },
  "videoEditions.createEdit": {
    "defaultMessage": "Edit erstellen"
  },
  "videoEditions.deleteConfirm": {
    "defaultMessage": "Dieses Edit löschen? Diese Aktion kann nicht rückgängig gemacht werden."
  },
  "videoEditions.editCard.publishedOn": {
    "defaultMessage": "Veröffentlicht auf"
  },
  "videoEditions.emptyDraftTab": {
    "defaultMessage": "In diesem Bereich gibt es keine Entwürfe oder laufenden Renderings"
  },
  "videoEditions.emptyGeneratedTab": {
    "defaultMessage": "Noch keine generierten Videos"
  },
  "videoEditions.emptyHelp": {
    "defaultMessage": "Noch keine edits"
  },
  "videoEditions.finishedOn": {
    "defaultMessage": "Generiert"
  },
  "videoEditions.goToEditor": {
    "defaultMessage": "Zum Editor gehen"
  },
  "videoEditions.openInEditor": {
    "defaultMessage": "Im Editor öffnen"
  },
  "videoEditions.status.generated": {
    "defaultMessage": "Bereit zur Veröffentlichung"
  },
  "videoEditions.status.notGenerated": {
    "defaultMessage": "Nicht generiert"
  },
  "videoEditions.tabTitle": {
    "defaultMessage": "edits"
  },
  "videoEditions.title": {
    "defaultMessage": "edits"
  },
  "videoEditions.updatedAt": {
    "defaultMessage": "Aktualisiert"
  },
  "youtube.cuepoints.column.createdAt": {
    "defaultMessage": "Datum/Uhrzeit der Einfügung"
  },
  "youtube.cuepoints.column.cuepointId": {
    "defaultMessage": "Cuepoint-ID"
  },
  "youtube.cuepoints.column.videoId": {
    "defaultMessage": "Video-ID"
  },
  "youtube.cuepoints.filter.targetDate": {
    "defaultMessage": "Zieldatum"
  },
  "youtube.cuepoints.insert.button": {
    "defaultMessage": "Cuepoint einfügen"
  },
  "youtube.cuepoints.insert.dialogTitle": {
    "defaultMessage": "Cuepoint manuell einfügen"
  },
  "youtube.cuepoints.insert.durationHelper": {
    "defaultMessage": "Zwischen 1 und 300 Sekunden"
  },
  "youtube.cuepoints.insert.durationLabel": {
    "defaultMessage": "Dauer (Sekunden)"
  },
  "youtube.cuepoints.insert.durationMax": {
    "defaultMessage": "Maximaldauer beträgt 300 Sekunden"
  },
  "youtube.cuepoints.insert.durationMin": {
    "defaultMessage": "Mindestdauer beträgt 1 Sekunde"
  },
  "youtube.cuepoints.insert.durationRequired": {
    "defaultMessage": "Dauer ist erforderlich"
  },
  "youtube.cuepoints.insert.error": {
    "defaultMessage": "Cuepoint konnte nicht eingefügt werden"
  },
  "youtube.cuepoints.insert.submit": {
    "defaultMessage": "Einfügen"
  },
  "youtube.cuepoints.insert.success": {
    "defaultMessage": "Cuepoint erfolgreich eingefügt"
  },
  "youtube.cuepoints.manageCuepoints": {
    "defaultMessage": "Registrierte Cuepoints anzeigen"
  },
  "youtube.cuepoints.manageCuepointsAlertTitle": {
    "defaultMessage": "YouTube-Cuepoints"
  },
  "youtube.cuepoints.pageTitle": {
    "defaultMessage": "Cuepoints"
  },
  "youtube.privacyStatus.label": {
    "defaultMessage": "Privatsphäre-Status"
  },
  "youtube.privacyStatus.private": {
    "defaultMessage": "Privat"
  },
  "youtube.privacyStatus.public": {
    "defaultMessage": "Öffentlich"
  },
  "youtube.privacyStatus.unlisted": {
    "defaultMessage": "Nicht gelistet"
  }
}
